import { openBlock as R, createElementBlock as Y, renderSlot as le, defineComponent as ne, toRef as Dr, computed as T, ref as $e, shallowRef as Vi, onMounted as xn, watch as Kn, createBlock as z, resolveDynamicComponent as Is, normalizeStyle as zi, withCtx as oe, normalizeProps as Ps, guardReactiveProps as Rs, normalizeClass as Pt, createElementVNode as U, toDisplayString as Le, createCommentVNode as te, Fragment as Ut, unref as Me, createStaticVNode as As, renderList as lr, readonly as Hi, getCurrentInstance as Wi, nextTick as Yi, mergeProps as me, createTextVNode as dr, resolveComponent as Ki, createVNode as be, reactive as Tn, createSlots as Gi } from "vue";
import { createClient as Ji } from "@sanity/client";
import { cloneDeep as js, isEqual as Ds } from "lodash";
import st from "mustache";
const Te = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, s] of t)
    n[r] = s;
  return n;
}, Zi = {}, Xi = { class: "base-list" };
function Qi(e, t) {
  return R(), Y("div", Xi, [
    le(e.$slots, "default", {}, void 0, !0)
  ]);
}
const Lh = /* @__PURE__ */ Te(Zi, [["render", Qi], ["__scopeId", "data-v-95ef8457"]]), ea = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M10%2017.3433L15.3433%2012L10%206.65674'%20stroke='%231D1D1D'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", ta = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M6.65625%2010L11.9995%2015.3433L17.3428%2010'%20stroke='%231D1D1D'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", na = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M17.3438%2014L12.0005%208.65674L6.65723%2014'%20stroke='%231D1D1D'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", Ls = "--vc-auto-duration", ra = `height var(${Ls}) cubic-bezier(0.33, 1, 0.68, 1)`, Zt = { padding: 0 }, sa = 300, oa = {
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: "0",
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  border: "0"
}, ia = () => typeof navigator < "u" && navigator.userAgent.includes("Firefox");
function Lr(e) {
  return e.value ? parseFloat(getComputedStyle(e.value).height) : 0;
}
function Mr(e) {
  var t;
  return {
    height: `${((t = e.value) == null ? void 0 : t.scrollHeight) || 0}px`
  };
}
function Nr(e) {
  if (!e.value)
    return {};
  const { transition: t } = getComputedStyle(e.value);
  return t === "all 0s ease 0s" || ia() && t === "all" ? { transition: ra } : { transition: t };
}
function Ur(e) {
  if (!e.value)
    return !0;
  const { transition: t } = getComputedStyle(e.value);
  return typeof window.requestAnimationFrame > "u" || window.matchMedia("(prefers-reduced-motion: reduce)").matches || t.includes("none") || t.includes("height 0s");
}
function aa(e = 0) {
  if (e === 0)
    return 0;
  const t = e / 36, n = Math.round((4 + 15 * t ** 0.25 + t / 5) * 10);
  return Number.isFinite(n) ? n : 0;
}
const ca = /* @__PURE__ */ ne({
  inheritAttrs: !0,
  __name: "Collapse",
  props: {
    when: { type: Boolean },
    baseHeight: { default: 0 },
    as: { default: "div" }
  },
  emits: ["collapse", "expand", "collapsed", "expanded"],
  setup(e, { emit: t }) {
    const n = e, r = t, s = Dr(n, "when"), o = Dr(n, "baseHeight"), i = T(() => ({ overflow: "hidden", height: `${o.value}px` })), a = T(() => ({
      ...Zt,
      ...o.value === 0 ? { display: "none" } : i.value
    })), u = $e(null), c = $e(s.value ? "expanded" : "collapsed"), l = (I) => c.value = I;
    function d() {
      return s.value ? Zt : o.value === 0 ? oa : a.value;
    }
    const g = Vi(d()), m = (I) => g.value = I, b = (I) => m({ ...g.value, ...I }), f = $e(sa), S = (I) => f.value = I, $ = T(() => ({ [Ls]: `${f.value}ms` }));
    function E() {
      m(Zt), l("expanded"), r("expanded");
    }
    function j() {
      m(a.value), l("collapsed"), r("collapsed");
    }
    xn(() => {
      if (!u.value)
        return;
      const I = aa(u.value.scrollHeight - o.value);
      I > 0 && S(I), !s.value && o.value === 0 && m(a.value);
    }), Kn(s, (I) => {
      if (u.value)
        if (I) {
          if (Ur(u))
            return E();
          l("expanding"), r("expand"), m({
            ...Zt,
            ...i.value,
            ...$.value
          }), requestAnimationFrame(() => {
            if (u.value.scrollHeight === 0)
              return E();
            b({
              ...Mr(u),
              ...Nr(u),
              willChange: "height"
            });
          });
        } else {
          if (Ur(u) || (l("collapsing"), r("collapse"), b({
            ...$.value,
            ...Mr(u)
          }), u.value.scrollHeight === 0))
            return j();
          requestAnimationFrame(() => {
            b({
              ...i.value,
              ...Nr(u),
              willChange: "height"
            });
          });
        }
    }), Kn(o, (I) => {
      s.value || (I > 0 ? b({ display: void 0, height: `${I}px` }) : b({ display: "none" }));
    });
    function D(I) {
      I.target && I.target === u.value && I.propertyName === "height" && (s.value ? Math.abs(u.value.scrollHeight - Lr(u)) < 1 && E() : Math.abs(o.value - Lr(u)) < 1 && j());
    }
    return (I, M) => (R(), z(Is(n.as), {
      ref_key: "collapseRef",
      ref: u,
      style: zi(g.value),
      onTransitionend: D,
      "data-collapse": c.value
    }, {
      default: oe(() => [
        le(I.$slots, "default", Ps(Rs({ state: c.value })))
      ]),
      _: 3
    }, 40, ["style", "data-collapse"]));
  }
}), ua = ["id"], la = { class: "base-list-item__left-content" }, da = { class: "base-list-item__left-content-text" }, pa = {
  key: 0,
  class: "base-list-item__tertiary-text",
  "data-testid": "tertiaryText"
}, fa = {
  "data-testid": "headline",
  class: "base-list-item__headline"
}, ha = { class: "base-list-item__right-content" }, ma = {
  key: 0,
  class: "base-list-item__widgets"
}, ga = {
  key: 1,
  class: "base-list-item__trailing-icon"
}, va = /* @__PURE__ */ ne({
  __name: "BaseListItem",
  props: {
    headline: {},
    tertiaryText: { default: "" },
    secondaryText: { default: "" },
    interaction: { default: "" },
    collapsed: { type: Boolean, default: !1 },
    listItemId: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    shadow: { type: Boolean, default: !0 },
    bordered: { type: Boolean, default: !1 },
    bgColor: { default: "" },
    truncateSecondaryText: { type: Boolean, default: !1 },
    animateCollapse: { type: Boolean, default: !1 }
  },
  emits: ["clicked"],
  setup(e, { emit: t }) {
    const n = e, r = t, s = T(() => {
      const c = [];
      return n.shadow && c.push("base-list-item--shadow"), n.disabled && c.push("base-list-item--disabled"), n.bordered && c.push("base-list-item--bordered"), c.push(`base-list-item--bg-${n.bgColor}`), c;
    }), o = T(() => n.interaction !== "collapsible" ? !1 : n.animateCollapse ? !0 : !n.collapsed), i = T(() => n.interaction ? ["base-list-item__header--clickable"] : []), a = T(() => n.truncateSecondaryText ? ["base-list-item__secondary-text--truncate"] : []), u = () => {
      n.interaction && r("clicked");
    };
    return (c, l) => {
      var d;
      return R(), Y("div", {
        id: (d = c.listItemId) == null ? void 0 : d.toString(),
        class: Pt(["base-list-item", s.value])
      }, [
        U("div", {
          "data-testid": "header",
          class: Pt(["base-list-item__header", i.value]),
          onClick: u
        }, [
          U("div", la, [
            le(c.$slots, "leadingVisual", { dataTestid: "leadingVisual" }, void 0, !0),
            U("div", da, [
              c.tertiaryText ? (R(), Y("div", pa, Le(c.tertiaryText), 1)) : te("", !0),
              U("div", fa, Le(c.headline), 1),
              c.secondaryText ? (R(), Y("div", {
                key: 1,
                class: Pt(["base-list-item__secondary-text", a.value]),
                "data-testid": "secondaryText"
              }, Le(c.secondaryText), 3)) : te("", !0)
            ])
          ]),
          U("div", ha, [
            c.$slots.widgets ? (R(), Y("div", ma, [
              le(c.$slots, "widgets", {}, void 0, !0)
            ])) : te("", !0),
            c.interaction === "clickable" || c.interaction === "collapsible" ? (R(), Y("div", ga, [
              c.interaction === "clickable" ? le(c.$slots, "clickVisual", { key: 0 }, () => [
                l[0] || (l[0] = U("img", {
                  src: ea,
                  alt: "Arrow right"
                }, null, -1))
              ], !0) : c.interaction === "collapsible" ? (R(), Y(Ut, { key: 1 }, [
                c.collapsed ? le(c.$slots, "expandVisual", { key: 0 }, () => [
                  l[1] || (l[1] = U("img", {
                    src: ta,
                    alt: "Arrow down"
                  }, null, -1))
                ], !0) : le(c.$slots, "collapseVisual", { key: 1 }, () => [
                  l[2] || (l[2] = U("img", {
                    src: na,
                    alt: "Arrow up"
                  }, null, -1))
                ], !0)
              ], 64)) : te("", !0)
            ])) : te("", !0)
          ])
        ], 2),
        o.value ? (R(), z(Is(c.animateCollapse ? Me(ca) : "div"), {
          key: 0,
          when: !c.collapsed
        }, {
          default: oe(() => [
            le(c.$slots, "collapseContent", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["when"])) : te("", !0)
      ], 10, ua);
    };
  }
}), pr = /* @__PURE__ */ Te(va, [["__scopeId", "data-v-d5e6b252"]]);
var Ms = /* @__PURE__ */ ((e) => (e.Draft = "Draft", e.PriceRequested = "PriceRequested", e.InformationRequested = "InformationRequested", e.Offered = "Offered", e))(Ms || {}), Q = /* @__PURE__ */ ((e) => (e.Offered = "Offered", e.Accepted = "Accepted", e.Completed = "Completed", e.Rejected = "Rejected", e.PriceRequested = "PriceRequested", e.InformationRequested = "InformationRequested", e.Lost = "Lost", e.Unanswered = "Unanswered", e.Interested = "Interested", e))(Q || {}), Rt = /* @__PURE__ */ ((e) => (e.Monthly = "Monthly", e.Yearly = "Yearly", e.Fixed = "Fixed", e))(Rt || {}), Ns = /* @__PURE__ */ ((e) => (e.Draft = "Draft", e.Offered = "Offered", e.Accepted = "Accepted", e.Completed = "Completed", e.Rejected = "Rejected", e.PriceRequested = "PriceRequested", e.InformationRequested = "InformationRequested", e.Withdrawn = "Withdrawn", e))(Ns || {}), vn = /* @__PURE__ */ ((e) => (e.Single = "Single", e.Repeating = "Repeating", e.Unknown = "Unknown", e))(vn || {}), Us = /* @__PURE__ */ ((e) => (e.Supplier = "Supplier", e.Customer = "Customer", e))(Us || {}), $n = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function fr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var qs = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })($n, function() {
    function n() {
      return n = Object.assign || function(h) {
        for (var y = 1; y < arguments.length; y++) {
          var p = arguments[y];
          for (var v in p)
            Object.prototype.hasOwnProperty.call(p, v) && (h[v] = p[v]);
        }
        return h;
      }, n.apply(this, arguments);
    }
    function r(h, y) {
      if (h) {
        if (typeof h == "string")
          return s(h, y);
        var p = Object.prototype.toString.call(h).slice(8, -1);
        if (p === "Object" && h.constructor && (p = h.constructor.name), p === "Map" || p === "Set")
          return Array.from(h);
        if (p === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(p))
          return s(h, y);
      }
    }
    function s(h, y) {
      (y == null || y > h.length) && (y = h.length);
      for (var p = 0, v = new Array(y); p < y; p++)
        v[p] = h[p];
      return v;
    }
    function o(h, y) {
      var p = typeof Symbol < "u" && h[Symbol.iterator] || h["@@iterator"];
      if (p)
        return (p = p.call(h)).next.bind(p);
      if (Array.isArray(h) || (p = r(h)) || y && h && typeof h.length == "number") {
        p && (h = p);
        var v = 0;
        return function() {
          return v >= h.length ? {
            done: !0
          } : {
            done: !1,
            value: h[v++]
          };
        };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var i = "image-Tb9Ew8CXIwaY6R1kjMvI0uRR-2000x3000-jpg";
    function a(h) {
      var y = h.split("-"), p = y[1], v = y[2], _ = y[3];
      if (!p || !v || !_)
        throw new Error("Malformed asset _ref '" + h + `'. Expected an id like "` + i + '".');
      var w = v.split("x"), x = w[0], O = w[1], A = +x, P = +O, L = isFinite(A) && isFinite(P);
      if (!L)
        throw new Error("Malformed asset _ref '" + h + `'. Expected an id like "` + i + '".');
      return {
        id: p,
        width: A,
        height: P,
        format: _
      };
    }
    var u = function(y) {
      var p = y;
      return p ? typeof p._ref == "string" : !1;
    }, c = function(y) {
      var p = y;
      return p ? typeof p._id == "string" : !1;
    }, l = function(y) {
      var p = y;
      return p && p.asset ? typeof p.asset.url == "string" : !1;
    };
    function d(h) {
      if (!h)
        return null;
      var y;
      if (typeof h == "string" && g(h))
        y = {
          asset: {
            _ref: m(h)
          }
        };
      else if (typeof h == "string")
        y = {
          asset: {
            _ref: h
          }
        };
      else if (u(h))
        y = {
          asset: h
        };
      else if (c(h))
        y = {
          asset: {
            _ref: h._id || ""
          }
        };
      else if (l(h))
        y = {
          asset: {
            _ref: m(h.asset.url)
          }
        };
      else if (typeof h.asset == "object")
        y = n({}, h);
      else
        return null;
      var p = h;
      return p.crop && (y.crop = p.crop), p.hotspot && (y.hotspot = p.hotspot), b(y);
    }
    function g(h) {
      return /^https?:\/\//.test("" + h);
    }
    function m(h) {
      var y = h.split("/").slice(-1);
      return ("image-" + y[0]).replace(/\.([a-z]+)$/, "-$1");
    }
    function b(h) {
      if (h.crop && h.hotspot)
        return h;
      var y = n({}, h);
      return y.crop || (y.crop = {
        left: 0,
        top: 0,
        bottom: 0,
        right: 0
      }), y.hotspot || (y.hotspot = {
        x: 0.5,
        y: 0.5,
        height: 1,
        width: 1
      }), y;
    }
    var f = [["width", "w"], ["height", "h"], ["format", "fm"], ["download", "dl"], ["blur", "blur"], ["sharpen", "sharp"], ["invert", "invert"], ["orientation", "or"], ["minHeight", "min-h"], ["maxHeight", "max-h"], ["minWidth", "min-w"], ["maxWidth", "max-w"], ["quality", "q"], ["fit", "fit"], ["crop", "crop"], ["saturation", "sat"], ["auto", "auto"], ["dpr", "dpr"], ["pad", "pad"]];
    function S(h) {
      var y = n({}, h || {}), p = y.source;
      delete y.source;
      var v = d(p);
      if (!v)
        throw new Error("Unable to resolve image URL from source (" + JSON.stringify(p) + ")");
      var _ = v.asset._ref || v.asset._id || "", w = a(_), x = Math.round(v.crop.left * w.width), O = Math.round(v.crop.top * w.height), A = {
        left: x,
        top: O,
        width: Math.round(w.width - v.crop.right * w.width - x),
        height: Math.round(w.height - v.crop.bottom * w.height - O)
      }, P = v.hotspot.height * w.height / 2, L = v.hotspot.width * w.width / 2, F = v.hotspot.x * w.width, W = v.hotspot.y * w.height, B = {
        left: F - L,
        top: W - P,
        right: F + L,
        bottom: W + P
      };
      return y.rect || y.focalPoint || y.ignoreImageParams || y.crop || (y = n({}, y, E({
        crop: A,
        hotspot: B
      }, y))), $(n({}, y, {
        asset: w
      }));
    }
    function $(h) {
      var y = (h.baseUrl || "https://cdn.sanity.io").replace(/\/+$/, ""), p = h.asset.id + "-" + h.asset.width + "x" + h.asset.height + "." + h.asset.format, v = y + "/images/" + h.projectId + "/" + h.dataset + "/" + p, _ = [];
      if (h.rect) {
        var w = h.rect, x = w.left, O = w.top, A = w.width, P = w.height, L = x !== 0 || O !== 0 || P !== h.asset.height || A !== h.asset.width;
        L && _.push("rect=" + x + "," + O + "," + A + "," + P);
      }
      h.bg && _.push("bg=" + h.bg), h.focalPoint && (_.push("fp-x=" + h.focalPoint.x), _.push("fp-y=" + h.focalPoint.y));
      var F = [h.flipHorizontal && "h", h.flipVertical && "v"].filter(Boolean).join("");
      return F && _.push("flip=" + F), f.forEach(function(W) {
        var B = W[0], ee = W[1];
        typeof h[B] < "u" ? _.push(ee + "=" + encodeURIComponent(h[B])) : typeof h[ee] < "u" && _.push(ee + "=" + encodeURIComponent(h[ee]));
      }), _.length === 0 ? v : v + "?" + _.join("&");
    }
    function E(h, y) {
      var p, v = y.width, _ = y.height;
      if (!(v && _))
        return {
          width: v,
          height: _,
          rect: h.crop
        };
      var w = h.crop, x = h.hotspot, O = v / _, A = w.width / w.height;
      if (A > O) {
        var P = Math.round(w.height), L = Math.round(P * O), F = Math.max(0, Math.round(w.top)), W = Math.round((x.right - x.left) / 2 + x.left), B = Math.max(0, Math.round(W - L / 2));
        B < w.left ? B = w.left : B + L > w.left + w.width && (B = w.left + w.width - L), p = {
          left: B,
          top: F,
          width: L,
          height: P
        };
      } else {
        var ee = w.width, se = Math.round(ee / O), Se = Math.max(0, Math.round(w.left)), ke = Math.round((x.bottom - x.top) / 2 + x.top), ae = Math.max(0, Math.round(ke - se / 2));
        ae < w.top ? ae = w.top : ae + se > w.top + w.height && (ae = w.top + w.height - se), p = {
          left: Se,
          top: ae,
          width: ee,
          height: se
        };
      }
      return {
        width: v,
        height: _,
        rect: p
      };
    }
    var j = ["clip", "crop", "fill", "fillmax", "max", "scale", "min"], D = ["top", "bottom", "left", "right", "center", "focalpoint", "entropy"], I = ["format"];
    function M(h) {
      return h && "config" in h ? typeof h.config == "function" : !1;
    }
    function K(h) {
      return h && "clientConfig" in h ? typeof h.clientConfig == "object" : !1;
    }
    function J(h) {
      for (var y = f, p = o(y), v; !(v = p()).done; ) {
        var _ = v.value, w = _[0], x = _[1];
        if (h === w || h === x)
          return w;
      }
      return h;
    }
    function q(h) {
      if (M(h)) {
        var y = h.config(), p = y.apiHost, v = y.projectId, _ = y.dataset, w = p || "https://api.sanity.io";
        return new N(null, {
          baseUrl: w.replace(/^https:\/\/api\./, "https://cdn."),
          projectId: v,
          dataset: _
        });
      }
      var x = h;
      if (K(x)) {
        var O = x.clientConfig, A = O.apiHost, P = O.projectId, L = O.dataset, F = A || "https://api.sanity.io";
        return new N(null, {
          baseUrl: F.replace(/^https:\/\/api\./, "https://cdn."),
          projectId: P,
          dataset: L
        });
      }
      return new N(null, h);
    }
    var N = /* @__PURE__ */ function() {
      function h(p, v) {
        this.options = void 0, this.options = p ? n({}, p.options || {}, v || {}) : n({}, v || {});
      }
      var y = h.prototype;
      return y.withOptions = function(v) {
        var _ = v.baseUrl || this.options.baseUrl, w = {
          baseUrl: _
        };
        for (var x in v)
          if (v.hasOwnProperty(x)) {
            var O = J(x);
            w[O] = v[x];
          }
        return new h(this, n({
          baseUrl: _
        }, w));
      }, y.image = function(v) {
        return this.withOptions({
          source: v
        });
      }, y.dataset = function(v) {
        return this.withOptions({
          dataset: v
        });
      }, y.projectId = function(v) {
        return this.withOptions({
          projectId: v
        });
      }, y.bg = function(v) {
        return this.withOptions({
          bg: v
        });
      }, y.dpr = function(v) {
        return this.withOptions(v && v !== 1 ? {
          dpr: v
        } : {});
      }, y.width = function(v) {
        return this.withOptions({
          width: v
        });
      }, y.height = function(v) {
        return this.withOptions({
          height: v
        });
      }, y.focalPoint = function(v, _) {
        return this.withOptions({
          focalPoint: {
            x: v,
            y: _
          }
        });
      }, y.maxWidth = function(v) {
        return this.withOptions({
          maxWidth: v
        });
      }, y.minWidth = function(v) {
        return this.withOptions({
          minWidth: v
        });
      }, y.maxHeight = function(v) {
        return this.withOptions({
          maxHeight: v
        });
      }, y.minHeight = function(v) {
        return this.withOptions({
          minHeight: v
        });
      }, y.size = function(v, _) {
        return this.withOptions({
          width: v,
          height: _
        });
      }, y.blur = function(v) {
        return this.withOptions({
          blur: v
        });
      }, y.sharpen = function(v) {
        return this.withOptions({
          sharpen: v
        });
      }, y.rect = function(v, _, w, x) {
        return this.withOptions({
          rect: {
            left: v,
            top: _,
            width: w,
            height: x
          }
        });
      }, y.format = function(v) {
        return this.withOptions({
          format: v
        });
      }, y.invert = function(v) {
        return this.withOptions({
          invert: v
        });
      }, y.orientation = function(v) {
        return this.withOptions({
          orientation: v
        });
      }, y.quality = function(v) {
        return this.withOptions({
          quality: v
        });
      }, y.forceDownload = function(v) {
        return this.withOptions({
          download: v
        });
      }, y.flipHorizontal = function() {
        return this.withOptions({
          flipHorizontal: !0
        });
      }, y.flipVertical = function() {
        return this.withOptions({
          flipVertical: !0
        });
      }, y.ignoreImageParams = function() {
        return this.withOptions({
          ignoreImageParams: !0
        });
      }, y.fit = function(v) {
        if (j.indexOf(v) === -1)
          throw new Error('Invalid fit mode "' + v + '"');
        return this.withOptions({
          fit: v
        });
      }, y.crop = function(v) {
        if (D.indexOf(v) === -1)
          throw new Error('Invalid crop mode "' + v + '"');
        return this.withOptions({
          crop: v
        });
      }, y.saturation = function(v) {
        return this.withOptions({
          saturation: v
        });
      }, y.auto = function(v) {
        if (I.indexOf(v) === -1)
          throw new Error('Invalid auto mode "' + v + '"');
        return this.withOptions({
          auto: v
        });
      }, y.pad = function(v) {
        return this.withOptions({
          pad: v
        });
      }, y.url = function() {
        return S(this.options);
      }, y.toString = function() {
        return this.url();
      }, h;
    }();
    return q;
  });
})(qs);
var ya = qs.exports;
const ba = /* @__PURE__ */ fr(ya), Fs = Ji({
  projectId: "0ls0csm4",
  dataset: "production",
  token: "skF3I3GTefhnWc6ta4QSMIwXiCUlQ1DHc2UuHfSoL22XgPVAnI6SX0e3Sxh5lLw7EnaIM4RHkd4w0ihgdtI7LFv7bNVF9sYS2PYeH87oQZitkj1M26Yl5mBHNV3YSYrTKxki5Ni2ABxP8mI3QSWc9u1tUCY4o43vbvZ5U4q2T8Qje5BXKeV3",
  useCdn: !1,
  ignoreBrowserTokenWarning: !0,
  apiVersion: "2020-01-01"
}), wa = ba(Fs), _a = async (e, t = {}) => {
  try {
    return await Fs.fetch(e, t);
  } catch (n) {
    throw console.log("Error fetching cms: ", n), n;
  }
}, Sa = (e) => wa.image(e), Bs = {
  fetchCms: _a,
  resolveImage: Sa
};
function Ca(e) {
  const t = [];
  return new Proxy(e, {
    apply(n, r, s) {
      const o = js(s), i = t.find((u) => Ds(u.key, o));
      if (i)
        return i.value;
      const a = Reflect.apply(n, r, s);
      return t.push({ key: o, value: a }), a;
    }
  });
}
var qe = /* @__PURE__ */ ((e) => (e.CUSTOMER_AGREEMENT_TENDER_LIST_ITEM = "customerAgreementTenderListItem", e.CUSTOMER_PRICE_REQUEST_TENDER_LIST_ITEM = "customerPriceRequestTenderListItem", e.SUPPLIER_TENDER_LIST_ITEM = "supplierTenderListItem", e.SUPPLIER_INVOICE_LIST_ITEM = "supplierInvoiceListItem", e))(qe || {});
const xa = Ca(Bs.fetchCms), Ta = [
  [
    qe.CUSTOMER_AGREEMENT_TENDER_LIST_ITEM,
    qe.CUSTOMER_PRICE_REQUEST_TENDER_LIST_ITEM
  ],
  [
    qe.SUPPLIER_TENDER_LIST_ITEM
  ],
  [
    qe.SUPPLIER_INVOICE_LIST_ITEM
  ]
], ce = () => {
  const e = async (l) => {
    const d = Ta.find(
      (m) => m.find((b) => b === l)
    );
    return d ? (await xa(t(d))).find((m) => m.label === l) : void 0;
  }, t = (l) => `*[_type == "pages" && ${Array.isArray(l) ? `label in ${JSON.stringify(l)}` : `label == "${l}"`} && __i18n_lang == "no" && !(_id in path("drafts.**"))]`, n = (l, d) => l == null ? void 0 : l.find((g) => g.label === d), r = (l, d) => {
    const g = n(l, d);
    return (g == null ? void 0 : g.title) ?? "";
  }, s = (l, d) => {
    if (!d)
      return "";
    const g = n(d, l);
    return g ? o(g) : "";
  }, o = (l) => {
    const d = l.icon;
    return Bs.resolveImage(d).url();
  }, i = (l, d) => l == null ? void 0 : l.find(
    (g) => g.label === d
  ), a = (l, d) => l == null ? void 0 : l.flatMap((g) => g.serviceCategories).find(
    (g) => (g == null ? void 0 : g.label) === d
  );
  return {
    getPageCms: e,
    getIconUrl: o,
    getCmsItem: n,
    getCmsItemText: r,
    findIconAndResolveUrl: s,
    getServiceIcon: (l, d) => {
      const g = l == null ? void 0 : l.icons;
      if (g != null && g.length)
        return o(g[0]);
      const m = d == null ? void 0 : d.icons;
      return m != null && m.length ? o(m[0]) : "";
    },
    getServiceName: (l, d) => {
      const g = a(l, d);
      return (g == null ? void 0 : g.title) || d || "";
    },
    getServiceTypeCms: i,
    getServiceCategoryCms: a
  };
}, $a = ["src"], Oa = { class: "list-widget__text-section" }, ka = { class: "list-widget__primary-text" }, Ea = {
  key: 0,
  class: "list-widget__secondary-text"
}, Ia = /* @__PURE__ */ ne({
  __name: "ListWidget",
  props: {
    primaryText: { default: void 0 },
    secondaryText: { default: void 0 },
    widgetIconUrl: { default: "" },
    primaryTextCms: { default: void 0 },
    secondaryTextCms: { default: void 0 },
    widgetCms: { default: void 0 },
    nudge: { type: Boolean, default: !1 },
    nudgeColor: { default: "yellow" }
  },
  setup(e) {
    const t = e, { getIconUrl: n } = ce(), r = T(() => t.nudge ? [`list-widget--bg-${t.nudgeColor}`] : []), s = T(() => typeof t.primaryText == "string" ? t.primaryText : t.primaryTextCms ? t.primaryTextCms.title : ""), o = T(() => typeof t.secondaryText == "string" ? t.secondaryText : t.secondaryTextCms ? t.secondaryTextCms.title : ""), i = T(() => {
      var u, c, l, d, g;
      if (t.widgetIconUrl)
        return t.widgetIconUrl;
      const a = (c = (u = t.primaryTextCms) == null ? void 0 : u.icons) != null && c.length ? t.primaryTextCms : t.secondaryTextCms;
      return (l = a == null ? void 0 : a.icons) != null && l.length ? n(a.icons[0]) : (g = (d = t.widgetCms) == null ? void 0 : d.icons) != null && g.length ? n(t.widgetCms.icons[0]) : "";
    });
    return (a, u) => (R(), Y("div", {
      class: Pt(["list-widget", r.value])
    }, [
      le(a.$slots, "visual", {}, () => [
        i.value ? (R(), Y("img", {
          key: 0,
          src: i.value,
          alt: ""
        }, null, 8, $a)) : te("", !0)
      ], !0),
      U("div", Oa, [
        U("div", ka, Le(s.value), 1),
        o.value ? (R(), Y("div", Ea, Le(o.value), 1)) : te("", !0)
      ])
    ], 2));
  }
}), we = /* @__PURE__ */ Te(Ia, [["__scopeId", "data-v-d43f48f4"]]), Pa = /* @__PURE__ */ ne({
  __name: "AgreementResponsibleListWidget",
  props: {
    supplierUsers: {},
    agreementOwnerUserId: {},
    cms: { default: void 0 }
  },
  setup(e) {
    const t = e, { getCmsItem: n } = ce(), r = T(
      () => {
        var a;
        return n((a = t.cms) == null ? void 0 : a.pageSections, "agreementResponsibleWidget");
      }
    ), s = T(() => {
      var a;
      if (!t.agreementOwnerUserId)
        return n((a = r.value) == null ? void 0 : a.otherText, "primaryText_allResponsible");
    }), o = T(() => {
      var a, u;
      if (t.agreementOwnerUserId) {
        const c = (a = t.supplierUsers) == null ? void 0 : a.find((l) => l.userId === t.agreementOwnerUserId);
        return (c == null ? void 0 : c.displayName) || "";
      }
      return ((u = s.value) == null ? void 0 : u.title) || "";
    }), i = T(() => {
      var a;
      return n(
        (a = r.value) == null ? void 0 : a.otherText,
        t.agreementOwnerUserId ? "secondaryText_selectedResponsible" : "secondaryText_allResponsible"
      );
    });
    return (a, u) => (R(), z(we, {
      "primary-text": o.value,
      "primary-text-cms": s.value,
      "secondary-text-cms": i.value,
      "widget-cms": r.value
    }, null, 8, ["primary-text", "primary-text-cms", "secondary-text-cms", "widget-cms"]));
  }
});
var Vs = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })($n, function() {
    var n = 1e3, r = 6e4, s = 36e5, o = "millisecond", i = "second", a = "minute", u = "hour", c = "day", l = "week", d = "month", g = "quarter", m = "year", b = "date", f = "Invalid Date", S = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, $ = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, E = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(v) {
      var _ = ["th", "st", "nd", "rd"], w = v % 100;
      return "[" + v + (_[(w - 20) % 10] || _[w] || _[0]) + "]";
    } }, j = function(v, _, w) {
      var x = String(v);
      return !x || x.length >= _ ? v : "" + Array(_ + 1 - x.length).join(w) + v;
    }, D = { s: j, z: function(v) {
      var _ = -v.utcOffset(), w = Math.abs(_), x = Math.floor(w / 60), O = w % 60;
      return (_ <= 0 ? "+" : "-") + j(x, 2, "0") + ":" + j(O, 2, "0");
    }, m: function v(_, w) {
      if (_.date() < w.date())
        return -v(w, _);
      var x = 12 * (w.year() - _.year()) + (w.month() - _.month()), O = _.clone().add(x, d), A = w - O < 0, P = _.clone().add(x + (A ? -1 : 1), d);
      return +(-(x + (w - O) / (A ? O - P : P - O)) || 0);
    }, a: function(v) {
      return v < 0 ? Math.ceil(v) || 0 : Math.floor(v);
    }, p: function(v) {
      return { M: d, y: m, w: l, d: c, D: b, h: u, m: a, s: i, ms: o, Q: g }[v] || String(v || "").toLowerCase().replace(/s$/, "");
    }, u: function(v) {
      return v === void 0;
    } }, I = "en", M = {};
    M[I] = E;
    var K = "$isDayjsObject", J = function(v) {
      return v instanceof y || !(!v || !v[K]);
    }, q = function v(_, w, x) {
      var O;
      if (!_)
        return I;
      if (typeof _ == "string") {
        var A = _.toLowerCase();
        M[A] && (O = A), w && (M[A] = w, O = A);
        var P = _.split("-");
        if (!O && P.length > 1)
          return v(P[0]);
      } else {
        var L = _.name;
        M[L] = _, O = L;
      }
      return !x && O && (I = O), O || !x && I;
    }, N = function(v, _) {
      if (J(v))
        return v.clone();
      var w = typeof _ == "object" ? _ : {};
      return w.date = v, w.args = arguments, new y(w);
    }, h = D;
    h.l = q, h.i = J, h.w = function(v, _) {
      return N(v, { locale: _.$L, utc: _.$u, x: _.$x, $offset: _.$offset });
    };
    var y = function() {
      function v(w) {
        this.$L = q(w.locale, null, !0), this.parse(w), this.$x = this.$x || w.x || {}, this[K] = !0;
      }
      var _ = v.prototype;
      return _.parse = function(w) {
        this.$d = function(x) {
          var O = x.date, A = x.utc;
          if (O === null)
            return /* @__PURE__ */ new Date(NaN);
          if (h.u(O))
            return /* @__PURE__ */ new Date();
          if (O instanceof Date)
            return new Date(O);
          if (typeof O == "string" && !/Z$/i.test(O)) {
            var P = O.match(S);
            if (P) {
              var L = P[2] - 1 || 0, F = (P[7] || "0").substring(0, 3);
              return A ? new Date(Date.UTC(P[1], L, P[3] || 1, P[4] || 0, P[5] || 0, P[6] || 0, F)) : new Date(P[1], L, P[3] || 1, P[4] || 0, P[5] || 0, P[6] || 0, F);
            }
          }
          return new Date(O);
        }(w), this.init();
      }, _.init = function() {
        var w = this.$d;
        this.$y = w.getFullYear(), this.$M = w.getMonth(), this.$D = w.getDate(), this.$W = w.getDay(), this.$H = w.getHours(), this.$m = w.getMinutes(), this.$s = w.getSeconds(), this.$ms = w.getMilliseconds();
      }, _.$utils = function() {
        return h;
      }, _.isValid = function() {
        return this.$d.toString() !== f;
      }, _.isSame = function(w, x) {
        var O = N(w);
        return this.startOf(x) <= O && O <= this.endOf(x);
      }, _.isAfter = function(w, x) {
        return N(w) < this.startOf(x);
      }, _.isBefore = function(w, x) {
        return this.endOf(x) < N(w);
      }, _.$g = function(w, x, O) {
        return h.u(w) ? this[x] : this.set(O, w);
      }, _.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, _.valueOf = function() {
        return this.$d.getTime();
      }, _.startOf = function(w, x) {
        var O = this, A = !!h.u(x) || x, P = h.p(w), L = function(ae, ve) {
          var je = h.w(O.$u ? Date.UTC(O.$y, ve, ae) : new Date(O.$y, ve, ae), O);
          return A ? je : je.endOf(c);
        }, F = function(ae, ve) {
          return h.w(O.toDate()[ae].apply(O.toDate("s"), (A ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(ve)), O);
        }, W = this.$W, B = this.$M, ee = this.$D, se = "set" + (this.$u ? "UTC" : "");
        switch (P) {
          case m:
            return A ? L(1, 0) : L(31, 11);
          case d:
            return A ? L(1, B) : L(0, B + 1);
          case l:
            var Se = this.$locale().weekStart || 0, ke = (W < Se ? W + 7 : W) - Se;
            return L(A ? ee - ke : ee + (6 - ke), B);
          case c:
          case b:
            return F(se + "Hours", 0);
          case u:
            return F(se + "Minutes", 1);
          case a:
            return F(se + "Seconds", 2);
          case i:
            return F(se + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, _.endOf = function(w) {
        return this.startOf(w, !1);
      }, _.$set = function(w, x) {
        var O, A = h.p(w), P = "set" + (this.$u ? "UTC" : ""), L = (O = {}, O[c] = P + "Date", O[b] = P + "Date", O[d] = P + "Month", O[m] = P + "FullYear", O[u] = P + "Hours", O[a] = P + "Minutes", O[i] = P + "Seconds", O[o] = P + "Milliseconds", O)[A], F = A === c ? this.$D + (x - this.$W) : x;
        if (A === d || A === m) {
          var W = this.clone().set(b, 1);
          W.$d[L](F), W.init(), this.$d = W.set(b, Math.min(this.$D, W.daysInMonth())).$d;
        } else
          L && this.$d[L](F);
        return this.init(), this;
      }, _.set = function(w, x) {
        return this.clone().$set(w, x);
      }, _.get = function(w) {
        return this[h.p(w)]();
      }, _.add = function(w, x) {
        var O, A = this;
        w = Number(w);
        var P = h.p(x), L = function(B) {
          var ee = N(A);
          return h.w(ee.date(ee.date() + Math.round(B * w)), A);
        };
        if (P === d)
          return this.set(d, this.$M + w);
        if (P === m)
          return this.set(m, this.$y + w);
        if (P === c)
          return L(1);
        if (P === l)
          return L(7);
        var F = (O = {}, O[a] = r, O[u] = s, O[i] = n, O)[P] || 1, W = this.$d.getTime() + w * F;
        return h.w(W, this);
      }, _.subtract = function(w, x) {
        return this.add(-1 * w, x);
      }, _.format = function(w) {
        var x = this, O = this.$locale();
        if (!this.isValid())
          return O.invalidDate || f;
        var A = w || "YYYY-MM-DDTHH:mm:ssZ", P = h.z(this), L = this.$H, F = this.$m, W = this.$M, B = O.weekdays, ee = O.months, se = O.meridiem, Se = function(ve, je, Ge, ut) {
          return ve && (ve[je] || ve(x, A)) || Ge[je].slice(0, ut);
        }, ke = function(ve) {
          return h.s(L % 12 || 12, ve, "0");
        }, ae = se || function(ve, je, Ge) {
          var ut = ve < 12 ? "AM" : "PM";
          return Ge ? ut.toLowerCase() : ut;
        };
        return A.replace($, function(ve, je) {
          return je || function(Ge) {
            switch (Ge) {
              case "YY":
                return String(x.$y).slice(-2);
              case "YYYY":
                return h.s(x.$y, 4, "0");
              case "M":
                return W + 1;
              case "MM":
                return h.s(W + 1, 2, "0");
              case "MMM":
                return Se(O.monthsShort, W, ee, 3);
              case "MMMM":
                return Se(ee, W);
              case "D":
                return x.$D;
              case "DD":
                return h.s(x.$D, 2, "0");
              case "d":
                return String(x.$W);
              case "dd":
                return Se(O.weekdaysMin, x.$W, B, 2);
              case "ddd":
                return Se(O.weekdaysShort, x.$W, B, 3);
              case "dddd":
                return B[x.$W];
              case "H":
                return String(L);
              case "HH":
                return h.s(L, 2, "0");
              case "h":
                return ke(1);
              case "hh":
                return ke(2);
              case "a":
                return ae(L, F, !0);
              case "A":
                return ae(L, F, !1);
              case "m":
                return String(F);
              case "mm":
                return h.s(F, 2, "0");
              case "s":
                return String(x.$s);
              case "ss":
                return h.s(x.$s, 2, "0");
              case "SSS":
                return h.s(x.$ms, 3, "0");
              case "Z":
                return P;
            }
            return null;
          }(ve) || P.replace(":", "");
        });
      }, _.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, _.diff = function(w, x, O) {
        var A, P = this, L = h.p(x), F = N(w), W = (F.utcOffset() - this.utcOffset()) * r, B = this - F, ee = function() {
          return h.m(P, F);
        };
        switch (L) {
          case m:
            A = ee() / 12;
            break;
          case d:
            A = ee();
            break;
          case g:
            A = ee() / 3;
            break;
          case l:
            A = (B - W) / 6048e5;
            break;
          case c:
            A = (B - W) / 864e5;
            break;
          case u:
            A = B / s;
            break;
          case a:
            A = B / r;
            break;
          case i:
            A = B / n;
            break;
          default:
            A = B;
        }
        return O ? A : h.a(A);
      }, _.daysInMonth = function() {
        return this.endOf(d).$D;
      }, _.$locale = function() {
        return M[this.$L];
      }, _.locale = function(w, x) {
        if (!w)
          return this.$L;
        var O = this.clone(), A = q(w, x, !0);
        return A && (O.$L = A), O;
      }, _.clone = function() {
        return h.w(this.$d, this);
      }, _.toDate = function() {
        return new Date(this.valueOf());
      }, _.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, _.toISOString = function() {
        return this.$d.toISOString();
      }, _.toString = function() {
        return this.$d.toUTCString();
      }, v;
    }(), p = y.prototype;
    return N.prototype = p, [["$ms", o], ["$s", i], ["$m", a], ["$H", u], ["$W", c], ["$M", d], ["$y", m], ["$D", b]].forEach(function(v) {
      p[v[1]] = function(_) {
        return this.$g(_, v[0], v[1]);
      };
    }), N.extend = function(v, _) {
      return v.$i || (v(_, y, N), v.$i = !0), N;
    }, N.locale = q, N.isDayjs = J, N.unix = function(v) {
      return N(1e3 * v);
    }, N.en = M[I], N.Ls = M, N.p = {}, N;
  });
})(Vs);
var zs = Vs.exports;
const ie = /* @__PURE__ */ fr(zs);
var Ra = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(zs);
  })($n, function(n) {
    function r(i) {
      return i && typeof i == "object" && "default" in i ? i : { default: i };
    }
    var s = r(n), o = { name: "nb", weekdays: "søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag".split("_"), weekdaysShort: "sø._ma._ti._on._to._fr._lø.".split("_"), weekdaysMin: "sø_ma_ti_on_to_fr_lø".split("_"), months: "januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"), monthsShort: "jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.".split("_"), ordinal: function(i) {
      return i + ".";
    }, weekStart: 1, yearStart: 4, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD.MM.YYYY", LL: "D. MMMM YYYY", LLL: "D. MMMM YYYY [kl.] HH:mm", LLLL: "dddd D. MMMM YYYY [kl.] HH:mm" }, relativeTime: { future: "om %s", past: "%s siden", s: "noen sekunder", m: "ett minutt", mm: "%d minutter", h: "en time", hh: "%d timer", d: "en dag", dd: "%d dager", M: "en måned", MM: "%d måneder", y: "ett år", yy: "%d år" } };
    return s.default.locale(o, null, !0), o;
  });
})(Ra);
const Hs = (e) => yt(e, "long"), yt = (e, t = "number") => t === "number" ? Mn(e, "DD.MM.YYYY") : t === "short" ? Mn(e, "DD. MMM YYYY") : Mn(e, "DD. MMMM YYYY"), Mn = (e, t) => e ? ie(e).locale("nb").format(t) : "", Aa = (e, t) => {
  let s = t, o = ie(e);
  if (o.isValid()) {
    for (; s > 0; )
      o = o.add(1, "days"), o.day() !== 0 && o.day() !== 6 && s--;
    return o.toDate();
  }
};
var Ws = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })($n, function() {
    var n = "minute", r = /[+-]\d\d(?::?\d\d)?/g, s = /([+-]|\d\d)/g;
    return function(o, i, a) {
      var u = i.prototype;
      a.utc = function(f) {
        var S = { date: f, utc: !0, args: arguments };
        return new i(S);
      }, u.utc = function(f) {
        var S = a(this.toDate(), { locale: this.$L, utc: !0 });
        return f ? S.add(this.utcOffset(), n) : S;
      }, u.local = function() {
        return a(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var c = u.parse;
      u.parse = function(f) {
        f.utc && (this.$u = !0), this.$utils().u(f.$offset) || (this.$offset = f.$offset), c.call(this, f);
      };
      var l = u.init;
      u.init = function() {
        if (this.$u) {
          var f = this.$d;
          this.$y = f.getUTCFullYear(), this.$M = f.getUTCMonth(), this.$D = f.getUTCDate(), this.$W = f.getUTCDay(), this.$H = f.getUTCHours(), this.$m = f.getUTCMinutes(), this.$s = f.getUTCSeconds(), this.$ms = f.getUTCMilliseconds();
        } else
          l.call(this);
      };
      var d = u.utcOffset;
      u.utcOffset = function(f, S) {
        var $ = this.$utils().u;
        if ($(f))
          return this.$u ? 0 : $(this.$offset) ? d.call(this) : this.$offset;
        if (typeof f == "string" && (f = function(I) {
          I === void 0 && (I = "");
          var M = I.match(r);
          if (!M)
            return null;
          var K = ("" + M[0]).match(s) || ["-", 0, 0], J = K[0], q = 60 * +K[1] + +K[2];
          return q === 0 ? 0 : J === "+" ? q : -q;
        }(f), f === null))
          return this;
        var E = Math.abs(f) <= 16 ? 60 * f : f, j = this;
        if (S)
          return j.$offset = E, j.$u = f === 0, j;
        if (f !== 0) {
          var D = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (j = this.local().add(E + D, n)).$offset = E, j.$x.$localOffset = D;
        } else
          j = this.utc();
        return j;
      };
      var g = u.format;
      u.format = function(f) {
        var S = f || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return g.call(this, S);
      }, u.valueOf = function() {
        var f = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * f;
      }, u.isUTC = function() {
        return !!this.$u;
      }, u.toISOString = function() {
        return this.toDate().toISOString();
      }, u.toString = function() {
        return this.toDate().toUTCString();
      };
      var m = u.toDate;
      u.toDate = function(f) {
        return f === "s" && this.$offset ? a(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : m.call(this);
      };
      var b = u.diff;
      u.diff = function(f, S, $) {
        if (f && this.$u === f.$u)
          return b.call(this, f, S, $);
        var E = this.local(), j = a(f).local();
        return b.call(E, j, S, $);
      };
    };
  });
})(Ws);
var ja = Ws.exports;
const Da = /* @__PURE__ */ fr(ja), qr = 5, La = /* @__PURE__ */ ne({
  __name: "OffersSentListWidget",
  props: {
    tender: {},
    priceRequestId: {},
    supplierId: {},
    cms: { default: void 0 }
  },
  setup(e) {
    ie.extend(Da);
    const t = e, { getCmsItem: n, getIconUrl: r } = ce(), s = T(() => {
      var f;
      return n((f = t.cms) == null ? void 0 : f.pageSections, "offersSentWidget");
    }), o = (f, S) => {
      try {
        const $ = new Date(f);
        return isNaN($.getTime()) ? void 0 : b($, S).toISOString();
      } catch {
        return;
      }
    }, i = T(() => {
      const f = t.tender.priceRequests.find(($) => $.id === t.priceRequestId);
      if (!(f != null && f.createdOn))
        return;
      const S = f.offerResponsePeriodInDays;
      if (!(!S || S < 0))
        return o(f.createdOn, S);
    }), a = T(() => {
      const f = t.tender.priceRequests.find((j) => j.id === t.priceRequestId);
      if (!(f != null && f.createdOn) || !f.offerResponsePeriodInDays)
        return;
      const S = o(f.createdOn, f.offerResponsePeriodInDays);
      if (!S)
        return;
      const $ = ie.utc(), E = ie.utc(S);
      if (!(!$.isValid() || !E.isValid()))
        return Math.ceil(E.diff($, "day", !0));
    }), u = T(() => {
      const f = t.tender.priceRequests.find(($) => $.id === t.priceRequestId), S = f == null ? void 0 : f.supplierRequests.find(($) => $.supplierId === t.supplierId);
      return (S == null ? void 0 : S.offerCount) ?? 0;
    }), c = T(() => {
      const f = t.tender.priceRequests.find(($) => $.id === t.priceRequestId), S = f == null ? void 0 : f.supplierRequests.find(($) => $.supplierId === t.supplierId);
      return S == null ? void 0 : S.requestEstimates;
    }), l = T(() => u.value > 0 ? "green" : a.value && a.value <= qr && a.value > 0 ? "red" : a.value && a.value < 0 || a.value === 0 ? "gray" : "yellow"), d = T(() => {
      var E;
      const f = u.value > 0 ? "primaryText_withOffers_offerType" : "primaryText_noOffers_offerType", S = n((E = s.value) == null ? void 0 : E.otherText, f), $ = c.value ? "estimat" : "tilbud";
      return {
        primaryTextCms: S,
        primaryText: st.render((S == null ? void 0 : S.title) || "", {
          offersCount: u.value,
          offerType: $
        })
      };
    }), g = T(() => {
      var $;
      let f;
      a.value === null || typeof a.value != "number" ? f = "secondaryText_noDeadline" : a.value > qr ? f = "secondaryText_notCloseToDeadline" : a.value > 0 ? f = "secondaryText_closeToDeadline" : f = "secondaryText_afterDeadline";
      const S = n(($ = s.value) == null ? void 0 : $.otherText, f);
      return {
        secondaryTextCms: S,
        secondaryText: st.render((S == null ? void 0 : S.title) || "", {
          date: yt(i.value) || "",
          daysCount: a.value
        })
      };
    }), m = T(() => {
      var D;
      const f = {
        primaryTextCms: d.value.primaryTextCms,
        primaryText: d.value.primaryText,
        secondaryTextCms: g.value.secondaryTextCms,
        secondaryText: g.value.secondaryText,
        nudgeColor: l.value,
        widgetIconUrl: ""
      }, S = {
        red: "alert",
        gray: "close",
        yellow: "clock",
        green: "done"
      }, $ = u.value > 0 ? S.green : S[l.value], E = (D = s.value) == null ? void 0 : D.icons, j = (E == null ? void 0 : E.find((I) => I.label === $)) ?? (E == null ? void 0 : E[0]);
      return f.widgetIconUrl = j ? r(j) : "", f;
    }), b = (f, S) => {
      const $ = new Date(f.getTime());
      let E = S;
      for (; E > 0; ) {
        $.setUTCDate($.getUTCDate() + 1);
        const j = $.getUTCDay();
        j !== 0 && j !== 6 && E--;
      }
      return $;
    };
    return (f, S) => (R(), z(we, {
      "primary-text": m.value.primaryText,
      "secondary-text": m.value.secondaryText,
      "widget-icon-url": m.value.widgetIconUrl,
      nudge: !0,
      "nudge-color": m.value.nudgeColor
    }, null, 8, ["primary-text", "secondary-text", "widget-icon-url", "nudge-color"]));
  }
}), Ma = /* @__PURE__ */ ne({
  __name: "AboutRequestWidget",
  props: {
    tender: {},
    cms: { default: void 0 }
  },
  setup(e) {
    const t = e, { getCmsItem: n } = ce(), r = T(
      () => {
        var i;
        return n((i = t.cms) == null ? void 0 : i.pageSections, "priceRequestWidget");
      }
    ), s = T(() => {
      var i;
      return n(
        (i = r.value) == null ? void 0 : i.otherText,
        t.tender.integrationSource === "SupplierAdmin" ? "primaryText_supplierSent" : "primaryText_customerSent"
      );
    }), o = T(() => {
      const i = ie(t.tender.createdOn), a = ie().startOf("day").diff(i.startOf("day"), "day"), u = "kl. HH:mm";
      return a === 0 ? `i dag ${i.format(u)}` : a === 1 ? `i går ${i.format(u)}` : a >= 2 && a <= 6 ? i.locale("nb").format(`dddd ${u}`) : i.locale("nb").format("DD.MMM YYYY");
    });
    return (i, a) => (R(), z(we, {
      "primary-text-cms": s.value,
      "secondary-text": o.value,
      "widget-cms": r.value
    }, null, 8, ["primary-text-cms", "secondary-text", "widget-cms"]));
  }
}), Nn = 14, Na = /* @__PURE__ */ ne({
  __name: "AgreementStatusWidget",
  props: {
    tender: {},
    cms: { default: void 0 }
  },
  setup(e) {
    const t = e, { getCmsItem: n, getCmsItemText: r } = ce(), s = T(
      () => {
        var d;
        return n((d = t.cms) == null ? void 0 : d.pageSections, "activeAgreementStatus");
      }
    ), o = T(() => {
      var g;
      const d = (g = t.tender.supplierPortfolios) == null ? void 0 : g.flatMap((m) => m.serviceTypePackagePortfolio).find((m) => m.serviceTypePortfolioAcceptance);
      return d ? d.serviceTypePortfolioAcceptance.startDate : void 0;
    }), i = T(() => {
      var g;
      const d = (g = t.tender.supplierPortfolios) == null ? void 0 : g.flatMap((m) => m.serviceTypePackagePortfolio).flatMap((m) => m.serviceOffers).find((m) => m.offerState === Ns.Accepted);
      return d == null ? void 0 : d.billingCycle;
    }), a = T(() => o.value ? ie(o.value).startOf("day").diff(ie().startOf("day"), "day") : -1), u = T(() => {
      var g;
      let d;
      return a.value >= Nn ? d = "primaryText_waitingStartup" : a.value > 0 && a.value < Nn ? d = "primaryText_startingSoon" : i.value === Rt.Fixed ? d = "primaryText_startedSingleJob" : d = "primaryText_startedRepeatingJob", n((g = s.value) == null ? void 0 : g.otherText, d);
    }), c = T(() => {
      var d;
      return a.value > 0 ? ie(o.value).locale("nb").format("DD.MMM YYYY") : i.value === Rt.Fixed ? st.render(
        r(
          (d = s.value) == null ? void 0 : d.otherText,
          "secondaryText_started"
        ),
        {
          date: ie(o.value).format("DD.MM.YYYY")
        }
      ) : "";
    }), l = T(() => a.value > 0 && a.value < Nn || i.value === Rt.Fixed);
    return (d, g) => (R(), z(we, {
      "secondary-text": c.value,
      "primary-text-cms": u.value,
      "widget-cms": s.value,
      nudge: l.value
    }, null, 8, ["secondary-text", "primary-text-cms", "widget-cms", "nudge"]));
  }
}), Ua = /* @__PURE__ */ ne({
  __name: "ConcludedTenderStatusWidget",
  props: {
    supplierRequest: {},
    cms: { default: void 0 }
  },
  setup(e) {
    const t = e, { getCmsItem: n } = ce(), r = T(
      () => {
        var i;
        return n((i = t.cms) == null ? void 0 : i.pageSections, "concludedAgreementStatus");
      }
    ), s = T(() => {
      var a;
      let i = "";
      return t.supplierRequest.requestState === Q.Rejected && (i = t.supplierRequest.requestStateAudience === Us.Customer ? "primaryText_customerRejected" : "primaryText_supplierRejected"), t.supplierRequest.requestState === Q.Completed && (i = "primaryText_done"), n((a = r.value) == null ? void 0 : a.otherText, i);
    }), o = T(() => {
      const i = t.supplierRequest.requestStateChanges.find(
        (a) => a.stateTo === t.supplierRequest.requestState
      );
      return i != null && i.createdOn ? ie(i.createdOn).locale("nb").format("DD.MMMM YYYY") : "";
    });
    return (i, a) => (R(), z(we, {
      "primary-text-cms": s.value,
      "secondary-text": o.value,
      "widget-cms": r.value
    }, null, 8, ["primary-text-cms", "secondary-text", "widget-cms"]));
  }
}), qa = "data:image/svg+xml,%3csvg%20width='20'%20height='20'%20viewBox='0%200%2020%2020'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Close'%3e%3cpath%20id='Union'%20d='M6.4346%205.24614C6.10642%204.91795%205.57432%204.91795%205.24614%205.24614C4.91795%205.57432%204.91795%206.10642%205.24614%206.4346L8.8116%2010.0001L5.24627%2013.5654C4.91808%2013.8936%204.91808%2014.4257%205.24627%2014.7539C5.57445%2015.082%206.10654%2015.082%206.43473%2014.7539L10.0001%2011.1885L13.5654%2014.7538C13.8936%2015.082%2014.4257%2015.082%2014.7539%2014.7538C15.082%2014.4257%2015.082%2013.8936%2014.7539%2013.5654L11.1885%2010.0001L14.754%206.43461C15.0822%206.10643%2015.0822%205.57433%2014.754%205.24615C14.4258%204.91796%2013.8937%204.91796%2013.5655%205.24615L10.0001%208.8116L6.4346%205.24614Z'%20fill='%231D1D1D'/%3e%3c/g%3e%3c/svg%3e", On = "data:image/svg+xml,%3csvg%20width='20'%20height='20'%20viewBox='0%200%2020%2020'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Arrow'%3e%3cpath%20id='Union'%20d='M2.82813%209.99951C2.82812%2010.5518%203.27584%2010.9995%203.82812%2010.9995L13.7589%2010.9995L10.1227%2014.6357C9.7322%2015.0262%209.7322%2015.6594%2010.1227%2016.0499C10.5133%2016.4404%2011.1464%2016.4404%2011.5369%2016.0499L16.8802%2010.7066C17.2707%2010.3161%2017.2707%209.68293%2016.8802%209.29241L11.5369%203.94914C11.1464%203.55862%2010.5133%203.55862%2010.1227%203.94914C9.7322%204.33967%209.7322%204.97283%2010.1227%205.36336L13.7589%208.99951L3.82813%208.99951C3.27584%208.99951%202.82813%209.44723%202.82813%209.99951Z'%20fill='white'/%3e%3c/g%3e%3c/svg%3e", Fa = {}, Ba = { class: "customer-chose-another-supplier-widget" };
function Va(e, t) {
  return R(), Y("div", Ba, t[0] || (t[0] = [
    As('<div class="customer-chose-another-supplier-widget__content" data-v-a63c9c0c><div class="customer-chose-another-supplier-widget__icon" data-v-a63c9c0c><img src="' + qa + '" alt="Close" data-v-a63c9c0c></div><div class="customer-chose-another-supplier-widget__text" data-v-a63c9c0c><div class="customer-chose-another-supplier-widget__title" data-v-a63c9c0c> Kunde valgte annen leverandør </div><div class="customer-chose-another-supplier-widget__subtitle" data-v-a63c9c0c> Se tilbakemelding og flytt til arkiv </div></div></div><button class="customer-chose-another-supplier-widget__button" data-v-a63c9c0c><img src="' + On + '" alt="Arrow Right" class="customer-chose-another-supplier-widget__button-icon" data-v-a63c9c0c></button>', 2)
  ]));
}
const za = /* @__PURE__ */ Te(Fa, [["render", Va], ["__scopeId", "data-v-a63c9c0c"]]), Ha = "data:image/svg+xml,%3csvg%20width='20'%20height='20'%20viewBox='0%200%2020%2020'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Checkmark'%3e%3cpath%20id='Vector'%20d='M12.8279%206.8163L8.5858%2011.0584L7.17175%209.64439C6.78127%209.25391%206.14818%209.25391%205.7577%209.64439C5.36722%2010.0349%205.36722%2010.668%205.7577%2011.0584L7.87877%2013.1795C8.26925%2013.57%208.90234%2013.57%209.29282%2013.1795L14.242%208.23034C14.6325%207.83987%2014.6325%207.20677%2014.242%206.8163C13.8515%206.42582%2013.2184%206.42582%2012.8279%206.8163Z'%20fill='%231D1D1D'/%3e%3c/g%3e%3c/svg%3e", Wa = "data:image/svg+xml,%3csvg%20width='24'%20height='14'%20viewBox='0%200%2024%2014'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20id='Subtract'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M23.368%201.29031C21.4652%208.31284%2015.3145%2012.8149%209.38274%2011.6944L9.52871%2012.8093C9.58653%2013.2509%209.17655%2013.6092%208.74672%2013.4927L7.54203%2013.1663C7.1122%2013.0498%206.93918%2012.5336%207.21202%2012.1816L7.90089%2011.2929C2.21489%209.2655%20-0.821546%202.27409%201.08126%20-4.74845C3.0643%20-12.0671%209.66093%20-16.6482%2015.8152%20-14.9806C21.9695%20-13.3131%2025.351%20-6.02832%2023.368%201.29031ZM20.3494%20-6.40495C20.207%20-6.71881%2019.8372%20-6.85793%2019.5233%20-6.71567C19.2094%20-6.57335%2019.0703%20-6.20354%2019.2126%20-5.88961C20.0607%20-4.0186%2020.2734%20-1.60582%2019.6069%200.853852C18.731%204.08645%2016.5933%206.46625%2014.2395%207.34299C13.9165%207.46336%2013.7522%207.82271%2013.8725%208.14569C13.9928%208.46865%2014.3521%208.63295%2014.6751%208.51265C17.4694%207.47184%2019.8493%204.73161%2020.8116%201.18027C21.5471%20-1.53432%2021.3275%20-4.2471%2020.3494%20-6.40495Z'%20fill='%232F5D38'/%3e%3c/svg%3e", Ya = "data:image/svg+xml,%3csvg%20width='17'%20height='21'%20viewBox='0%200%2017%2021'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20id='Subtract'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M16.368%2017.2903C14.4652%2024.3128%208.31447%2028.8149%202.38274%2027.6944L2.52871%2028.8093C2.58653%2029.2509%202.17655%2029.6092%201.74672%2029.4927L0.542033%2029.1663C0.112205%2029.0498%20-0.0608155%2028.5336%200.212017%2028.1816L0.900889%2027.2929C-4.78511%2025.2655%20-7.82155%2018.2741%20-5.91874%2011.2516C-3.9357%203.93292%202.66093%20-0.648176%208.81523%201.01938C14.9695%202.68693%2018.351%209.97168%2016.368%2017.2903ZM13.3494%209.59505C13.207%209.28119%2012.8372%209.14207%2012.5233%209.28433C12.2094%209.42665%2012.0703%209.79646%2012.2126%2010.1104C13.0607%2011.9814%2013.2734%2014.3942%2012.6069%2016.8539C11.731%2020.0864%209.59329%2022.4663%207.23947%2023.343C6.91647%2023.4634%206.75217%2023.8227%206.87249%2024.1457C6.99279%2024.4687%207.35214%2024.633%207.67513%2024.5127C10.4694%2023.4718%2012.8493%2020.7316%2013.8116%2017.1803C14.5471%2014.4657%2014.3275%2011.7529%2013.3494%209.59505Z'%20fill='%232F5D38'/%3e%3c/svg%3e", Ka = "data:image/svg+xml,%3csvg%20width='13'%20height='16'%20viewBox='0%200%2013%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20id='Vector%20310'%20d='M1.13289%2019.4634C1.13289%2019.4634%204.54173%207.95486%205.74107%209.31134C6.4092%2010.067%205.39868%2013.198%205.9309%2014.2942C7.20094%2016.91%2011.8962%200.432095%2011.8962%200.432095'%20stroke='%2391C79C'/%3e%3c/svg%3e", Ga = {}, Ja = { class: "new-agreement-widget" }, Za = { class: "new-agreement-widget__container" }, Xa = { class: "new-agreement-widget__icon-wrapper" };
function Qa(e, t) {
  return R(), Y("div", Ja, [
    U("div", Za, [
      U("div", Xa, [
        t[0] || (t[0] = U("img", {
          src: Ha,
          alt: "Check mark",
          class: "new-agreement-widget__done-icon"
        }, null, -1)),
        t[1] || (t[1] = U("img", {
          src: Wa,
          alt: "Balloon top",
          class: "new-agreement-widget__decoration new-agreement-widget__decoration--top-right"
        }, null, -1)),
        t[2] || (t[2] = U("img", {
          src: Ya,
          alt: "Balloon bottom",
          class: "new-agreement-widget__decoration new-agreement-widget__decoration--bottom-left"
        }, null, -1)),
        t[3] || (t[3] = U("img", {
          src: Ka,
          alt: "Vector",
          class: "new-agreement-widget__vector"
        }, null, -1)),
        (R(), Y(Ut, null, lr(6, (n) => U("div", {
          key: n,
          class: Pt(`new-agreement-widget__shape new-agreement-widget__shape--${n}`)
        }, null, 2)), 64))
      ]),
      t[4] || (t[4] = U("div", { class: "new-agreement-widget__content" }, [
        U("h3", { class: "new-agreement-widget__title" }, "Ny avtale"),
        U("p", { class: "new-agreement-widget__subtitle" }, "Se tilbakemelding fra kunde")
      ], -1))
    ]),
    t[5] || (t[5] = U("button", { class: "new-agreement-widget__button" }, [
      U("img", {
        src: On,
        alt: "Arrow Right"
      })
    ], -1))
  ]);
}
const ec = /* @__PURE__ */ Te(Ga, [["render", Qa]]), tc = { class: "new-price-request-widget" }, nc = { class: "new-price-request-widget__content" }, rc = { class: "new-price-request-widget__text" }, sc = { class: "new-price-request-widget__subtitle" }, oc = /* @__PURE__ */ ne({
  __name: "NewPriceRequestWidget",
  props: {
    requestEstimates: { type: Boolean }
  },
  setup(e) {
    return (t, n) => (R(), Y("div", tc, [
      U("div", nc, [
        n[1] || (n[1] = U("div", { class: "new-price-request-widget__icon" }, [
          U("i", { class: "pi pi-tag" })
        ], -1)),
        U("div", rc, [
          n[0] || (n[0] = U("div", { class: "new-price-request-widget__title" }, " Ny prisforespørsel ", -1)),
          U("div", sc, Le(t.requestEstimates ? "Send melding for mer informasjon, eller svar med estimat" : "Send melding for mer informasjon, eller svar med tilbud"), 1)
        ])
      ]),
      n[2] || (n[2] = U("button", {
        class: "new-price-request-widget__button",
        "aria-label": "Se prisforespørsel"
      }, [
        U("img", {
          src: On,
          alt: "Arrow Right",
          class: "new-price-request-widget__button-icon"
        })
      ], -1))
    ]));
  }
}), ic = /* @__PURE__ */ Te(oc, [["__scopeId", "data-v-b73e50be"]]), ac = {}, cc = { class: "unread-messages-widget" };
function uc(e, t) {
  return R(), Y("div", cc, t[0] || (t[0] = [
    As('<div class="unread-messages-widget__content" data-v-03e4c1c2><div class="unread-messages-widget__icon" data-v-03e4c1c2><i class="pi pi-envelope" data-v-03e4c1c2></i></div><div class="unread-messages-widget__text" data-v-03e4c1c2><div class="unread-messages-widget__title" data-v-03e4c1c2> Du har uleste meldinger fra kunden </div><div class="unread-messages-widget__subtitle" data-v-03e4c1c2> Se gjennom og svar om nødvendig </div></div></div><button class="unread-messages-widget__button" aria-label="Se prisforespørsel" data-v-03e4c1c2><img src="' + On + '" alt="Arrow Right" class="unread-messages-widget__button-icon" data-v-03e4c1c2></button>', 2)
  ]));
}
const lc = /* @__PURE__ */ Te(ac, [["render", uc], ["__scopeId", "data-v-03e4c1c2"]]), dc = /* @__PURE__ */ ne({
  __name: "RequestStateWidget",
  props: {
    requestState: {},
    offersCount: {},
    requestEstimates: { type: Boolean },
    cms: {}
  },
  setup(e) {
    const t = e, { getCmsItem: n, getIconUrl: r } = ce(), s = T(
      () => {
        var c;
        return n((c = t.cms) == null ? void 0 : c.pageSections, "requestStateWidget");
      }
    ), o = {
      [Q.Offered]: {
        primaryText: "tilbud gitt",
        nudgeColor: "green",
        iconLabel: "done"
      },
      [Q.PriceRequested]: {
        primaryText: "Pris forespurt",
        nudgeColor: "gray",
        iconLabel: "clock"
      },
      [Q.InformationRequested]: {
        primaryText: "Kunde kontaktet",
        nudgeColor: "yellow",
        iconLabel: "send"
      },
      [Q.Lost]: {
        primaryText: "Tapt",
        nudgeColor: "gray",
        iconLabel: "close"
      },
      [Q.Unanswered]: {
        primaryText: "Ubesvart",
        nudgeColor: "gray",
        iconLabel: "clock"
      },
      [Q.Accepted]: {
        primaryText: "Akseptert",
        nudgeColor: "green",
        iconLabel: "done"
      },
      [Q.Rejected]: {
        primaryText: "Avvist",
        nudgeColor: "gray",
        iconLabel: "close"
      },
      [Q.Interested]: {
        primaryText: "Interessert",
        nudgeColor: "yellow",
        iconLabel: "star"
      }
    }, i = (c) => o[c] ?? o[Q.PriceRequested], a = (c, l) => (c == null ? void 0 : c.find((d) => d.label === l)) ?? (c == null ? void 0 : c[0]), u = T(() => {
      var g;
      if (![
        Q.Offered,
        Q.PriceRequested,
        Q.InformationRequested,
        Q.Lost,
        Q.Unanswered,
        Q.Accepted,
        Q.Rejected,
        Q.Interested
      ].includes(t.requestState))
        return null;
      const c = i(t.requestState), l = a(
        (g = s.value) == null ? void 0 : g.icons,
        c.iconLabel
      );
      let d = c.primaryText;
      if (t.requestState === Q.Offered) {
        const m = t.requestEstimates ? "estimat" : "tilbud";
        d = `${t.offersCount} ${m} gitt`;
      }
      return {
        primaryText: t.requestState === Q.Offered ? d : c.primaryText,
        nudgeColor: c.nudgeColor,
        widgetIconUrl: l ? r(l) : ""
      };
    });
    return (c, l) => u.value ? (R(), z(we, {
      key: 0,
      "primary-text": u.value.primaryText,
      "widget-icon-url": u.value.widgetIconUrl,
      nudge: !0,
      "nudge-color": u.value.nudgeColor
    }, null, 8, ["primary-text", "widget-icon-url", "nudge-color"])) : te("", !0);
  }
});
function kn(e) {
  return e == null || e === "" || Array.isArray(e) && e.length === 0 || !(e instanceof Date) && typeof e == "object" && Object.keys(e).length === 0;
}
function Ys(e) {
  return !!(e && e.constructor && e.call && e.apply);
}
function re(e) {
  return !kn(e);
}
function vt(e, t = !0) {
  return e instanceof Object && e.constructor === Object && (t || Object.keys(e).length !== 0);
}
function Pe(e, ...t) {
  return Ys(e) ? e(...t) : e;
}
function Ne(e, t = !0) {
  return typeof e == "string" && (t || e !== "");
}
function Ke(e) {
  return Ne(e) ? e.replace(/(-|_)/g, "").toLowerCase() : e;
}
function Ks(e, t = "", n = {}) {
  const r = Ke(t).split("."), s = r.shift();
  return s ? vt(e) ? Ks(Pe(e[Object.keys(e).find((o) => Ke(o) === s) || ""], n), r.join("."), n) : void 0 : Pe(e, n);
}
function hr(e, t = !0) {
  return Array.isArray(e) && (t || e.length !== 0);
}
function pc(e) {
  return re(e) && !isNaN(e);
}
function Fe(e, t) {
  if (t) {
    const n = t.test(e);
    return t.lastIndex = 0, n;
  }
  return !1;
}
function At(e) {
  return e && e.replace(/\/\*(?:(?!\*\/)[\s\S])*\*\/|[\r\n\t]+/g, "").replace(/ {2,}/g, " ").replace(/ ([{:}]) /g, "$1").replace(/([;,]) /g, "$1").replace(/ !/g, "!").replace(/: /g, ":");
}
function Gs(e) {
  return Ne(e) ? e.replace(/(_)/g, "-").replace(/[A-Z]/g, (t, n) => n === 0 ? t : "-" + t.toLowerCase()).toLowerCase() : e;
}
function Fr(e) {
  return Ne(e) ? e.replace(/[A-Z]/g, (t, n) => n === 0 ? t : "." + t.toLowerCase()).toLowerCase() : e;
}
function fc() {
  const e = /* @__PURE__ */ new Map();
  return {
    on(t, n) {
      let r = e.get(t);
      return r ? r.push(n) : r = [n], e.set(t, r), this;
    },
    off(t, n) {
      let r = e.get(t);
      return r && r.splice(r.indexOf(n) >>> 0, 1), this;
    },
    emit(t, n) {
      let r = e.get(t);
      r && r.slice().map((s) => {
        s(n);
      });
    },
    clear() {
      e.clear();
    }
  };
}
var hc = Object.defineProperty, mc = Object.defineProperties, gc = Object.getOwnPropertyDescriptors, yn = Object.getOwnPropertySymbols, Js = Object.prototype.hasOwnProperty, Zs = Object.prototype.propertyIsEnumerable, Br = (e, t, n) => t in e ? hc(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Ie = (e, t) => {
  for (var n in t || (t = {}))
    Js.call(t, n) && Br(e, n, t[n]);
  if (yn)
    for (var n of yn(t))
      Zs.call(t, n) && Br(e, n, t[n]);
  return e;
}, Un = (e, t) => mc(e, gc(t)), Ue = (e, t) => {
  var n = {};
  for (var r in e)
    Js.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && yn)
    for (var r of yn(e))
      t.indexOf(r) < 0 && Zs.call(e, r) && (n[r] = e[r]);
  return n;
}, vc = fc(), He = vc;
function Vr(e, t) {
  hr(e) ? e.push(...t || []) : vt(e) && Object.assign(e, t);
}
function yc(e) {
  return vt(e) && e.hasOwnProperty("value") && e.hasOwnProperty("type") ? e.value : e;
}
function bc(e) {
  return e.replaceAll(/ /g, "").replace(/[^\w]/g, "-");
}
function Gn(e = "", t = "") {
  return bc(`${Ne(e, !1) && Ne(t, !1) ? `${e}-` : e}${t}`);
}
function Xs(e = "", t = "") {
  return `--${Gn(e, t)}`;
}
function wc(e = "") {
  const t = (e.match(/{/g) || []).length, n = (e.match(/}/g) || []).length;
  return (t + n) % 2 !== 0;
}
function Qs(e, t = "", n = "", r = [], s) {
  if (Ne(e)) {
    const o = /{([^}]*)}/g, i = e.trim();
    if (wc(i))
      return;
    if (Fe(i, o)) {
      const a = i.replaceAll(o, (l) => {
        const g = l.replace(/{|}/g, "").split(".").filter((m) => !r.some((b) => Fe(m, b)));
        return `var(${Xs(n, Gs(g.join("-")))}${re(s) ? `, ${s}` : ""})`;
      }), u = /(\d+\s+[\+\-\*\/]\s+\d+)/g, c = /var\([^)]+\)/g;
      return Fe(a.replace(c, "0"), u) ? `calc(${a})` : a;
    }
    return i;
  } else if (pc(e))
    return e;
}
function _c(e, t, n) {
  Ne(t, !1) && e.push(`${t}:${n};`);
}
function dt(e, t) {
  return e ? `${e}{${t}}` : "";
}
var jt = (...e) => Sc(he.getTheme(), ...e), Sc = (e = {}, t, n, r) => {
  if (t) {
    const { variable: s, options: o } = he.defaults || {}, { prefix: i, transform: a } = (e == null ? void 0 : e.options) || o || {}, c = Fe(t, /{([^}]*)}/g) ? t : `{${t}}`;
    return r === "value" || kn(r) && a === "strict" ? he.getTokenValue(t) : Qs(c, void 0, i, [s.excludedKeyRegex], n);
  }
  return "";
};
function Cc(e, t = {}) {
  const n = he.defaults.variable, { prefix: r = n.prefix, selector: s = n.selector, excludedKeyRegex: o = n.excludedKeyRegex } = t, i = (c, l = "") => Object.entries(c).reduce(
    (d, [g, m]) => {
      const b = Fe(g, o) ? Gn(l) : Gn(l, Gs(g)), f = yc(m);
      if (vt(f)) {
        const { variables: S, tokens: $ } = i(f, b);
        Vr(d.tokens, $), Vr(d.variables, S);
      } else
        d.tokens.push((r ? b.replace(`${r}-`, "") : b).replaceAll("-", ".")), _c(d.variables, Xs(b), Qs(f, b, r, [o]));
      return d;
    },
    { variables: [], tokens: [] }
  ), { variables: a, tokens: u } = i(e, r);
  return {
    value: a,
    tokens: u,
    declarations: a.join(""),
    css: dt(s, a.join(""))
  };
}
var Ee = {
  regex: {
    rules: {
      class: {
        pattern: /^\.([a-zA-Z][\w-]*)$/,
        resolve(e) {
          return { type: "class", selector: e, matched: this.pattern.test(e.trim()) };
        }
      },
      attr: {
        pattern: /^\[(.*)\]$/,
        resolve(e) {
          return { type: "attr", selector: `:root${e}`, matched: this.pattern.test(e.trim()) };
        }
      },
      media: {
        pattern: /^@media (.*)$/,
        resolve(e) {
          return { type: "media", selector: `${e}{:root{[CSS]}}`, matched: this.pattern.test(e.trim()) };
        }
      },
      system: {
        pattern: /^system$/,
        resolve(e) {
          return { type: "system", selector: "@media (prefers-color-scheme: dark){:root{[CSS]}}", matched: this.pattern.test(e.trim()) };
        }
      },
      custom: {
        resolve(e) {
          return { type: "custom", selector: e, matched: !0 };
        }
      }
    },
    resolve(e) {
      const t = Object.keys(this.rules).filter((n) => n !== "custom").map((n) => this.rules[n]);
      return [e].flat().map((n) => {
        var r;
        return (r = t.map((s) => s.resolve(n)).find((s) => s.matched)) != null ? r : this.rules.custom.resolve(n);
      });
    }
  },
  _toVariables(e, t) {
    return Cc(e, { prefix: t == null ? void 0 : t.prefix });
  },
  getCommon({ name: e = "", theme: t = {}, params: n, set: r, defaults: s }) {
    var o, i, a, u, c, l, d;
    const { preset: g, options: m } = t;
    let b, f, S, $, E, j, D;
    if (re(g) && m.transform !== "strict") {
      const { primitive: I, semantic: M, extend: K } = g, J = M || {}, { colorScheme: q } = J, N = Ue(J, ["colorScheme"]), h = K || {}, { colorScheme: y } = h, p = Ue(h, ["colorScheme"]), v = q || {}, { dark: _ } = v, w = Ue(v, ["dark"]), x = y || {}, { dark: O } = x, A = Ue(x, ["dark"]), P = re(I) ? this._toVariables({ primitive: I }, m) : {}, L = re(N) ? this._toVariables({ semantic: N }, m) : {}, F = re(w) ? this._toVariables({ light: w }, m) : {}, W = re(_) ? this._toVariables({ dark: _ }, m) : {}, B = re(p) ? this._toVariables({ semantic: p }, m) : {}, ee = re(A) ? this._toVariables({ light: A }, m) : {}, se = re(O) ? this._toVariables({ dark: O }, m) : {}, [Se, ke] = [(o = P.declarations) != null ? o : "", P.tokens], [ae, ve] = [(i = L.declarations) != null ? i : "", L.tokens || []], [je, Ge] = [(a = F.declarations) != null ? a : "", F.tokens || []], [ut, Ri] = [(u = W.declarations) != null ? u : "", W.tokens || []], [Ai, ji] = [(c = B.declarations) != null ? c : "", B.tokens || []], [Di, Li] = [(l = ee.declarations) != null ? l : "", ee.tokens || []], [Mi, Ni] = [(d = se.declarations) != null ? d : "", se.tokens || []];
      b = this.transformCSS(e, Se, "light", "variable", m, r, s), f = ke;
      const Ui = this.transformCSS(e, `${ae}${je}`, "light", "variable", m, r, s), qi = this.transformCSS(e, `${ut}`, "dark", "variable", m, r, s);
      S = `${Ui}${qi}`, $ = [.../* @__PURE__ */ new Set([...ve, ...Ge, ...Ri])];
      const Fi = this.transformCSS(e, `${Ai}${Di}color-scheme:light`, "light", "variable", m, r, s), Bi = this.transformCSS(e, `${Mi}color-scheme:dark`, "dark", "variable", m, r, s);
      E = `${Fi}${Bi}`, j = [.../* @__PURE__ */ new Set([...ji, ...Li, ...Ni])], D = Pe(g.css, { dt: jt });
    }
    return {
      primitive: {
        css: b,
        tokens: f
      },
      semantic: {
        css: S,
        tokens: $
      },
      global: {
        css: E,
        tokens: j
      },
      style: D
    };
  },
  getPreset({ name: e = "", preset: t = {}, options: n, params: r, set: s, defaults: o, selector: i }) {
    var a, u, c;
    let l, d, g;
    if (re(t) && n.transform !== "strict") {
      const m = e.replace("-directive", ""), b = t, { colorScheme: f, extend: S, css: $ } = b, E = Ue(b, ["colorScheme", "extend", "css"]), j = S || {}, { colorScheme: D } = j, I = Ue(j, ["colorScheme"]), M = f || {}, { dark: K } = M, J = Ue(M, ["dark"]), q = D || {}, { dark: N } = q, h = Ue(q, ["dark"]), y = re(E) ? this._toVariables({ [m]: Ie(Ie({}, E), I) }, n) : {}, p = re(J) ? this._toVariables({ [m]: Ie(Ie({}, J), h) }, n) : {}, v = re(K) ? this._toVariables({ [m]: Ie(Ie({}, K), N) }, n) : {}, [_, w] = [(a = y.declarations) != null ? a : "", y.tokens || []], [x, O] = [(u = p.declarations) != null ? u : "", p.tokens || []], [A, P] = [(c = v.declarations) != null ? c : "", v.tokens || []], L = this.transformCSS(m, `${_}${x}`, "light", "variable", n, s, o, i), F = this.transformCSS(m, A, "dark", "variable", n, s, o, i);
      l = `${L}${F}`, d = [.../* @__PURE__ */ new Set([...w, ...O, ...P])], g = Pe($, { dt: jt });
    }
    return {
      css: l,
      tokens: d,
      style: g
    };
  },
  getPresetC({ name: e = "", theme: t = {}, params: n, set: r, defaults: s }) {
    var o;
    const { preset: i, options: a } = t, u = (o = i == null ? void 0 : i.components) == null ? void 0 : o[e];
    return this.getPreset({ name: e, preset: u, options: a, params: n, set: r, defaults: s });
  },
  getPresetD({ name: e = "", theme: t = {}, params: n, set: r, defaults: s }) {
    var o;
    const i = e.replace("-directive", ""), { preset: a, options: u } = t, c = (o = a == null ? void 0 : a.directives) == null ? void 0 : o[i];
    return this.getPreset({ name: i, preset: c, options: u, params: n, set: r, defaults: s });
  },
  applyDarkColorScheme(e) {
    return !(e.darkModeSelector === "none" || e.darkModeSelector === !1);
  },
  getColorSchemeOption(e, t) {
    var n;
    return this.applyDarkColorScheme(e) ? this.regex.resolve(e.darkModeSelector === !0 ? t.options.darkModeSelector : (n = e.darkModeSelector) != null ? n : t.options.darkModeSelector) : [];
  },
  getLayerOrder(e, t = {}, n, r) {
    const { cssLayer: s } = t;
    return s ? `@layer ${Pe(s.order || "primeui", n)}` : "";
  },
  getCommonStyleSheet({ name: e = "", theme: t = {}, params: n, props: r = {}, set: s, defaults: o }) {
    const i = this.getCommon({ name: e, theme: t, params: n, set: s, defaults: o }), a = Object.entries(r).reduce((u, [c, l]) => u.push(`${c}="${l}"`) && u, []).join(" ");
    return Object.entries(i || {}).reduce((u, [c, l]) => {
      if (l != null && l.css) {
        const d = At(l == null ? void 0 : l.css), g = `${c}-variables`;
        u.push(`<style type="text/css" data-primevue-style-id="${g}" ${a}>${d}</style>`);
      }
      return u;
    }, []).join("");
  },
  getStyleSheet({ name: e = "", theme: t = {}, params: n, props: r = {}, set: s, defaults: o }) {
    var i;
    const a = { name: e, theme: t, params: n, set: s, defaults: o }, u = (i = e.includes("-directive") ? this.getPresetD(a) : this.getPresetC(a)) == null ? void 0 : i.css, c = Object.entries(r).reduce((l, [d, g]) => l.push(`${d}="${g}"`) && l, []).join(" ");
    return u ? `<style type="text/css" data-primevue-style-id="${e}-variables" ${c}>${At(u)}</style>` : "";
  },
  createTokens(e = {}, t, n = "", r = "", s = {}) {
    return Object.entries(e).forEach(([o, i]) => {
      const a = Fe(o, t.variable.excludedKeyRegex) ? n : n ? `${n}.${Fr(o)}` : Fr(o), u = r ? `${r}.${o}` : o;
      vt(i) ? this.createTokens(i, t, a, u, s) : (s[a] || (s[a] = {
        paths: [],
        computed(c, l = {}) {
          var d, g;
          return this.paths.length === 1 ? (d = this.paths[0]) == null ? void 0 : d.computed(this.paths[0].scheme, l.binding) : c && c !== "none" ? (g = this.paths.find((m) => m.scheme === c)) == null ? void 0 : g.computed(c, l.binding) : this.paths.map((m) => m.computed(m.scheme, l[m.scheme]));
        }
      }), s[a].paths.push({
        path: u,
        value: i,
        scheme: u.includes("colorScheme.light") ? "light" : u.includes("colorScheme.dark") ? "dark" : "none",
        computed(c, l = {}) {
          const d = /{([^}]*)}/g;
          let g = i;
          if (l.name = this.path, l.binding || (l.binding = {}), Fe(i, d)) {
            const b = i.trim().replaceAll(d, ($) => {
              var E;
              const j = $.replace(/{|}/g, ""), D = (E = s[j]) == null ? void 0 : E.computed(c, l);
              return hr(D) && D.length === 2 ? `light-dark(${D[0].value},${D[1].value})` : D == null ? void 0 : D.value;
            }), f = /(\d+\w*\s+[\+\-\*\/]\s+\d+\w*)/g, S = /var\([^)]+\)/g;
            g = Fe(b.replace(S, "0"), f) ? `calc(${b})` : b;
          }
          return kn(l.binding) && delete l.binding, {
            colorScheme: c,
            path: this.path,
            paths: l,
            value: g.includes("undefined") ? void 0 : g
          };
        }
      }));
    }), s;
  },
  getTokenValue(e, t, n) {
    var r;
    const o = ((u) => u.split(".").filter((l) => !Fe(l.toLowerCase(), n.variable.excludedKeyRegex)).join("."))(t), i = t.includes("colorScheme.light") ? "light" : t.includes("colorScheme.dark") ? "dark" : void 0, a = [(r = e[o]) == null ? void 0 : r.computed(i)].flat().filter((u) => u);
    return a.length === 1 ? a[0].value : a.reduce((u = {}, c) => {
      const l = c, { colorScheme: d } = l, g = Ue(l, ["colorScheme"]);
      return u[d] = g, u;
    }, void 0);
  },
  getSelectorRule(e, t, n, r) {
    return n === "class" || n === "attr" ? dt(re(t) ? `${e}${t},${e} ${t}` : e, r) : dt(e, re(t) ? dt(t, r) : r);
  },
  transformCSS(e, t, n, r, s = {}, o, i, a) {
    if (re(t)) {
      const { cssLayer: u } = s;
      if (r !== "style") {
        const c = this.getColorSchemeOption(s, i);
        t = n === "dark" ? c.reduce((l, { type: d, selector: g }) => (re(g) && (l += g.includes("[CSS]") ? g.replace("[CSS]", t) : this.getSelectorRule(g, a, d, t)), l), "") : dt(a ?? ":root", t);
      }
      if (u) {
        const c = {
          name: "primeui",
          order: "primeui"
        };
        vt(u) && (c.name = Pe(u.name, { name: e, type: r })), re(c.name) && (t = dt(`@layer ${c.name}`, t), o == null || o.layerNames(c.name));
      }
      return t;
    }
    return "";
  }
}, he = {
  defaults: {
    variable: {
      prefix: "p",
      selector: ":root",
      excludedKeyRegex: /^(primitive|semantic|components|directives|variables|colorscheme|light|dark|common|root|states|extend|css)$/gi
    },
    options: {
      prefix: "p",
      darkModeSelector: "system",
      cssLayer: !1
    }
  },
  _theme: void 0,
  _layerNames: /* @__PURE__ */ new Set(),
  _loadedStyleNames: /* @__PURE__ */ new Set(),
  _loadingStyles: /* @__PURE__ */ new Set(),
  _tokens: {},
  update(e = {}) {
    const { theme: t } = e;
    t && (this._theme = Un(Ie({}, t), {
      options: Ie(Ie({}, this.defaults.options), t.options)
    }), this._tokens = Ee.createTokens(this.preset, this.defaults), this.clearLoadedStyleNames());
  },
  get theme() {
    return this._theme;
  },
  get preset() {
    var e;
    return ((e = this.theme) == null ? void 0 : e.preset) || {};
  },
  get options() {
    var e;
    return ((e = this.theme) == null ? void 0 : e.options) || {};
  },
  get tokens() {
    return this._tokens;
  },
  getTheme() {
    return this.theme;
  },
  setTheme(e) {
    this.update({ theme: e }), He.emit("theme:change", e);
  },
  getPreset() {
    return this.preset;
  },
  setPreset(e) {
    this._theme = Un(Ie({}, this.theme), { preset: e }), this._tokens = Ee.createTokens(e, this.defaults), this.clearLoadedStyleNames(), He.emit("preset:change", e), He.emit("theme:change", this.theme);
  },
  getOptions() {
    return this.options;
  },
  setOptions(e) {
    this._theme = Un(Ie({}, this.theme), { options: e }), this.clearLoadedStyleNames(), He.emit("options:change", e), He.emit("theme:change", this.theme);
  },
  getLayerNames() {
    return [...this._layerNames];
  },
  setLayerNames(e) {
    this._layerNames.add(e);
  },
  getLoadedStyleNames() {
    return this._loadedStyleNames;
  },
  isStyleNameLoaded(e) {
    return this._loadedStyleNames.has(e);
  },
  setLoadedStyleName(e) {
    this._loadedStyleNames.add(e);
  },
  deleteLoadedStyleName(e) {
    this._loadedStyleNames.delete(e);
  },
  clearLoadedStyleNames() {
    this._loadedStyleNames.clear();
  },
  getTokenValue(e) {
    return Ee.getTokenValue(this.tokens, e, this.defaults);
  },
  getCommon(e = "", t) {
    return Ee.getCommon({ name: e, theme: this.theme, params: t, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } });
  },
  getComponent(e = "", t) {
    const n = { name: e, theme: this.theme, params: t, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } };
    return Ee.getPresetC(n);
  },
  getDirective(e = "", t) {
    const n = { name: e, theme: this.theme, params: t, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } };
    return Ee.getPresetD(n);
  },
  getCustomPreset(e = "", t, n, r) {
    const s = { name: e, preset: t, options: this.options, selector: n, params: r, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } };
    return Ee.getPreset(s);
  },
  getLayerOrderCSS(e = "") {
    return Ee.getLayerOrder(e, this.options, { names: this.getLayerNames() }, this.defaults);
  },
  transformCSS(e = "", t, n = "style", r) {
    return Ee.transformCSS(e, t, r, n, this.options, { layerNames: this.setLayerNames.bind(this) }, this.defaults);
  },
  getCommonStyleSheet(e = "", t, n = {}) {
    return Ee.getCommonStyleSheet({ name: e, theme: this.theme, params: t, props: n, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } });
  },
  getStyleSheet(e, t, n = {}) {
    return Ee.getStyleSheet({ name: e, theme: this.theme, params: t, props: n, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } });
  },
  onStyleMounted(e) {
    this._loadingStyles.add(e);
  },
  onStyleUpdated(e) {
    this._loadingStyles.add(e);
  },
  onStyleLoaded(e, { name: t }) {
    this._loadingStyles.size && (this._loadingStyles.delete(t), He.emit(`theme:${t}:load`, e), !this._loadingStyles.size && He.emit("theme:load"));
  }
};
function mr(e) {
  return typeof HTMLElement == "object" ? e instanceof HTMLElement : e && typeof e == "object" && e !== null && e.nodeType === 1 && typeof e.nodeName == "string";
}
function Jn(e, t = {}) {
  if (mr(e)) {
    const n = (r, s) => {
      var o, i;
      const a = (o = e == null ? void 0 : e.$attrs) != null && o[r] ? [(i = e == null ? void 0 : e.$attrs) == null ? void 0 : i[r]] : [];
      return [s].flat().reduce((u, c) => {
        if (c != null) {
          const l = typeof c;
          if (l === "string" || l === "number")
            u.push(c);
          else if (l === "object") {
            const d = Array.isArray(c) ? n(r, c) : Object.entries(c).map(([g, m]) => r === "style" && (m || m === 0) ? `${g.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}:${m}` : m ? g : void 0);
            u = d.length ? u.concat(d.filter((g) => !!g)) : u;
          }
        }
        return u;
      }, a);
    };
    Object.entries(t).forEach(([r, s]) => {
      if (s != null) {
        const o = r.match(/^on(.+)/);
        o ? e.addEventListener(o[1].toLowerCase(), s) : r === "p-bind" || r === "pBind" ? Jn(e, s) : (s = r === "class" ? [...new Set(n("class", s))].join(" ").trim() : r === "style" ? n("style", s).join(";").trim() : s, (e.$attrs = e.$attrs || {}) && (e.$attrs[r] = s), e.setAttribute(r, s));
      }
    });
  }
}
function xc(e, t) {
  return mr(e) ? e.matches(t) ? e : e.querySelector(t) : null;
}
function Tc(e) {
  if (e) {
    let t = e.parentNode;
    return t && t instanceof ShadowRoot && t.host && (t = t.host), t;
  }
  return null;
}
function $c(e) {
  return !!(e !== null && typeof e < "u" && e.nodeName && Tc(e));
}
function eo() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function Oc(e, t = "", n) {
  mr(e) && n !== null && n !== void 0 && e.setAttribute(t, n);
}
var Xt = {};
function kc(e = "pui_id_") {
  return Xt.hasOwnProperty(e) || (Xt[e] = 0), Xt[e]++, `${e}${Xt[e]}`;
}
var St = {
  _loadedStyleNames: /* @__PURE__ */ new Set(),
  getLoadedStyleNames: function() {
    return this._loadedStyleNames;
  },
  isStyleNameLoaded: function(t) {
    return this._loadedStyleNames.has(t);
  },
  setLoadedStyleName: function(t) {
    this._loadedStyleNames.add(t);
  },
  deleteLoadedStyleName: function(t) {
    this._loadedStyleNames.delete(t);
  },
  clearLoadedStyleNames: function() {
    this._loadedStyleNames.clear();
  }
};
function qt(e) {
  "@babel/helpers - typeof";
  return qt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, qt(e);
}
function zr(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Hr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? zr(Object(n), !0).forEach(function(r) {
      Ec(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : zr(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Ec(e, t, n) {
  return (t = Ic(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Ic(e) {
  var t = Pc(e, "string");
  return qt(t) == "symbol" ? t : t + "";
}
function Pc(e, t) {
  if (qt(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (qt(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Rc(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  Wi() ? xn(e) : t ? e() : Yi(e);
}
var Ac = 0;
function jc(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = $e(!1), r = $e(e), s = $e(null), o = eo() ? window.document : void 0, i = t.document, a = i === void 0 ? o : i, u = t.immediate, c = u === void 0 ? !0 : u, l = t.manual, d = l === void 0 ? !1 : l, g = t.name, m = g === void 0 ? "style_".concat(++Ac) : g, b = t.id, f = b === void 0 ? void 0 : b, S = t.media, $ = S === void 0 ? void 0 : S, E = t.nonce, j = E === void 0 ? void 0 : E, D = t.first, I = D === void 0 ? !1 : D, M = t.onMounted, K = M === void 0 ? void 0 : M, J = t.onUpdated, q = J === void 0 ? void 0 : J, N = t.onLoad, h = N === void 0 ? void 0 : N, y = t.props, p = y === void 0 ? {} : y, v = function() {
  }, _ = function(O) {
    var A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (a) {
      var P = Hr(Hr({}, p), A), L = P.name || m, F = P.id || f, W = P.nonce || j;
      s.value = a.querySelector('style[data-primevue-style-id="'.concat(L, '"]')) || a.getElementById(F) || a.createElement("style"), s.value.isConnected || (r.value = O || e, Jn(s.value, {
        type: "text/css",
        id: F,
        media: $,
        nonce: W
      }), I ? a.head.prepend(s.value) : a.head.appendChild(s.value), Oc(s.value, "data-primevue-style-id", L), Jn(s.value, P), s.value.onload = function(B) {
        return h == null ? void 0 : h(B, {
          name: L
        });
      }, K == null || K(L)), !n.value && (v = Kn(r, function(B) {
        s.value.textContent = B, q == null || q(L);
      }, {
        immediate: !0
      }), n.value = !0);
    }
  }, w = function() {
    !a || !n.value || (v(), $c(s.value) && a.head.removeChild(s.value), n.value = !1);
  };
  return c && !d && Rc(_), {
    id: f,
    name: m,
    el: s,
    css: r,
    unload: w,
    load: _,
    isLoaded: Hi(n)
  };
}
function Ft(e) {
  "@babel/helpers - typeof";
  return Ft = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ft(e);
}
function Wr(e, t) {
  return Nc(e) || Mc(e, t) || Lc(e, t) || Dc();
}
function Dc() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Lc(e, t) {
  if (e) {
    if (typeof e == "string")
      return Yr(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Yr(e, t) : void 0;
  }
}
function Yr(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Mc(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, s, o, i, a = [], u = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0)
        for (; !(u = (r = o.call(n)).done) && (a.push(r.value), a.length !== t); u = !0)
          ;
    } catch (l) {
      c = !0, s = l;
    } finally {
      try {
        if (!u && n.return != null && (i = n.return(), Object(i) !== i))
          return;
      } finally {
        if (c)
          throw s;
      }
    }
    return a;
  }
}
function Nc(e) {
  if (Array.isArray(e))
    return e;
}
function Kr(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function qn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Kr(Object(n), !0).forEach(function(r) {
      Uc(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Kr(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Uc(e, t, n) {
  return (t = qc(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function qc(e) {
  var t = Fc(e, "string");
  return Ft(t) == "symbol" ? t : t + "";
}
function Fc(e, t) {
  if (Ft(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Ft(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Bc = function(t) {
  var n = t.dt;
  return `
*,
::before,
::after {
    box-sizing: border-box;
}

/* Non vue overlay animations */
.p-connected-overlay {
    opacity: 0;
    transform: scaleY(0.8);
    transition: transform 0.12s cubic-bezier(0, 0, 0.2, 1),
        opacity 0.12s cubic-bezier(0, 0, 0.2, 1);
}

.p-connected-overlay-visible {
    opacity: 1;
    transform: scaleY(1);
}

.p-connected-overlay-hidden {
    opacity: 0;
    transform: scaleY(1);
    transition: opacity 0.1s linear;
}

/* Vue based overlay animations */
.p-connected-overlay-enter-from {
    opacity: 0;
    transform: scaleY(0.8);
}

.p-connected-overlay-leave-to {
    opacity: 0;
}

.p-connected-overlay-enter-active {
    transition: transform 0.12s cubic-bezier(0, 0, 0.2, 1),
        opacity 0.12s cubic-bezier(0, 0, 0.2, 1);
}

.p-connected-overlay-leave-active {
    transition: opacity 0.1s linear;
}

/* Toggleable Content */
.p-toggleable-content-enter-from,
.p-toggleable-content-leave-to {
    max-height: 0;
}

.p-toggleable-content-enter-to,
.p-toggleable-content-leave-from {
    max-height: 1000px;
}

.p-toggleable-content-leave-active {
    overflow: hidden;
    transition: max-height 0.45s cubic-bezier(0, 1, 0, 1);
}

.p-toggleable-content-enter-active {
    overflow: hidden;
    transition: max-height 1s ease-in-out;
}

.p-disabled,
.p-disabled * {
    cursor: default;
    pointer-events: none;
    user-select: none;
}

.p-disabled,
.p-component:disabled {
    opacity: `.concat(n("disabled.opacity"), `;
}

.pi {
    font-size: `).concat(n("icon.size"), `;
}

.p-icon {
    width: `).concat(n("icon.size"), `;
    height: `).concat(n("icon.size"), `;
}

.p-overlay-mask {
    background: `).concat(n("mask.background"), `;
    color: `).concat(n("mask.color"), `;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.p-overlay-mask-enter {
    animation: p-overlay-mask-enter-animation `).concat(n("mask.transition.duration"), ` forwards;
}

.p-overlay-mask-leave {
    animation: p-overlay-mask-leave-animation `).concat(n("mask.transition.duration"), ` forwards;
}

@keyframes p-overlay-mask-enter-animation {
    from {
        background: transparent;
    }
    to {
        background: `).concat(n("mask.background"), `;
    }
}
@keyframes p-overlay-mask-leave-animation {
    from {
        background: `).concat(n("mask.background"), `;
    }
    to {
        background: transparent;
    }
}
`);
}, Vc = function(t) {
  var n = t.dt;
  return `
.p-hidden-accessible {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
}

.p-hidden-accessible input,
.p-hidden-accessible select {
    transform: scale(0);
}

.p-overflow-hidden {
    overflow: hidden;
    padding-right: `.concat(n("scrollbar.width"), `;
}
`);
}, zc = {}, Hc = {}, Ce = {
  name: "base",
  css: Vc,
  theme: Bc,
  classes: zc,
  inlineStyles: Hc,
  load: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function(o) {
      return o;
    }, s = r(Pe(t, {
      dt: jt
    }));
    return re(s) ? jc(At(s), qn({
      name: this.name
    }, n)) : {};
  },
  loadCSS: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return this.load(this.css, t);
  },
  loadTheme: function() {
    var t = this, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return this.load(this.theme, n, function() {
      var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
      return he.transformCSS(n.name || t.name, "".concat(s).concat(r));
    });
  },
  getCommonTheme: function(t) {
    return he.getCommon(this.name, t);
  },
  getComponentTheme: function(t) {
    return he.getComponent(this.name, t);
  },
  getDirectiveTheme: function(t) {
    return he.getDirective(this.name, t);
  },
  getPresetTheme: function(t, n, r) {
    return he.getCustomPreset(this.name, t, n, r);
  },
  getLayerOrderThemeCSS: function() {
    return he.getLayerOrderCSS(this.name);
  },
  getStyleSheet: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.css) {
      var r = Pe(this.css, {
        dt: jt
      }) || "", s = At("".concat(r).concat(t)), o = Object.entries(n).reduce(function(i, a) {
        var u = Wr(a, 2), c = u[0], l = u[1];
        return i.push("".concat(c, '="').concat(l, '"')) && i;
      }, []).join(" ");
      return re(s) ? '<style type="text/css" data-primevue-style-id="'.concat(this.name, '" ').concat(o, ">").concat(s, "</style>") : "";
    }
    return "";
  },
  getCommonThemeStyleSheet: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return he.getCommonStyleSheet(this.name, t, n);
  },
  getThemeStyleSheet: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = [he.getStyleSheet(this.name, t, n)];
    if (this.theme) {
      var s = this.name === "base" ? "global-style" : "".concat(this.name, "-style"), o = Pe(this.theme, {
        dt: jt
      }), i = At(he.transformCSS(s, o)), a = Object.entries(n).reduce(function(u, c) {
        var l = Wr(c, 2), d = l[0], g = l[1];
        return u.push("".concat(d, '="').concat(g, '"')) && u;
      }, []).join(" ");
      re(i) && r.push('<style type="text/css" data-primevue-style-id="'.concat(s, '" ').concat(a, ">").concat(i, "</style>"));
    }
    return r.join("");
  },
  extend: function(t) {
    return qn(qn({}, this), {}, {
      css: void 0,
      theme: void 0
    }, t);
  }
}, Gr = Ce.extend({
  name: "common"
});
function Bt(e) {
  "@babel/helpers - typeof";
  return Bt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Bt(e);
}
function Wc(e) {
  return ro(e) || Yc(e) || no(e) || to();
}
function Yc(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Ct(e, t) {
  return ro(e) || Kc(e, t) || no(e, t) || to();
}
function to() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function no(e, t) {
  if (e) {
    if (typeof e == "string")
      return Jr(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Jr(e, t) : void 0;
  }
}
function Jr(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Kc(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, s, o, i, a = [], u = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n)
          return;
        u = !1;
      } else
        for (; !(u = (r = o.call(n)).done) && (a.push(r.value), a.length !== t); u = !0)
          ;
    } catch (l) {
      c = !0, s = l;
    } finally {
      try {
        if (!u && n.return != null && (i = n.return(), Object(i) !== i))
          return;
      } finally {
        if (c)
          throw s;
      }
    }
    return a;
  }
}
function ro(e) {
  if (Array.isArray(e))
    return e;
}
function Zr(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function G(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Zr(Object(n), !0).forEach(function(r) {
      Tt(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Zr(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Tt(e, t, n) {
  return (t = Gc(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Gc(e) {
  var t = Jc(e, "string");
  return Bt(t) == "symbol" ? t : t + "";
}
function Jc(e, t) {
  if (Bt(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Bt(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var En = {
  name: "BaseComponent",
  props: {
    pt: {
      type: Object,
      default: void 0
    },
    ptOptions: {
      type: Object,
      default: void 0
    },
    unstyled: {
      type: Boolean,
      default: void 0
    },
    dt: {
      type: Object,
      default: void 0
    }
  },
  inject: {
    $parentInstance: {
      default: void 0
    }
  },
  watch: {
    isUnstyled: {
      immediate: !0,
      handler: function(t) {
        t || (this._loadCoreStyles(), this._themeChangeListener(this._loadCoreStyles));
      }
    },
    dt: {
      immediate: !0,
      handler: function(t) {
        var n = this;
        t ? (this._loadScopedThemeStyles(t), this._themeChangeListener(function() {
          return n._loadScopedThemeStyles(t);
        })) : this._unloadScopedThemeStyles();
      }
    }
  },
  scopedStyleEl: void 0,
  rootEl: void 0,
  $attrSelector: void 0,
  beforeCreate: function() {
    var t, n, r, s, o, i, a, u, c, l, d, g = (t = this.pt) === null || t === void 0 ? void 0 : t._usept, m = g ? (n = this.pt) === null || n === void 0 || (n = n.originalValue) === null || n === void 0 ? void 0 : n[this.$.type.name] : void 0, b = g ? (r = this.pt) === null || r === void 0 || (r = r.value) === null || r === void 0 ? void 0 : r[this.$.type.name] : this.pt;
    (s = b || m) === null || s === void 0 || (s = s.hooks) === null || s === void 0 || (o = s.onBeforeCreate) === null || o === void 0 || o.call(s);
    var f = (i = this.$primevueConfig) === null || i === void 0 || (i = i.pt) === null || i === void 0 ? void 0 : i._usept, S = f ? (a = this.$primevue) === null || a === void 0 || (a = a.config) === null || a === void 0 || (a = a.pt) === null || a === void 0 ? void 0 : a.originalValue : void 0, $ = f ? (u = this.$primevue) === null || u === void 0 || (u = u.config) === null || u === void 0 || (u = u.pt) === null || u === void 0 ? void 0 : u.value : (c = this.$primevue) === null || c === void 0 || (c = c.config) === null || c === void 0 ? void 0 : c.pt;
    (l = $ || S) === null || l === void 0 || (l = l[this.$.type.name]) === null || l === void 0 || (l = l.hooks) === null || l === void 0 || (d = l.onBeforeCreate) === null || d === void 0 || d.call(l), this.$attrSelector = kc("pc");
  },
  created: function() {
    this._hook("onCreated");
  },
  beforeMount: function() {
    this.rootEl = xc(this.$el, '[data-pc-name="'.concat(Ke(this.$.type.name), '"]')), this.rootEl && (this.$attrSelector && !this.rootEl.hasAttribute(this.$attrSelector) && this.rootEl.setAttribute(this.$attrSelector, ""), this.rootEl.$pc = G({
      name: this.$.type.name,
      attrSelector: this.$attrSelector
    }, this.$params)), this._loadStyles(), this._hook("onBeforeMount");
  },
  mounted: function() {
    this._hook("onMounted");
  },
  beforeUpdate: function() {
    this._hook("onBeforeUpdate");
  },
  updated: function() {
    this._hook("onUpdated");
  },
  beforeUnmount: function() {
    this._hook("onBeforeUnmount");
  },
  unmounted: function() {
    this._unloadScopedThemeStyles(), this._hook("onUnmounted");
  },
  methods: {
    _hook: function(t) {
      if (!this.$options.hostName) {
        var n = this._usePT(this._getPT(this.pt, this.$.type.name), this._getOptionValue, "hooks.".concat(t)), r = this._useDefaultPT(this._getOptionValue, "hooks.".concat(t));
        n == null || n(), r == null || r();
      }
    },
    _mergeProps: function(t) {
      for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), s = 1; s < n; s++)
        r[s - 1] = arguments[s];
      return Ys(t) ? t.apply(void 0, r) : me.apply(void 0, r);
    },
    _loadStyles: function() {
      var t = this, n = function() {
        St.isStyleNameLoaded("base") || (Ce.loadCSS(t.$styleOptions), t._loadGlobalStyles(), St.setLoadedStyleName("base")), t._loadThemeStyles();
      };
      n(), this._themeChangeListener(n);
    },
    _loadCoreStyles: function() {
      var t, n;
      !St.isStyleNameLoaded((t = this.$style) === null || t === void 0 ? void 0 : t.name) && (n = this.$style) !== null && n !== void 0 && n.name && (Gr.loadCSS(this.$styleOptions), this.$options.style && this.$style.loadCSS(this.$styleOptions), St.setLoadedStyleName(this.$style.name));
    },
    _loadGlobalStyles: function() {
      var t = this._useGlobalPT(this._getOptionValue, "global.css", this.$params);
      re(t) && Ce.load(t, G({
        name: "global"
      }, this.$styleOptions));
    },
    _loadThemeStyles: function() {
      var t, n;
      if (!(this.isUnstyled || this.$theme === "none")) {
        if (!he.isStyleNameLoaded("common")) {
          var r, s, o = ((r = this.$style) === null || r === void 0 || (s = r.getCommonTheme) === null || s === void 0 ? void 0 : s.call(r)) || {}, i = o.primitive, a = o.semantic, u = o.global, c = o.style;
          Ce.load(i == null ? void 0 : i.css, G({
            name: "primitive-variables"
          }, this.$styleOptions)), Ce.load(a == null ? void 0 : a.css, G({
            name: "semantic-variables"
          }, this.$styleOptions)), Ce.load(u == null ? void 0 : u.css, G({
            name: "global-variables"
          }, this.$styleOptions)), Ce.loadTheme(G({
            name: "global-style"
          }, this.$styleOptions), c), he.setLoadedStyleName("common");
        }
        if (!he.isStyleNameLoaded((t = this.$style) === null || t === void 0 ? void 0 : t.name) && (n = this.$style) !== null && n !== void 0 && n.name) {
          var l, d, g, m, b = ((l = this.$style) === null || l === void 0 || (d = l.getComponentTheme) === null || d === void 0 ? void 0 : d.call(l)) || {}, f = b.css, S = b.style;
          (g = this.$style) === null || g === void 0 || g.load(f, G({
            name: "".concat(this.$style.name, "-variables")
          }, this.$styleOptions)), (m = this.$style) === null || m === void 0 || m.loadTheme(G({
            name: "".concat(this.$style.name, "-style")
          }, this.$styleOptions), S), he.setLoadedStyleName(this.$style.name);
        }
        if (!he.isStyleNameLoaded("layer-order")) {
          var $, E, j = ($ = this.$style) === null || $ === void 0 || (E = $.getLayerOrderThemeCSS) === null || E === void 0 ? void 0 : E.call($);
          Ce.load(j, G({
            name: "layer-order",
            first: !0
          }, this.$styleOptions)), he.setLoadedStyleName("layer-order");
        }
      }
    },
    _loadScopedThemeStyles: function(t) {
      var n, r, s, o = ((n = this.$style) === null || n === void 0 || (r = n.getPresetTheme) === null || r === void 0 ? void 0 : r.call(n, t, "[".concat(this.$attrSelector, "]"))) || {}, i = o.css, a = (s = this.$style) === null || s === void 0 ? void 0 : s.load(i, G({
        name: "".concat(this.$attrSelector, "-").concat(this.$style.name)
      }, this.$styleOptions));
      this.scopedStyleEl = a.el;
    },
    _unloadScopedThemeStyles: function() {
      var t;
      (t = this.scopedStyleEl) === null || t === void 0 || (t = t.value) === null || t === void 0 || t.remove();
    },
    _themeChangeListener: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
      };
      St.clearLoadedStyleNames(), He.on("theme:change", t);
    },
    _getHostInstance: function(t) {
      return t ? this.$options.hostName ? t.$.type.name === this.$options.hostName ? t : this._getHostInstance(t.$parentInstance) : t.$parentInstance : void 0;
    },
    _getPropValue: function(t) {
      var n;
      return this[t] || ((n = this._getHostInstance(this)) === null || n === void 0 ? void 0 : n[t]);
    },
    _getOptionValue: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      return Ks(t, n, r);
    },
    _getPTValue: function() {
      var t, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0, i = /./g.test(r) && !!s[r.split(".")[0]], a = this._getPropValue("ptOptions") || ((t = this.$primevueConfig) === null || t === void 0 ? void 0 : t.ptOptions) || {}, u = a.mergeSections, c = u === void 0 ? !0 : u, l = a.mergeProps, d = l === void 0 ? !1 : l, g = o ? i ? this._useGlobalPT(this._getPTClassValue, r, s) : this._useDefaultPT(this._getPTClassValue, r, s) : void 0, m = i ? void 0 : this._getPTSelf(n, this._getPTClassValue, r, G(G({}, s), {}, {
        global: g || {}
      })), b = this._getPTDatasets(r);
      return c || !c && m ? d ? this._mergeProps(d, g, m, b) : G(G(G({}, g), m), b) : G(G({}, m), b);
    },
    _getPTSelf: function() {
      for (var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), s = 1; s < n; s++)
        r[s - 1] = arguments[s];
      return me(
        this._usePT.apply(this, [this._getPT(t, this.$name)].concat(r)),
        // Exp; <component :pt="{}"
        this._usePT.apply(this, [this.$_attrsPT].concat(r))
        // Exp; <component :pt:[passthrough_key]:[attribute]="{value}" or <component :pt:[passthrough_key]="() =>{value}"
      );
    },
    _getPTDatasets: function() {
      var t, n, r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", s = "data-pc-", o = r === "root" && re((t = this.pt) === null || t === void 0 ? void 0 : t["data-pc-section"]);
      return r !== "transition" && G(G({}, r === "root" && G(G(Tt({}, "".concat(s, "name"), Ke(o ? (n = this.pt) === null || n === void 0 ? void 0 : n["data-pc-section"] : this.$.type.name)), o && Tt({}, "".concat(s, "extend"), Ke(this.$.type.name))), eo() && Tt({}, "".concat(this.$attrSelector), ""))), {}, Tt({}, "".concat(s, "section"), Ke(r)));
    },
    _getPTClassValue: function() {
      var t = this._getOptionValue.apply(this, arguments);
      return Ne(t) || hr(t) ? {
        class: t
      } : t;
    },
    _getPT: function(t) {
      var n = this, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", s = arguments.length > 2 ? arguments[2] : void 0, o = function(a) {
        var u, c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, l = s ? s(a) : a, d = Ke(r), g = Ke(n.$name);
        return (u = c ? d !== g ? l == null ? void 0 : l[d] : void 0 : l == null ? void 0 : l[d]) !== null && u !== void 0 ? u : l;
      };
      return t != null && t.hasOwnProperty("_usept") ? {
        _usept: t._usept,
        originalValue: o(t.originalValue),
        value: o(t.value)
      } : o(t, !0);
    },
    _usePT: function(t, n, r, s) {
      var o = function(f) {
        return n(f, r, s);
      };
      if (t != null && t.hasOwnProperty("_usept")) {
        var i, a = t._usept || ((i = this.$primevueConfig) === null || i === void 0 ? void 0 : i.ptOptions) || {}, u = a.mergeSections, c = u === void 0 ? !0 : u, l = a.mergeProps, d = l === void 0 ? !1 : l, g = o(t.originalValue), m = o(t.value);
        return g === void 0 && m === void 0 ? void 0 : Ne(m) ? m : Ne(g) ? g : c || !c && m ? d ? this._mergeProps(d, g, m) : G(G({}, g), m) : m;
      }
      return o(t);
    },
    _useGlobalPT: function(t, n, r) {
      return this._usePT(this.globalPT, t, n, r);
    },
    _useDefaultPT: function(t, n, r) {
      return this._usePT(this.defaultPT, t, n, r);
    },
    ptm: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return this._getPTValue(this.pt, t, G(G({}, this.$params), n));
    },
    ptmi: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return me(this.$_attrsWithoutPT, this.ptm(t, n));
    },
    ptmo: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      return this._getPTValue(t, n, G({
        instance: this
      }, r), !1);
    },
    cx: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return this.isUnstyled ? void 0 : this._getOptionValue(this.$style.classes, t, G(G({}, this.$params), n));
    },
    sx: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      if (n) {
        var s = this._getOptionValue(this.$style.inlineStyles, t, G(G({}, this.$params), r)), o = this._getOptionValue(Gr.inlineStyles, t, G(G({}, this.$params), r));
        return [o, s];
      }
    }
  },
  computed: {
    globalPT: function() {
      var t, n = this;
      return this._getPT((t = this.$primevueConfig) === null || t === void 0 ? void 0 : t.pt, void 0, function(r) {
        return Pe(r, {
          instance: n
        });
      });
    },
    defaultPT: function() {
      var t, n = this;
      return this._getPT((t = this.$primevueConfig) === null || t === void 0 ? void 0 : t.pt, void 0, function(r) {
        return n._getOptionValue(r, n.$name, G({}, n.$params)) || Pe(r, G({}, n.$params));
      });
    },
    isUnstyled: function() {
      var t;
      return this.unstyled !== void 0 ? this.unstyled : (t = this.$primevueConfig) === null || t === void 0 ? void 0 : t.unstyled;
    },
    $inProps: function() {
      var t, n = Object.keys(((t = this.$.vnode) === null || t === void 0 ? void 0 : t.props) || {});
      return Object.fromEntries(Object.entries(this.$props).filter(function(r) {
        var s = Ct(r, 1), o = s[0];
        return n == null ? void 0 : n.includes(o);
      }));
    },
    $theme: function() {
      var t;
      return (t = this.$primevueConfig) === null || t === void 0 ? void 0 : t.theme;
    },
    $style: function() {
      return G(G({
        classes: void 0,
        inlineStyles: void 0,
        load: function() {
        },
        loadCSS: function() {
        },
        loadTheme: function() {
        }
      }, (this._getHostInstance(this) || {}).$style), this.$options.style);
    },
    $styleOptions: function() {
      var t;
      return {
        nonce: (t = this.$primevueConfig) === null || t === void 0 || (t = t.csp) === null || t === void 0 ? void 0 : t.nonce
      };
    },
    $primevueConfig: function() {
      var t;
      return (t = this.$primevue) === null || t === void 0 ? void 0 : t.config;
    },
    $name: function() {
      return this.$options.hostName || this.$.type.name;
    },
    $params: function() {
      var t = this._getHostInstance(this) || this.$parent;
      return {
        instance: this,
        props: this.$props,
        state: this.$data,
        attrs: this.$attrs,
        parent: {
          instance: t,
          props: t == null ? void 0 : t.$props,
          state: t == null ? void 0 : t.$data,
          attrs: t == null ? void 0 : t.$attrs
        }
      };
    },
    $_attrsPT: function() {
      return Object.entries(this.$attrs || {}).filter(function(t) {
        var n = Ct(t, 1), r = n[0];
        return r == null ? void 0 : r.startsWith("pt:");
      }).reduce(function(t, n) {
        var r = Ct(n, 2), s = r[0], o = r[1], i = s.split(":"), a = Wc(i), u = a.slice(1);
        return u == null || u.reduce(function(c, l, d, g) {
          return !c[l] && (c[l] = d === g.length - 1 ? o : {}), c[l];
        }, t), t;
      }, {});
    },
    $_attrsWithoutPT: function() {
      return Object.entries(this.$attrs || {}).filter(function(t) {
        var n = Ct(t, 1), r = n[0];
        return !(r != null && r.startsWith("pt:"));
      }).reduce(function(t, n) {
        var r = Ct(n, 2), s = r[0], o = r[1];
        return t[s] = o, t;
      }, {});
    }
  }
}, Zc = function(t) {
  var n = t.dt;
  return `
.p-badge {
    display: inline-flex;
    border-radius: `.concat(n("badge.border.radius"), `;
    align-items: center;
    justify-content: center;
    padding: `).concat(n("badge.padding"), `;
    background: `).concat(n("badge.primary.background"), `;
    color: `).concat(n("badge.primary.color"), `;
    font-size: `).concat(n("badge.font.size"), `;
    font-weight: `).concat(n("badge.font.weight"), `;
    min-width: `).concat(n("badge.min.width"), `;
    height: `).concat(n("badge.height"), `;
}

.p-badge-dot {
    width: `).concat(n("badge.dot.size"), `;
    min-width: `).concat(n("badge.dot.size"), `;
    height: `).concat(n("badge.dot.size"), `;
    border-radius: 50%;
    padding: 0;
}

.p-badge-circle {
    padding: 0;
    border-radius: 50%;
}

.p-badge-secondary {
    background: `).concat(n("badge.secondary.background"), `;
    color: `).concat(n("badge.secondary.color"), `;
}

.p-badge-success {
    background: `).concat(n("badge.success.background"), `;
    color: `).concat(n("badge.success.color"), `;
}

.p-badge-info {
    background: `).concat(n("badge.info.background"), `;
    color: `).concat(n("badge.info.color"), `;
}

.p-badge-warn {
    background: `).concat(n("badge.warn.background"), `;
    color: `).concat(n("badge.warn.color"), `;
}

.p-badge-danger {
    background: `).concat(n("badge.danger.background"), `;
    color: `).concat(n("badge.danger.color"), `;
}

.p-badge-contrast {
    background: `).concat(n("badge.contrast.background"), `;
    color: `).concat(n("badge.contrast.color"), `;
}

.p-badge-sm {
    font-size: `).concat(n("badge.sm.font.size"), `;
    min-width: `).concat(n("badge.sm.min.width"), `;
    height: `).concat(n("badge.sm.height"), `;
}

.p-badge-lg {
    font-size: `).concat(n("badge.lg.font.size"), `;
    min-width: `).concat(n("badge.lg.min.width"), `;
    height: `).concat(n("badge.lg.height"), `;
}

.p-badge-xl {
    font-size: `).concat(n("badge.xl.font.size"), `;
    min-width: `).concat(n("badge.xl.min.width"), `;
    height: `).concat(n("badge.xl.height"), `;
}
`);
}, Xc = {
  root: function(t) {
    var n = t.props, r = t.instance;
    return ["p-badge p-component", {
      "p-badge-circle": re(n.value) && String(n.value).length === 1,
      "p-badge-dot": kn(n.value) && !r.$slots.default,
      "p-badge-sm": n.size === "small",
      "p-badge-lg": n.size === "large",
      "p-badge-xl": n.size === "xlarge",
      "p-badge-info": n.severity === "info",
      "p-badge-success": n.severity === "success",
      "p-badge-warn": n.severity === "warn",
      "p-badge-danger": n.severity === "danger",
      "p-badge-secondary": n.severity === "secondary",
      "p-badge-contrast": n.severity === "contrast"
    }];
  }
}, Qc = Ce.extend({
  name: "badge",
  theme: Zc,
  classes: Xc
}), eu = {
  name: "BaseBadge",
  extends: En,
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    severity: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  style: Qc,
  provide: function() {
    return {
      $pcBadge: this,
      $parentInstance: this
    };
  }
}, gr = {
  name: "Badge",
  extends: eu,
  inheritAttrs: !1
};
function tu(e, t, n, r, s, o) {
  return R(), Y("span", me({
    class: e.cx("root")
  }, e.ptmi("root")), [le(e.$slots, "default", {}, function() {
    return [dr(Le(e.value), 1)];
  })], 16);
}
gr.render = tu;
var nu = function(t) {
  var n = t.dt;
  return `
.p-overlaybadge {
    position: relative;
}

.p-overlaybadge .p-badge {
    position: absolute;
    inset-block-start: 0;
    inset-inline-end: 0;
    transform: translate(50%, -50%);
    transform-origin: 100% 0;
    margin: 0;
    outline-width: `.concat(n("overlaybadge.outline.width"), `;
    outline-style: solid;
    outline-color: `).concat(n("overlaybadge.outline.color"), `;
}

.p-overlaybadge .p-badge:dir(rtl) {
    transform: translate(-50%, -50%);
}
`);
}, ru = {
  root: "p-overlaybadge"
}, su = Ce.extend({
  name: "overlaybadge",
  theme: nu,
  classes: ru
}), ou = {
  name: "OverlayBadge",
  extends: gr,
  style: su,
  provide: function() {
    return {
      $pcOverlayBadge: this,
      $parentInstance: this
    };
  }
}, bn = {
  name: "OverlayBadge",
  extends: ou,
  inheritAttrs: !1,
  components: {
    Badge: gr
  }
};
function iu(e, t, n, r, s, o) {
  var i = Ki("Badge");
  return R(), Y("div", me({
    class: e.cx("root")
  }, e.ptmi("root")), [le(e.$slots, "default"), be(i, me(e.$props, {
    pt: e.ptm("pcBadge")
  }), null, 16, ["pt"])], 16);
}
bn.render = iu;
const au = /* @__PURE__ */ ne({
  __name: "IntegrationSourceBadge",
  props: {
    integrationSource: {},
    hasFrameAgreement: { type: Boolean },
    hideExcludedSources: { type: Boolean }
  },
  setup(e) {
    const t = {
      FRAME_AGREEMENT: "Rammeavtale",
      SUPPLIER_ADMIN: "Leverandøradmin"
    }, n = {
      PORTAL: "portal",
      SUPPLIER_ADMIN: "supplierAdmin"
    }, r = e, s = (a) => !a || r.hideExcludedSources && (a === "famac" || a === "fdvWeb") ? null : a === n.SUPPLIER_ADMIN ? t.SUPPLIER_ADMIN : a !== n.PORTAL ? a : null, o = (a) => ({
      text: a,
      type: "text"
    }), i = T(() => {
      const a = [];
      r.hasFrameAgreement && a.push(o(t.FRAME_AGREEMENT));
      const u = s(
        r.integrationSource
      );
      return u && a.push(o(u)), a;
    });
    return (a, u) => (R(!0), Y(Ut, null, lr(i.value, (c, l) => (R(), Y("div", {
      key: l,
      class: "badge"
    }, Le(c.text), 1))), 128));
  }
}), so = /* @__PURE__ */ Te(au, [["__scopeId", "data-v-9ec6ec03"]]), cu = ["src"], uu = { class: "supplier-tender-list-item__widgets" }, lu = { class: "supplier-tender-list-item__left-widgets" }, du = { class: "supplier-tender-list-item__right-widgets" }, pu = {
  key: 0,
  class: "supplier-tender-list-item__messages-widget"
}, fu = /* @__PURE__ */ ne({
  __name: "SupplierTenderListItem",
  props: {
    serviceTypesCms: {},
    tender: {},
    priceRequestId: {},
    supplierId: {},
    supplierUsers: {},
    collapsed: { type: Boolean, default: !0 },
    listItemId: { default: void 0 },
    showNewRequestWidget: { type: Boolean, default: !1 },
    showUnreadMessagesWidget: { type: Boolean, default: !1 },
    showUnreadMessagesBadge: { type: Boolean, default: !1 },
    showCustomerChoseAnotherSupplierWidget: { type: Boolean, default: !1 },
    showNewAgreementWidget: { type: Boolean, default: !1 }
  },
  emits: [
    "clicked",
    "customerChoseAnotherSupplierWidgetClicked",
    "newAgreementWidgetClicked"
  ],
  setup(e, { emit: t }) {
    const n = t, r = e, {
      getPageCms: s,
      getServiceTypeCms: o,
      getServiceCategoryCms: i,
      getServiceName: a,
      getServiceIcon: u
    } = ce(), c = Tn({
      cms: void 0
    }), l = T(
      () => r.tender.priceRequests.find(
        (p) => p.id === r.priceRequestId
      )
    ), d = T(() => {
      var v;
      const p = (v = l.value) == null ? void 0 : v.supplierRequests;
      return p == null ? void 0 : p.find(
        (_) => _.supplierId === r.supplierId
      );
    }), g = T(() => {
      var p;
      return ((p = d.value) == null ? void 0 : p.hasFrameAgreement) || !1;
    }), m = T(() => {
      var p;
      return ((p = d.value) == null ? void 0 : p.requestEstimates) || !1;
    }), b = T(() => {
      var v;
      const p = (v = l.value) == null ? void 0 : v.supplierRequests;
      return p != null && p.length ? p[0].agreementOwnerUserId : "";
    }), f = T(
      () => {
        var p;
        return o(
          r.serviceTypesCms,
          (p = l.value) == null ? void 0 : p.serviceTypeLabel
        );
      }
    ), S = T(
      () => {
        var p;
        return i(
          r.serviceTypesCms,
          (p = l.value) == null ? void 0 : p.serviceCategoryLabel
        );
      }
    ), $ = T(() => r.tender.customerOrganizationName || ""), E = T(() => {
      var p;
      return ((p = l.value) == null ? void 0 : p.customerPropertyAddress) || "";
    }), j = T(() => {
      var w, x, O, A;
      const p = a(
        r.serviceTypesCms,
        (w = l.value) == null ? void 0 : w.serviceCategoryLabel
      ), _ = [`#${(x = r.tender.acceptedOfferReferences) != null && x.length && (((O = d.value) == null ? void 0 : O.requestState) === Q.Accepted || ((A = d.value) == null ? void 0 : A.requestState) === Q.Completed) ? r.tender.acceptedOfferReferences[0] : r.tender.externalTenderId}`];
      return p && _.unshift(p), _.join(" - ");
    }), D = T(() => u(S.value, f.value)), I = T(() => {
      var p, v, _;
      return ((p = d.value) == null ? void 0 : p.requestState) === Q.InformationRequested || ((v = d.value) == null ? void 0 : v.requestState) === Q.PriceRequested || ((_ = d.value) == null ? void 0 : _.requestState) === Q.Offered;
    }), M = T(() => {
      var p, v, _;
      return ((p = d.value) == null ? void 0 : p.requestState) === Q.InformationRequested || ((v = d.value) == null ? void 0 : v.requestState) === Q.PriceRequested || ((_ = d.value) == null ? void 0 : _.requestState) === Q.Offered;
    }), K = T(() => !1), J = T(() => {
      var p;
      return ((p = d.value) == null ? void 0 : p.requestState) === Q.Completed;
    }), q = T(() => r.showUnreadMessagesWidget || r.showNewRequestWidget || r.showCustomerChoseAnotherSupplierWidget || r.showNewAgreementWidget), N = T(() => {
      var p;
      return ((p = l.value) == null ? void 0 : p.unreadMessagesCount) || 0;
    }), h = T(() => r.showUnreadMessagesBadge);
    return (async () => {
      c.cms = await s(qe.SUPPLIER_TENDER_LIST_ITEM);
    })(), (p, v) => (R(), z(pr, {
      "tertiary-text": j.value,
      headline: $.value,
      "secondary-text": E.value,
      interaction: "collapsible",
      collapsed: p.collapsed,
      "list-item-id": p.listItemId,
      onClicked: v[0] || (v[0] = (_) => n("clicked"))
    }, {
      leadingVisual: oe(() => [
        D.value ? (R(), Y("img", {
          key: 0,
          src: D.value,
          alt: "Service icon"
        }, null, 8, cu)) : te("", !0)
      ]),
      widgets: oe(() => [
        U("div", uu, [
          U("div", lu, [
            be(so, {
              "integration-source": p.tender.integrationSource,
              "has-frame-agreement": g.value
            }, null, 8, ["integration-source", "has-frame-agreement"])
          ]),
          U("div", du, [
            q.value ? (R(), Y(Ut, { key: 0 }, [
              p.showUnreadMessagesWidget ? (R(), z(lc, { key: 0 })) : te("", !0),
              p.showNewRequestWidget ? (R(), z(ic, {
                key: 1,
                "request-estimates": m.value
              }, null, 8, ["request-estimates"])) : te("", !0),
              p.showCustomerChoseAnotherSupplierWidget ? (R(), z(za, { key: 2 })) : te("", !0),
              p.showNewAgreementWidget ? (R(), z(ec, { key: 3 })) : te("", !0)
            ], 64)) : (R(), Y(Ut, { key: 1 }, [
              h.value ? (R(), Y("div", pu, [
                N.value > 0 ? (R(), z(Me(bn), {
                  key: 0,
                  severity: "danger",
                  value: N.value
                }, {
                  default: oe(() => v[1] || (v[1] = [
                    U("i", { class: "pi pi-envelope supplier-tender-list-item__message s-icon" }, null, -1)
                  ])),
                  _: 1
                }, 8, ["value"])) : (R(), z(Me(bn), { key: 1 }, {
                  default: oe(() => v[2] || (v[2] = [
                    U("i", { class: "pi pi-envelope supplier-tender-list-item__messages-icon" }, null, -1)
                  ])),
                  _: 1
                }))
              ])) : te("", !0),
              be(Pa, {
                "agreement-owner-user-id": b.value,
                "supplier-users": p.supplierUsers,
                cms: c.cms
              }, null, 8, ["agreement-owner-user-id", "supplier-users", "cms"]),
              d.value ? (R(), z(dc, {
                key: 1,
                "request-state": d.value.requestState,
                "offers-count": d.value.offerCount,
                cms: c.cms,
                "request-estimates": m.value
              }, null, 8, ["request-state", "offers-count", "cms", "request-estimates"])) : te("", !0),
              M.value ? (R(), z(Ma, {
                key: 2,
                tender: p.tender,
                cms: c.cms
              }, null, 8, ["tender", "cms"])) : K.value ? (R(), z(Na, {
                key: 3,
                tender: p.tender,
                cms: c.cms
              }, null, 8, ["tender", "cms"])) : d.value && J.value ? (R(), z(Ua, {
                key: 4,
                "supplier-request": d.value,
                cms: c.cms
              }, null, 8, ["supplier-request", "cms"])) : te("", !0),
              I.value ? (R(), z(La, {
                key: 5,
                tender: p.tender,
                "price-request-id": p.priceRequestId,
                "supplier-id": p.supplierId,
                cms: c.cms
              }, null, 8, ["tender", "price-request-id", "supplier-id", "cms"])) : te("", !0)
            ], 64))
          ])
        ])
      ]),
      collapseContent: oe(() => [
        le(p.$slots, "collapseContent", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["tertiary-text", "headline", "secondary-text", "collapsed", "list-item-id"]));
  }
}), Mh = /* @__PURE__ */ Te(fu, [["__scopeId", "data-v-42e1ce10"]]);
var oo = /* @__PURE__ */ ((e) => (e[e.Invoice = 0] = "Invoice", e[e.CreditNote = 1] = "CreditNote", e))(oo || {}), Be = /* @__PURE__ */ ((e) => (e[e.Unpaid = 42003] = "Unpaid", e[e.Overdue = 42002] = "Overdue", e[e.Paid = 42004] = "Paid", e[e.Credited = 42006] = "Credited", e))(Be || {});
const hu = /* @__PURE__ */ ne({
  __name: "InvoiceStakeholderWidget",
  props: {
    primaryName: {},
    secondaryName: {},
    cms: {}
  },
  setup(e) {
    const t = e, { getCmsItem: n, getIconUrl: r } = ce(), s = T(
      () => {
        var i;
        return n((i = t.cms) == null ? void 0 : i.pageSections, "invoiceSupplierSection");
      }
    ), o = T(() => {
      var u;
      const i = (u = s.value) == null ? void 0 : u.icons, a = (i == null ? void 0 : i.find((c) => c.label === "supplier")) ?? (i == null ? void 0 : i[0]);
      return a ? r(a) : "";
    });
    return (i, a) => (R(), z(we, {
      "primary-text": i.primaryName,
      "secondary-text": i.secondaryName,
      "widget-cms": s.value,
      "widget-icon-url": o.value
    }, null, 8, ["primary-text", "secondary-text", "widget-cms", "widget-icon-url"]));
  }
}), mu = /* @__PURE__ */ ne({
  __name: "InvoiceDateWidget",
  props: {
    date: {},
    dueDate: {},
    cms: {}
  },
  setup(e) {
    const t = e, { getCmsItem: n, getIconUrl: r } = ce(), s = T(
      () => {
        var u;
        return n((u = t.cms) == null ? void 0 : u.pageSections, "invoiceDateSection");
      }
    ), o = T(() => {
      const u = t.date;
      return ie(u).format("DD.MM.YYYY");
    }), i = T(() => {
      var u;
      return n((u = s.value) == null ? void 0 : u.otherText, "dateLabel");
    }), a = T(() => {
      var l;
      const u = (l = s.value) == null ? void 0 : l.icons, c = (u == null ? void 0 : u.find((d) => d.label === "send")) ?? (u == null ? void 0 : u[0]);
      return c ? r(c) : "";
    });
    return (u, c) => (R(), z(we, {
      "primary-text": o.value,
      "secondary-text-cms": i.value,
      "widget-cms": s.value,
      "widget-icon-url": a.value
    }, null, 8, ["primary-text", "secondary-text-cms", "widget-cms", "widget-icon-url"]));
  }
}), gu = /* @__PURE__ */ ne({
  __name: "InvoiceStatusWidget",
  props: {
    status: {},
    amount: {},
    dueDate: {},
    cms: {}
  },
  setup(e) {
    const t = e, { getCmsItem: n, getIconUrl: r } = ce(), s = T(
      () => {
        var c;
        return n((c = t.cms) == null ? void 0 : c.pageSections, "invoiceStatusWidget");
      }
    ), o = T(() => {
      if (t.status.isCreditNote)
        return "gray";
      if (t.status.isPaid)
        return "green";
      const c = ie().isAfter(ie(t.dueDate));
      return t.status.code === Be.Unpaid, c ? "red" : "yellow";
    }), i = T(() => {
      var d, g;
      const c = t.amount.toLocaleString("nb-NO"), l = ((g = n((d = s.value) == null ? void 0 : d.otherText, "currencyNo")) == null ? void 0 : g.title) || "kr eks. mva";
      return `${c} ${l}`;
    }), a = T(() => {
      var m, b, f, S, $;
      const c = (m = s.value) == null ? void 0 : m.otherText, l = ie(t.dueDate).format("DD.MM.YYYY"), d = (b = n(c, "overdue")) == null ? void 0 : b.title, g = ((f = n(c, "dueDateLabel")) == null ? void 0 : f.title) || "Forfall";
      if (t.status.isCreditNote)
        return (S = n(c, "credited")) == null ? void 0 : S.title;
      switch (t.status.code) {
        case Be.Paid:
          return ($ = n(c, "paid")) == null ? void 0 : $.title;
        case Be.Overdue:
          return `${d} ${l}`;
        case Be.Unpaid:
          return `${g} ${l}`;
        default:
          return "";
      }
    }), u = T(() => {
      var b;
      const d = {
        gray: "close-circle",
        green: "check-circle",
        red: "alert-circle",
        yellow: ie().isAfter(ie(t.dueDate)) ? "alert-circle" : "clock"
      }[o.value], g = (b = s.value) == null ? void 0 : b.icons, m = (g == null ? void 0 : g.find((f) => f.label === d)) ?? (g == null ? void 0 : g[0]);
      return m ? r(m) : "";
    });
    return (c, l) => (R(), z(we, {
      "primary-text": i.value,
      "secondary-text": a.value,
      "widget-cms": s.value,
      "widget-icon-url": u.value,
      nudge: !0,
      "nudge-color": o.value
    }, null, 8, ["primary-text", "secondary-text", "widget-cms", "widget-icon-url", "nudge-color"]));
  }
}), vu = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='receipt_long'%3e%3cmask%20id='mask0_140_758'%20style='mask-type:alpha'%20maskUnits='userSpaceOnUse'%20x='0'%20y='0'%20width='40'%20height='40'%3e%3crect%20id='Bounding%20box'%20width='40'%20height='40'%20fill='%23D9D9D9'/%3e%3c/mask%3e%3cg%20mask='url(%23mask0_140_758)'%3e%3cpath%20id='receipt_long_2'%20d='M9.77789%2035C8.8965%2035%208.1508%2034.6951%207.5408%2034.0854C6.93108%2033.4754%206.62622%2032.7347%206.62622%2031.8633V28.4617H11.7137V5.64084L13.8279%207.11542L16.0058%205.64084L18.1841%207.11542L20.3625%205.64084L22.5404%207.11542L24.72%205.64084L26.8996%207.11542L29.0791%205.64084L31.2587%207.11542L33.3737%205.64084V31.8483C33.3737%2032.7297%2033.0689%2033.4754%2032.4591%2034.0854C31.8491%2034.6951%2031.1034%2035%2030.2221%2035H9.77789ZM30.2329%2033.5896C30.7251%2033.5896%2031.1366%2033.4242%2031.4675%2033.0933C31.7983%2032.7625%2031.9637%2032.3475%2031.9637%2031.8483V8.07709H13.1237V28.4617H28.5021V31.8483C28.5021%2032.3475%2028.6675%2032.7625%2028.9983%2033.0933C29.3291%2033.4242%2029.7407%2033.5896%2030.2329%2033.5896ZM15.6004%2013.8763V12.4658H24.5108V13.8763H15.6004ZM15.6004%2019.0725V17.6625H24.5108V19.0725H15.6004ZM28.2691%2014.3246C27.9608%2014.3246%2027.6914%2014.2094%2027.4608%2013.9792C27.2305%2013.7486%2027.1154%2013.4792%2027.1154%2013.1708C27.1154%2012.8625%2027.2305%2012.5932%2027.4608%2012.3629C27.6914%2012.1324%2027.9608%2012.0171%2028.2691%2012.0171C28.5775%2012.0171%2028.8469%2012.1324%2029.0775%2012.3629C29.3077%2012.5932%2029.4229%2012.8625%2029.4229%2013.1708C29.4229%2013.4792%2029.3077%2013.7486%2029.0775%2013.9792C28.8469%2014.2094%2028.5775%2014.3246%2028.2691%2014.3246ZM28.2691%2019.4467C27.9608%2019.4467%2027.6914%2019.3314%2027.4608%2019.1008C27.2305%2018.8706%2027.1154%2018.6013%2027.1154%2018.2929C27.1154%2017.9843%2027.2305%2017.7149%2027.4608%2017.4846C27.6914%2017.254%2027.9608%2017.1388%2028.2691%2017.1388C28.5775%2017.1388%2028.8469%2017.254%2029.0775%2017.4846C29.3077%2017.7149%2029.4229%2017.9843%2029.4229%2018.2929C29.4229%2018.6013%2029.3077%2018.8706%2029.0775%2019.1008C28.8469%2019.3314%2028.5775%2019.4467%2028.2691%2019.4467ZM9.75622%2033.5896H27.0921V29.8717H8.03622V31.8483C8.03622%2032.3475%208.20303%2032.7625%208.53664%2033.0933C8.87025%2033.4242%209.27678%2033.5896%209.75622%2033.5896Z'%20fill='%231C1B1F'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e", yu = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='receipt_long_off'%3e%3cmask%20id='mask0_140_2414'%20style='mask-type:alpha'%20maskUnits='userSpaceOnUse'%20x='0'%20y='0'%20width='40'%20height='40'%3e%3crect%20id='Bounding%20box'%20width='40'%20height='40'%20fill='%23D9D9D9'/%3e%3c/mask%3e%3cg%20mask='url(%23mask0_140_2414)'%3e%3cpath%20id='receipt_long_off_2'%20d='M35.3579%2037.3825L32.5471%2034.5717C32.3291%2034.7439%2032.0817%2034.8583%2031.805%2034.915C31.5284%2034.9717%2031.3016%2035%2031.1246%2035H9.77794C8.89655%2035%208.15086%2034.6951%207.54086%2034.0854C6.93113%2033.4754%206.62627%2032.7297%206.62627%2031.8483V28.4617H11.7138V13.7383L3.13794%205.1625L4.15169%204.14833L36.3717%2036.3688L35.3579%2037.3825ZM9.75002%2033.5896H31.565L27.8471%2029.8717H8.03627V31.8483C8.03627%2032.3417%208.20377%2032.7553%208.53877%2033.0892C8.87377%2033.4228%209.27752%2033.5896%209.75002%2033.5896ZM33.3738%2029.0417L31.9638%2027.6312V8.07708H12.4092L11.7138%207.38125V5.64083L13.8279%207.11542L16.0059%205.64083L18.1842%207.11542L20.3625%205.64083L22.5404%207.11542L24.72%205.64083L26.8996%207.11542L29.0792%205.64083L31.2588%207.11542L33.3738%205.64083V29.0417ZM13.1238%2028.4617H26.4371L13.1238%2015.1483V28.4617ZM18.2146%2013.8763L16.8046%2012.4658H24.5109V13.8763H18.2146ZM23.39%2019.0725L21.9796%2017.6625H24.5109V19.0725H23.39ZM28.2642%2019.4467C27.955%2019.4467%2027.6863%2019.3307%2027.4579%2019.0987C27.2296%2018.8671%2027.1154%2018.5967%2027.1154%2018.2875C27.1154%2017.9783%2027.2313%2017.7096%2027.4629%2017.4812C27.6949%2017.2529%2027.9654%2017.1388%2028.2746%2017.1388C28.5838%2017.1388%2028.8525%2017.2547%2029.0809%2017.4867C29.3089%2017.7183%2029.4229%2017.9887%2029.4229%2018.2979C29.4229%2018.6071%2029.3071%2018.8758%2029.0754%2019.1042C28.8438%2019.3325%2028.5734%2019.4467%2028.2642%2019.4467ZM28.2692%2014.3246C27.9609%2014.3246%2027.6914%2014.2094%2027.4609%2013.9792C27.2306%2013.7486%2027.1154%2013.4792%2027.1154%2013.1708C27.1154%2012.8625%2027.2306%2012.5932%2027.4609%2012.3629C27.6914%2012.1324%2027.9609%2012.0171%2028.2692%2012.0171C28.5775%2012.0171%2028.847%2012.1324%2029.0775%2012.3629C29.3078%2012.5932%2029.4229%2012.8625%2029.4229%2013.1708C29.4229%2013.4792%2029.3078%2013.7486%2029.0775%2013.9792C28.847%2014.2094%2028.5775%2014.3246%2028.2692%2014.3246Z'%20fill='%231C1B1F'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e", bu = ["src", "alt"], wu = { class: "supplier-invoice-list-item__widgets" }, _u = { class: "supplier-invoice-list-item__right-widgets" }, Su = /* @__PURE__ */ ne({
  __name: "InvoiceListItem",
  props: {
    invoice: {},
    projectSupplierName: {},
    projectCustomerName: {},
    customerMode: { type: Boolean },
    collapsed: { type: Boolean, default: !1 },
    listItemId: { default: "" }
  },
  emits: ["clicked"],
  setup(e, { emit: t }) {
    const n = t, r = e, { getPageCms: s, getCmsItem: o } = ce(), i = Tn({
      cms: void 0
    }), a = T(
      () => r.invoice.statusCode === Be.Credited && r.invoice.invoiceType === oo.CreditNote
    ), u = T(
      () => r.invoice.statusCode === Be.Credited
    ), c = T(
      () => r.invoice.statusCode === Be.Paid
    ), l = T(
      () => r.invoice.statusCode === Be.Overdue
    ), d = T(() => {
      const D = r.invoice.customerName ? r.invoice.customerName : r.projectCustomerName, I = r.invoice.supplierName ? r.invoice.supplierName : r.projectSupplierName;
      return r.customerMode ? D : I;
    }), g = T(() => {
      const D = r.invoice.customerName ? r.invoice.customerName : r.projectCustomerName, I = r.invoice.supplierName ? r.invoice.supplierName : r.projectSupplierName;
      return r.customerMode ? I : D;
    }), m = T(() => ({
      code: r.invoice.statusCode,
      isOverdue: l.value,
      isPaid: c.value,
      isCreditNote: u.value
    })), b = T(
      () => a.value ? yu : vu
    ), f = T(
      () => a.value ? "Credit Note" : "Invoice"
    ), S = T(
      () => {
        var D;
        return o((D = i.cms) == null ? void 0 : D.pageSections, "invoiceTitleSection");
      }
    ), $ = T(() => {
      var D, I, M, K;
      return a.value ? ((I = o((D = S.value) == null ? void 0 : D.otherText, "creditNote")) == null ? void 0 : I.title) || "Kreditnota" : ((K = o((M = S.value) == null ? void 0 : M.otherText, "invoice")) == null ? void 0 : K.title) || "Faktura";
    }), E = T(() => {
      var M;
      const D = o((M = S.value) == null ? void 0 : M.otherText, "invoiceNumber");
      return `${(D == null ? void 0 : D.title) || "Fakturanr."} ${r.invoice.invoiceNumber}`;
    });
    return (async () => {
      i.cms = await s(qe.SUPPLIER_INVOICE_LIST_ITEM);
    })(), (D, I) => (R(), z(pr, {
      headline: $.value,
      "secondary-text": E.value,
      interaction: "",
      collapsed: D.collapsed,
      "list-item-id": D.listItemId,
      onClicked: I[0] || (I[0] = (M) => n("clicked"))
    }, {
      leadingVisual: oe(() => [
        U("img", {
          src: b.value,
          alt: f.value
        }, null, 8, bu)
      ]),
      widgets: oe(() => [
        U("div", wu, [
          U("div", _u, [
            be(hu, {
              "primary-name": d.value,
              "secondary-name": g.value,
              cms: i.cms
            }, null, 8, ["primary-name", "secondary-name", "cms"]),
            be(mu, {
              date: D.invoice.invoiceDate,
              "due-date": D.invoice.paymentDueDate,
              cms: i.cms
            }, null, 8, ["date", "due-date", "cms"]),
            be(gu, {
              status: m.value,
              amount: D.invoice.taxExclusiveAmount,
              "due-date": D.invoice.paymentDueDate,
              cms: i.cms
            }, null, 8, ["status", "amount", "due-date", "cms"])
          ])
        ])
      ]),
      collapseContent: oe(() => [
        le(D.$slots, "collapseContent", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["headline", "secondary-text", "collapsed", "list-item-id"]));
  }
}), Nh = /* @__PURE__ */ Te(Su, [["__scopeId", "data-v-4887297b"]]), Cu = {}, xu = { class: "portfolio-label" };
function Tu(e, t) {
  return R(), Y("div", xu, " Portefølje ");
}
const io = /* @__PURE__ */ Te(Cu, [["render", Tu], ["__scopeId", "data-v-5eb9d456"]]), $u = /* @__PURE__ */ ne({
  __name: "PublicSurveyWidget",
  props: {
    surveyDate: {},
    cms: { default: void 0 }
  },
  setup(e) {
    const t = e, { getCmsItem: n, getCmsItemText: r } = ce(), s = T(
      () => {
        var a;
        return n((a = t.cms) == null ? void 0 : a.pageSections, "jointInspectionWidget");
      }
    ), o = T(
      () => {
        var a;
        return r((a = s.value) == null ? void 0 : a.otherText, "secondaryText");
      }
    ), i = T(() => {
      var u;
      const a = yt(t.surveyDate);
      return a || r((u = s.value) == null ? void 0 : u.otherText, "primaryText_placeholder");
    });
    return (a, u) => (R(), z(we, {
      "primary-text": i.value,
      "secondary-text": o.value,
      "widget-cms": s.value
    }, null, 8, ["primary-text", "secondary-text", "widget-cms"]));
  }
}), Ou = /* @__PURE__ */ ne({
  __name: "StartDateWidget",
  props: {
    startDate: {},
    cms: { default: void 0 }
  },
  setup(e) {
    const t = e, { getCmsItem: n, getCmsItemText: r } = ce(), s = T(
      () => {
        var a;
        return n((a = t.cms) == null ? void 0 : a.pageSections, "startDateWidget");
      }
    ), o = T(
      () => {
        var a;
        return r((a = s.value) == null ? void 0 : a.otherText, "secondaryText");
      }
    ), i = T(() => {
      var u;
      const a = yt(t.startDate);
      return a || r((u = s.value) == null ? void 0 : u.otherText, "primaryText_placeholder");
    });
    return (a, u) => (R(), z(we, {
      "primary-text": i.value,
      "secondary-text": o.value,
      "widget-cms": s.value
    }, null, 8, ["primary-text", "secondary-text", "widget-cms"]));
  }
}), ku = 5, Eu = /* @__PURE__ */ ne({
  __name: "OfferStatusWidget",
  props: {
    requestDate: {},
    responseDeadlineInDays: {},
    offersCount: {},
    requestEstimates: { type: Boolean },
    cms: { default: void 0 }
  },
  setup(e) {
    const t = e, { getCmsItem: n, getCmsItemText: r, getIconUrl: s } = ce(), o = T(
      () => {
        var g;
        return n((g = t.cms) == null ? void 0 : g.pageSections, "statusWidget");
      }
    ), i = T(() => {
      if (typeof t.responseDeadlineInDays == "number")
        return Aa(t.requestDate, t.responseDeadlineInDays);
    }), a = T(() => {
      if (i.value)
        return ie(i.value).diff(ie(), "days") + 1;
    }), u = T(() => t.offersCount ? "green" : a.value && a.value < 0 ? "gray" : "yellow"), c = T(() => {
      var b, f;
      let g;
      t.offersCount ? g = "primaryText_offers2" : !a.value || a.value > 0 ? g = "primaryText_noOffers2" : g = "primaryText_noOffersAfterDeadline2";
      const m = n(
        (b = o.value) == null ? void 0 : b.otherText,
        g
      );
      return {
        primaryTextCms: m,
        primaryText: st.render((m == null ? void 0 : m.title) || "", {
          offersCount: t.offersCount,
          offerLabel: r(
            (f = o.value) == null ? void 0 : f.otherText,
            t.requestEstimates ? "estimateLabel" : "offerLabel"
          )
        })
      };
    }), l = T(() => {
      var b;
      let g;
      typeof a.value != "number" ? g = "" : a.value > ku ? g = "secondaryText_notCloseToDeadline" : a.value > 0 ? g = "secondaryText_closeToDeadline" : g = "secondaryText_afterDeadline";
      const m = n(
        (b = o.value) == null ? void 0 : b.otherText,
        g
      );
      return {
        secondaryTextCms: m,
        secondaryText: st.render((m == null ? void 0 : m.title) || "", {
          date: yt(i.value) || "",
          daysCount: a.value
        })
      };
    }), d = T(() => {
      var b, f, S, $;
      const g = {
        primaryTextCms: c.value.primaryTextCms,
        primaryText: c.value.primaryText,
        secondaryTextCms: l.value.secondaryTextCms,
        secondaryText: l.value.secondaryText,
        nudgeColor: u.value,
        widgetIconUrl: ""
      }, m = t.offersCount ? (f = (b = g.primaryTextCms) == null ? void 0 : b.icons) == null ? void 0 : f[0] : ($ = (S = g.secondaryTextCms) == null ? void 0 : S.icons) == null ? void 0 : $[0];
      return g.widgetIconUrl = m ? s(m) : "", g;
    });
    return (g, m) => (R(), z(we, {
      "primary-text": d.value.primaryText,
      "secondary-text": d.value.secondaryText,
      "widget-icon-url": d.value.widgetIconUrl,
      nudge: !0,
      "nudge-color": d.value.nudgeColor
    }, null, 8, ["primary-text", "secondary-text", "widget-icon-url", "nudge-color"]));
  }
}), Iu = (e, t) => e.toLowerCase() === t.toLowerCase(), Pu = ["src"], ao = /* @__PURE__ */ ne({
  __name: "CustomerTenderBaseListItem",
  props: {
    tender: {},
    serviceTypesCms: {},
    collapsed: { type: Boolean, default: !1 },
    interaction: { default: "clickable" },
    listItemId: { default: void 0 }
  },
  emits: ["clicked"],
  setup(e, { emit: t }) {
    const n = t, r = e, {
      getServiceCategoryCms: s,
      getServiceName: o,
      getServiceIcon: i
    } = ce(), a = T(() => s(r.serviceTypesCms, r.tender.serviceCategoryLabel)), u = T(
      () => o(
        r.serviceTypesCms,
        r.tender.serviceCategoryLabel
      )
    ), c = T(() => {
      const l = r.tender.bookingNumber || r.tender.externalTenderId;
      return {
        tertiaryText: [
          r.tender.nickName ? u.value : "",
          l ? `#${l}` : ""
        ].filter((d) => !!d).join(" - "),
        headline: r.tender.nickName || u.value,
        secondaryText: r.tender.customerPropertyAddresss,
        icon: i(a.value, void 0)
      };
    });
    return (l, d) => (R(), z(pr, {
      "tertiary-text": c.value.tertiaryText,
      headline: c.value.headline,
      "secondary-text": c.value.secondaryText,
      interaction: l.interaction,
      "list-item-id": l.listItemId,
      collapsed: l.collapsed,
      onClicked: d[0] || (d[0] = (g) => n("clicked"))
    }, Gi({
      leadingVisual: oe(() => [
        c.value.icon ? (R(), Y("img", {
          key: 0,
          src: c.value.icon,
          alt: "Service icon"
        }, null, 8, Pu)) : te("", !0)
      ]),
      _: 2
    }, [
      lr(l.$slots, (g, m) => ({
        name: m,
        fn: oe((b) => [
          le(l.$slots, m, Ps(Rs(b)))
        ])
      }))
    ]), 1032, ["tertiary-text", "headline", "secondary-text", "interaction", "list-item-id", "collapsed"]));
  }
}), Ru = { class: "list-item__start-widgets" }, Au = { class: "list-item__end-widgets" }, ju = {
  key: 0,
  class: "list-item__messages-widget"
}, Du = { class: "list-item__core-widgets" }, Lu = /* @__PURE__ */ ne({
  __name: "CustomerOfferListItem",
  props: {
    serviceTypesCms: {},
    priceRequestListItem: {},
    listItemId: { default: void 0 },
    isCollapsible: { type: Boolean, default: !0 },
    collapsed: { type: Boolean, default: !0 }
  },
  emits: ["clicked"],
  setup(e, { emit: t }) {
    const n = e, r = t, { getPageCms: s } = ce(), o = Tn({
      cms: void 0
    }), i = T(() => Iu(
      n.priceRequestListItem.requestState,
      Ms.Draft
    )), a = T(() => n.priceRequestListItem.hasFrameAgreement || !1);
    return (async () => {
      o.cms = await s(
        qe.CUSTOMER_PRICE_REQUEST_TENDER_LIST_ITEM
      );
    })(), (c, l) => (R(), z(ao, {
      tender: c.priceRequestListItem,
      "service-types-cms": c.serviceTypesCms,
      interaction: c.isCollapsible ? "collapsible" : "clickable",
      collapsed: c.collapsed,
      "list-item-id": c.listItemId,
      onClicked: l[0] || (l[0] = (d) => r("clicked"))
    }, {
      widgets: oe(() => [
        U("div", Ru, [
          c.priceRequestListItem.portfolio ? (R(), z(io, { key: 0 })) : te("", !0),
          be(so, {
            "integration-source": c.priceRequestListItem.integrationSource,
            "has-frame-agreement": a.value,
            "hide-excluded-sources": !0
          }, null, 8, ["integration-source", "has-frame-agreement"])
        ]),
        U("div", Au, [
          c.priceRequestListItem.hasUnreadMessages ? (R(), Y("div", ju, [
            be(Me(bn), { severity: "danger" }, {
              default: oe(() => l[1] || (l[1] = [
                U("i", { class: "pi pi-envelope list-item__messages-icon" }, null, -1)
              ])),
              _: 1
            })
          ])) : te("", !0),
          U("div", Du, [
            be($u, {
              "survey-date": c.priceRequestListItem.surveyDateTime,
              cms: o.cms
            }, null, 8, ["survey-date", "cms"]),
            be(Ou, {
              "start-date": c.priceRequestListItem.wantedStartDate,
              cms: o.cms
            }, null, 8, ["start-date", "cms"]),
            i.value ? te("", !0) : (R(), z(Eu, {
              key: 0,
              "request-date": c.priceRequestListItem.requestSent,
              "response-deadline-in-days": c.priceRequestListItem.responsePeriodInDays,
              "offers-count": c.priceRequestListItem.offerCount,
              "request-estimates": c.priceRequestListItem.requestEstimates,
              cms: o.cms
            }, null, 8, ["request-date", "response-deadline-in-days", "offers-count", "request-estimates", "cms"]))
          ])
        ])
      ]),
      collapseContent: oe(() => [
        le(c.$slots, "collapseContent", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["tender", "service-types-cms", "interaction", "collapsed", "list-item-id"]));
  }
}), Uh = /* @__PURE__ */ Te(Lu, [["__scopeId", "data-v-ae1878ae"]]), Mu = /* @__PURE__ */ ne({
  __name: "AboutSupplierWidget",
  props: {
    supplierName: {},
    cms: { default: void 0 }
  },
  setup(e) {
    const t = e, { getCmsItem: n, getCmsItemText: r } = ce(), s = T(
      () => {
        var i;
        return n((i = t.cms) == null ? void 0 : i.pageSections, "supplierWidget");
      }
    ), o = T(
      () => {
        var i;
        return r((i = s.value) == null ? void 0 : i.otherText, "secondaryText");
      }
    );
    return (i, a) => (R(), z(we, {
      "primary-text": i.supplierName,
      "secondary-text": o.value,
      "widget-cms": s.value
    }, null, 8, ["primary-text", "secondary-text", "widget-cms"]));
  }
}), Nu = /* @__PURE__ */ ne({
  __name: "DateSignedWidget",
  props: {
    acceptanceDate: {},
    cms: { default: void 0 }
  },
  setup(e) {
    const t = e, { getCmsItem: n, getCmsItemText: r } = ce(), s = T(
      () => {
        var a;
        return n((a = t.cms) == null ? void 0 : a.pageSections, "signedWidget");
      }
    ), o = T(
      () => {
        var a;
        return r((a = s.value) == null ? void 0 : a.otherText, "primaryText");
      }
    ), i = T(() => t.acceptanceDate ? Hs(t.acceptanceDate) : "--");
    return (a, u) => (R(), z(we, {
      "primary-text": o.value,
      "secondary-text": i.value,
      "widget-cms": s.value
    }, null, 8, ["primary-text", "secondary-text", "widget-cms"]));
  }
}), Uu = /* @__PURE__ */ ne({
  __name: "AgreementStatusWidget",
  props: {
    jobType: {},
    startDate: {},
    archived: { type: Boolean },
    completionDate: {},
    cms: { default: void 0 }
  },
  setup(e) {
    const t = e, { getCmsItem: n } = ce(), r = T(
      () => {
        var i;
        return n((i = t.cms) == null ? void 0 : i.pageSections, "statusWidget");
      }
    ), s = T(() => t.startDate ? ie(t.startDate).startOf("day").diff(ie().startOf("day"), "day") : -1), o = T(() => {
      var c, l, d, g, m;
      const i = {
        primaryTextCms: void 0,
        secondaryText: "",
        secondaryTextCms: void 0,
        nudgeColor: ""
      }, a = n(
        (c = r.value) == null ? void 0 : c.otherText,
        t.jobType === vn.Single ? "primaryText_singleJob" : "primaryText_repeatingJob"
      ), u = Hs(t.startDate);
      if (t.archived) {
        i.primaryTextCms = a;
        const b = n(
          (l = r.value) == null ? void 0 : l.otherText,
          "secondaryText_stopped"
        );
        i.secondaryTextCms = b, i.secondaryText = st.render((b == null ? void 0 : b.title) || "", {
          date: yt(t.completionDate) || "--"
        }), i.nudgeColor = "gray";
      } else if (s.value >= 14)
        i.primaryTextCms = n(
          (d = r.value) == null ? void 0 : d.otherText,
          "primaryText_waitingStartup"
        ), i.secondaryText = u || "";
      else if (s.value > 0)
        i.primaryTextCms = n(
          (g = r.value) == null ? void 0 : g.otherText,
          "primaryText_startingSoon"
        ), i.secondaryText = u || "", i.nudgeColor = "yellow";
      else {
        i.primaryTextCms = a;
        const b = n(
          (m = r.value) == null ? void 0 : m.otherText,
          "secondaryText_started"
        );
        i.secondaryTextCms = b, i.secondaryText = u ? st.render((b == null ? void 0 : b.title) || "", {
          date: u
        }) : "", i.nudgeColor = "green";
      }
      return i;
    });
    return (i, a) => (R(), z(we, {
      "secondary-text": o.value.secondaryText,
      "primary-text-cms": o.value.primaryTextCms,
      "secondary-text-cms": o.value.secondaryTextCms,
      "widget-cms": r.value,
      nudge: !0,
      "nudge-color": o.value.nudgeColor
    }, null, 8, ["secondary-text", "primary-text-cms", "secondary-text-cms", "widget-cms", "nudge-color"]));
  }
}), qu = { class: "list-item__start-widgets" }, Fu = { class: "list-item__end-widgets" }, Bu = /* @__PURE__ */ ne({
  __name: "CustomerAgreementListItem",
  props: {
    agreement: {},
    archived: { type: Boolean },
    serviceTypesCms: {},
    collapsed: { type: Boolean, default: !0 },
    listItemId: { default: void 0 }
  },
  emits: ["clicked"],
  setup(e, { emit: t }) {
    const n = e, r = t, {
      getPageCms: s
    } = ce(), o = Tn({
      cms: void 0
    }), i = T(() => {
      var d;
      return (d = n.agreement) == null ? void 0 : d.acceptedDate;
    }), a = T(() => n.agreement.startDate), u = T(() => {
    }), c = T(() => {
      var g;
      return ((g = n.agreement.billingCycles) == null ? void 0 : g.some(
        (m) => m.toLowerCase() !== Rt.Fixed.toLowerCase()
      )) ? vn.Repeating : vn.Single;
    });
    return (async () => {
      o.cms = await s(qe.CUSTOMER_AGREEMENT_TENDER_LIST_ITEM);
    })(), (d, g) => (R(), z(ao, {
      tender: d.agreement,
      "service-types-cms": d.serviceTypesCms,
      "list-item-id": d.listItemId,
      onClicked: g[0] || (g[0] = (m) => r("clicked"))
    }, {
      widgets: oe(() => [
        U("div", qu, [
          d.agreement.portfolio ? (R(), z(io, { key: 0 })) : te("", !0)
        ]),
        U("div", Fu, [
          be(Mu, {
            "supplier-name": d.agreement.supplierName,
            cms: o.cms
          }, null, 8, ["supplier-name", "cms"]),
          be(Nu, {
            "acceptance-date": i.value,
            cms: o.cms
          }, null, 8, ["acceptance-date", "cms"]),
          be(Uu, {
            "start-date": a.value,
            "job-type": c.value,
            archived: d.archived,
            "completion-date": u.value,
            cms: o.cms
          }, null, 8, ["start-date", "job-type", "archived", "completion-date", "cms"])
        ])
      ]),
      _: 1
    }, 8, ["tender", "service-types-cms", "list-item-id"]));
  }
}), qh = /* @__PURE__ */ Te(Bu, [["__scopeId", "data-v-82c77874"]]);
var Vu = Object.defineProperty, co = (e) => {
  throw TypeError(e);
}, zu = (e, t, n) => t in e ? Vu(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, H = (e, t, n) => zu(e, typeof t != "symbol" ? t + "" : t, n), uo = (e, t, n) => t.has(e) || co("Cannot " + n), k = (e, t, n) => (uo(e, t, "read from private field"), n ? n.call(e) : t.get(e)), X = (e, t, n) => t.has(e) ? co("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, n), Z = (e, t, n, r) => (uo(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n);
const Hu = () => "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(e) {
  const t = Math.random() * 16 | 0;
  return (e == "x" ? t : t & 3 | 8).toString(16);
});
`${Hu()}`;
var Wu = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Yu(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var lo = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(Wu, function() {
    function n() {
      return n = Object.assign || function(h) {
        for (var y = 1; y < arguments.length; y++) {
          var p = arguments[y];
          for (var v in p)
            Object.prototype.hasOwnProperty.call(p, v) && (h[v] = p[v]);
        }
        return h;
      }, n.apply(this, arguments);
    }
    function r(h, y) {
      if (h) {
        if (typeof h == "string")
          return s(h, y);
        var p = Object.prototype.toString.call(h).slice(8, -1);
        if (p === "Object" && h.constructor && (p = h.constructor.name), p === "Map" || p === "Set")
          return Array.from(h);
        if (p === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(p))
          return s(h, y);
      }
    }
    function s(h, y) {
      (y == null || y > h.length) && (y = h.length);
      for (var p = 0, v = new Array(y); p < y; p++)
        v[p] = h[p];
      return v;
    }
    function o(h, y) {
      var p = typeof Symbol < "u" && h[Symbol.iterator] || h["@@iterator"];
      if (p)
        return (p = p.call(h)).next.bind(p);
      if (Array.isArray(h) || (p = r(h)) || y) {
        p && (h = p);
        var v = 0;
        return function() {
          return v >= h.length ? {
            done: !0
          } : {
            done: !1,
            value: h[v++]
          };
        };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var i = "image-Tb9Ew8CXIwaY6R1kjMvI0uRR-2000x3000-jpg";
    function a(h) {
      var y = h.split("-"), p = y[1], v = y[2], _ = y[3];
      if (!p || !v || !_)
        throw new Error("Malformed asset _ref '" + h + `'. Expected an id like "` + i + '".');
      var w = v.split("x"), x = w[0], O = w[1], A = +x, P = +O, L = isFinite(A) && isFinite(P);
      if (!L)
        throw new Error("Malformed asset _ref '" + h + `'. Expected an id like "` + i + '".');
      return {
        id: p,
        width: A,
        height: P,
        format: _
      };
    }
    var u = function(h) {
      var y = h;
      return y ? typeof y._ref == "string" : !1;
    }, c = function(h) {
      var y = h;
      return y ? typeof y._id == "string" : !1;
    }, l = function(h) {
      var y = h;
      return y && y.asset ? typeof y.asset.url == "string" : !1;
    };
    function d(h) {
      if (!h)
        return null;
      var y;
      if (typeof h == "string" && g(h))
        y = {
          asset: {
            _ref: m(h)
          }
        };
      else if (typeof h == "string")
        y = {
          asset: {
            _ref: h
          }
        };
      else if (u(h))
        y = {
          asset: h
        };
      else if (c(h))
        y = {
          asset: {
            _ref: h._id || ""
          }
        };
      else if (l(h))
        y = {
          asset: {
            _ref: m(h.asset.url)
          }
        };
      else if (typeof h.asset == "object")
        y = n({}, h);
      else
        return null;
      var p = h;
      return p.crop && (y.crop = p.crop), p.hotspot && (y.hotspot = p.hotspot), b(y);
    }
    function g(h) {
      return /^https?:\/\//.test("" + h);
    }
    function m(h) {
      var y = h.split("/").slice(-1);
      return ("image-" + y[0]).replace(/\.([a-z]+)$/, "-$1");
    }
    function b(h) {
      if (h.crop && h.hotspot)
        return h;
      var y = n({}, h);
      return y.crop || (y.crop = {
        left: 0,
        top: 0,
        bottom: 0,
        right: 0
      }), y.hotspot || (y.hotspot = {
        x: 0.5,
        y: 0.5,
        height: 1,
        width: 1
      }), y;
    }
    var f = [["width", "w"], ["height", "h"], ["format", "fm"], ["download", "dl"], ["blur", "blur"], ["sharpen", "sharp"], ["invert", "invert"], ["orientation", "or"], ["minHeight", "min-h"], ["maxHeight", "max-h"], ["minWidth", "min-w"], ["maxWidth", "max-w"], ["quality", "q"], ["fit", "fit"], ["crop", "crop"], ["saturation", "sat"], ["auto", "auto"], ["dpr", "dpr"], ["pad", "pad"], ["frame", "frame"]];
    function S(h) {
      var y = n({}, h || {}), p = y.source;
      delete y.source;
      var v = d(p);
      if (!v)
        throw new Error("Unable to resolve image URL from source (" + JSON.stringify(p) + ")");
      var _ = v.asset._ref || v.asset._id || "", w = a(_), x = Math.round(v.crop.left * w.width), O = Math.round(v.crop.top * w.height), A = {
        left: x,
        top: O,
        width: Math.round(w.width - v.crop.right * w.width - x),
        height: Math.round(w.height - v.crop.bottom * w.height - O)
      }, P = v.hotspot.height * w.height / 2, L = v.hotspot.width * w.width / 2, F = v.hotspot.x * w.width, W = v.hotspot.y * w.height, B = {
        left: F - L,
        top: W - P,
        right: F + L,
        bottom: W + P
      };
      return y.rect || y.focalPoint || y.ignoreImageParams || y.crop || (y = n({}, y, E({
        crop: A,
        hotspot: B
      }, y))), $(n({}, y, {
        asset: w
      }));
    }
    function $(h) {
      var y = (h.baseUrl || "https://cdn.sanity.io").replace(/\/+$/, ""), p = h.vanityName ? "/" + h.vanityName : "", v = h.asset.id + "-" + h.asset.width + "x" + h.asset.height + "." + h.asset.format + p, _ = y + "/images/" + h.projectId + "/" + h.dataset + "/" + v, w = [];
      if (h.rect) {
        var x = h.rect, O = x.left, A = x.top, P = x.width, L = x.height, F = O !== 0 || A !== 0 || L !== h.asset.height || P !== h.asset.width;
        F && w.push("rect=" + O + "," + A + "," + P + "," + L);
      }
      h.bg && w.push("bg=" + h.bg), h.focalPoint && (w.push("fp-x=" + h.focalPoint.x), w.push("fp-y=" + h.focalPoint.y));
      var W = [h.flipHorizontal && "h", h.flipVertical && "v"].filter(Boolean).join("");
      return W && w.push("flip=" + W), f.forEach(function(B) {
        var ee = B[0], se = B[1];
        typeof h[ee] < "u" ? w.push(se + "=" + encodeURIComponent(h[ee])) : typeof h[se] < "u" && w.push(se + "=" + encodeURIComponent(h[se]));
      }), w.length === 0 ? _ : _ + "?" + w.join("&");
    }
    function E(h, y) {
      var p, v = y.width, _ = y.height;
      if (!(v && _))
        return {
          width: v,
          height: _,
          rect: h.crop
        };
      var w = h.crop, x = h.hotspot, O = v / _, A = w.width / w.height;
      if (A > O) {
        var P = Math.round(w.height), L = Math.round(P * O), F = Math.max(0, Math.round(w.top)), W = Math.round((x.right - x.left) / 2 + x.left), B = Math.max(0, Math.round(W - L / 2));
        B < w.left ? B = w.left : B + L > w.left + w.width && (B = w.left + w.width - L), p = {
          left: B,
          top: F,
          width: L,
          height: P
        };
      } else {
        var ee = w.width, se = Math.round(ee / O), Se = Math.max(0, Math.round(w.left)), ke = Math.round((x.bottom - x.top) / 2 + x.top), ae = Math.max(0, Math.round(ke - se / 2));
        ae < w.top ? ae = w.top : ae + se > w.top + w.height && (ae = w.top + w.height - se), p = {
          left: Se,
          top: ae,
          width: ee,
          height: se
        };
      }
      return {
        width: v,
        height: _,
        rect: p
      };
    }
    var j = ["clip", "crop", "fill", "fillmax", "max", "scale", "min"], D = ["top", "bottom", "left", "right", "center", "focalpoint", "entropy"], I = ["format"];
    function M(h) {
      return h && "config" in h ? typeof h.config == "function" : !1;
    }
    function K(h) {
      return h && "clientConfig" in h ? typeof h.clientConfig == "object" : !1;
    }
    function J(h) {
      for (var y = f, p = o(y), v; !(v = p()).done; ) {
        var _ = v.value, w = _[0], x = _[1];
        if (h === w || h === x)
          return w;
      }
      return h;
    }
    function q(h) {
      if (M(h)) {
        var y = h.config(), p = y.apiHost, v = y.projectId, _ = y.dataset, w = p || "https://api.sanity.io";
        return new N(null, {
          baseUrl: w.replace(/^https:\/\/api\./, "https://cdn."),
          projectId: v,
          dataset: _
        });
      }
      if (K(h)) {
        var x = h.clientConfig, O = x.apiHost, A = x.projectId, P = x.dataset, L = O || "https://api.sanity.io";
        return new N(null, {
          baseUrl: L.replace(/^https:\/\/api\./, "https://cdn."),
          projectId: A,
          dataset: P
        });
      }
      return new N(null, h || {});
    }
    var N = /* @__PURE__ */ function() {
      function h(p, v) {
        this.options = void 0, this.options = p ? n({}, p.options || {}, v || {}) : n({}, v || {});
      }
      var y = h.prototype;
      return y.withOptions = function(p) {
        var v = p.baseUrl || this.options.baseUrl, _ = {
          baseUrl: v
        };
        for (var w in p)
          if (p.hasOwnProperty(w)) {
            var x = J(w);
            _[x] = p[w];
          }
        return new h(this, n({
          baseUrl: v
        }, _));
      }, y.image = function(p) {
        return this.withOptions({
          source: p
        });
      }, y.dataset = function(p) {
        return this.withOptions({
          dataset: p
        });
      }, y.projectId = function(p) {
        return this.withOptions({
          projectId: p
        });
      }, y.bg = function(p) {
        return this.withOptions({
          bg: p
        });
      }, y.dpr = function(p) {
        return this.withOptions(p && p !== 1 ? {
          dpr: p
        } : {});
      }, y.width = function(p) {
        return this.withOptions({
          width: p
        });
      }, y.height = function(p) {
        return this.withOptions({
          height: p
        });
      }, y.focalPoint = function(p, v) {
        return this.withOptions({
          focalPoint: {
            x: p,
            y: v
          }
        });
      }, y.maxWidth = function(p) {
        return this.withOptions({
          maxWidth: p
        });
      }, y.minWidth = function(p) {
        return this.withOptions({
          minWidth: p
        });
      }, y.maxHeight = function(p) {
        return this.withOptions({
          maxHeight: p
        });
      }, y.minHeight = function(p) {
        return this.withOptions({
          minHeight: p
        });
      }, y.size = function(p, v) {
        return this.withOptions({
          width: p,
          height: v
        });
      }, y.blur = function(p) {
        return this.withOptions({
          blur: p
        });
      }, y.sharpen = function(p) {
        return this.withOptions({
          sharpen: p
        });
      }, y.rect = function(p, v, _, w) {
        return this.withOptions({
          rect: {
            left: p,
            top: v,
            width: _,
            height: w
          }
        });
      }, y.format = function(p) {
        return this.withOptions({
          format: p
        });
      }, y.invert = function(p) {
        return this.withOptions({
          invert: p
        });
      }, y.orientation = function(p) {
        return this.withOptions({
          orientation: p
        });
      }, y.quality = function(p) {
        return this.withOptions({
          quality: p
        });
      }, y.forceDownload = function(p) {
        return this.withOptions({
          download: p
        });
      }, y.flipHorizontal = function() {
        return this.withOptions({
          flipHorizontal: !0
        });
      }, y.flipVertical = function() {
        return this.withOptions({
          flipVertical: !0
        });
      }, y.ignoreImageParams = function() {
        return this.withOptions({
          ignoreImageParams: !0
        });
      }, y.fit = function(p) {
        if (j.indexOf(p) === -1)
          throw new Error('Invalid fit mode "' + p + '"');
        return this.withOptions({
          fit: p
        });
      }, y.crop = function(p) {
        if (D.indexOf(p) === -1)
          throw new Error('Invalid crop mode "' + p + '"');
        return this.withOptions({
          crop: p
        });
      }, y.saturation = function(p) {
        return this.withOptions({
          saturation: p
        });
      }, y.auto = function(p) {
        if (I.indexOf(p) === -1)
          throw new Error('Invalid auto mode "' + p + '"');
        return this.withOptions({
          auto: p
        });
      }, y.pad = function(p) {
        return this.withOptions({
          pad: p
        });
      }, y.vanityName = function(p) {
        return this.withOptions({
          vanityName: p
        });
      }, y.frame = function(p) {
        if (p !== 1)
          throw new Error('Invalid frame value "' + p + '"');
        return this.withOptions({
          frame: p
        });
      }, y.url = function() {
        return S(this.options);
      }, y.toString = function() {
        return this.url();
      }, h;
    }();
    return q;
  });
})(lo);
var Ku = lo.exports;
const Gu = /* @__PURE__ */ Yu(Ku), po = !(typeof navigator > "u") && navigator.product === "ReactNative", fo = { timeout: po ? 6e4 : 12e4 }, Ju = function(e) {
  const t = { ...fo, ...typeof e == "string" ? { url: e } : e };
  if (t.timeout = ho(t.timeout), t.query) {
    const { url: n, searchParams: r } = function(s) {
      const o = s.indexOf("?");
      if (o === -1)
        return { url: s, searchParams: new URLSearchParams() };
      const i = s.slice(0, o), a = s.slice(o + 1);
      if (!po)
        return { url: i, searchParams: new URLSearchParams(a) };
      if (typeof decodeURIComponent != "function")
        throw new Error("Broken `URLSearchParams` implementation, and `decodeURIComponent` is not defined");
      const u = new URLSearchParams();
      for (const c of a.split("&")) {
        const [l, d] = c.split("=");
        l && u.append(Xr(l), Xr(d || ""));
      }
      return { url: i, searchParams: u };
    }(t.url);
    for (const [s, o] of Object.entries(t.query)) {
      if (o !== void 0)
        if (Array.isArray(o))
          for (const a of o)
            r.append(s, a);
        else
          r.append(s, o);
      const i = r.toString();
      i && (t.url = `${n}?${i}`);
    }
  }
  return t.method = t.body && !t.method ? "POST" : (t.method || "GET").toUpperCase(), t;
};
function Xr(e) {
  return decodeURIComponent(e.replace(/\+/g, " "));
}
function ho(e) {
  if (e === !1 || e === 0)
    return !1;
  if (e.connect || e.socket)
    return e;
  const t = Number(e);
  return isNaN(t) ? ho(fo.timeout) : { connect: t, socket: t };
}
const Zu = /^https?:\/\//i, Xu = function(e) {
  if (!Zu.test(e.url))
    throw new Error(`"${e.url}" is not a valid URL`);
};
function mo(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
const Qu = ["request", "response", "progress", "error", "abort"], Qr = ["processOptions", "validateOptions", "interceptRequest", "finalizeOptions", "onRequest", "onResponse", "onError", "onReturn", "onHeaders"];
function go(e, t) {
  const n = [], r = Qr.reduce((o, i) => (o[i] = o[i] || [], o), { processOptions: [Ju], validateOptions: [Xu] });
  function s(o) {
    const i = Qu.reduce((m, b) => (m[b] = /* @__PURE__ */ function() {
      const f = /* @__PURE__ */ Object.create(null);
      let S = 0;
      return { publish: function($) {
        for (const E in f)
          f[E]($);
      }, subscribe: function($) {
        const E = S++;
        return f[E] = $, function() {
          delete f[E];
        };
      } };
    }(), m), {}), a = /* @__PURE__ */ ((m) => function(b, f, ...S) {
      const $ = b === "onError";
      let E = f;
      for (let j = 0; j < m[b].length && (E = (0, m[b][j])(E, ...S), !$ || E); j++)
        ;
      return E;
    })(r), u = a("processOptions", o);
    a("validateOptions", u);
    const c = { options: u, channels: i, applyMiddleware: a };
    let l;
    const d = i.request.subscribe((m) => {
      l = t(m, (b, f) => ((S, $, E) => {
        let j = S, D = $;
        if (!j)
          try {
            D = a("onResponse", $, E);
          } catch (I) {
            D = null, j = I;
          }
        j = j && a("onError", j, E), j ? i.error.publish(j) : D && i.response.publish(D);
      })(b, f, m));
    });
    i.abort.subscribe(() => {
      d(), l && l.abort();
    });
    const g = a("onReturn", i, c);
    return g === i && i.request.publish(c), g;
  }
  return s.use = function(o) {
    if (!o)
      throw new Error("Tried to add middleware that resolved to falsey value");
    if (typeof o == "function")
      throw new Error("Tried to add middleware that was a function. It probably expects you to pass options to it.");
    if (o.onReturn && r.onReturn.length > 0)
      throw new Error("Tried to add new middleware with `onReturn` handler, but another handler has already been registered for this event");
    return Qr.forEach((i) => {
      o[i] && r[i].push(o[i]);
    }), n.push(o), s;
  }, s.clone = () => go(n, t), e.forEach(s.use), s;
}
var Fn = function(e) {
  return e.replace(/^\s+|\s+$/g, "");
}, el = mo(function(e) {
  if (!e)
    return {};
  for (var t = {}, n = Fn(e).split(`
`), r = 0; r < n.length; r++) {
    var s = n[r], o = s.indexOf(":"), i = Fn(s.slice(0, o)).toLowerCase(), a = Fn(s.slice(o + 1));
    typeof t[i] > "u" ? t[i] = a : (u = t[i], Object.prototype.toString.call(u) === "[object Array]" ? t[i].push(a) : t[i] = [t[i], a]);
  }
  var u;
  return t;
}), Qt, en, lt, tn, ze, nn, rn, es;
let Zn = (es = class {
  constructor() {
    H(this, "onabort"), H(this, "onerror"), H(this, "onreadystatechange"), H(this, "ontimeout"), H(this, "readyState", 0), H(this, "response"), H(this, "responseText", ""), H(this, "responseType", ""), H(this, "status"), H(this, "statusText"), H(this, "withCredentials"), X(this, Qt), X(this, en), X(this, lt), X(this, tn, {}), X(this, ze), X(this, nn, {}), X(this, rn);
  }
  open(e, t, n) {
    var r;
    Z(this, Qt, e), Z(this, en, t), Z(this, lt, ""), this.readyState = 1, (r = this.onreadystatechange) == null || r.call(this), Z(this, ze, void 0);
  }
  abort() {
    k(this, ze) && k(this, ze).abort();
  }
  getAllResponseHeaders() {
    return k(this, lt);
  }
  setRequestHeader(e, t) {
    k(this, tn)[e] = t;
  }
  setInit(e, t = !0) {
    Z(this, nn, e), Z(this, rn, t);
  }
  send(e) {
    const t = this.responseType !== "arraybuffer", n = { ...k(this, nn), method: k(this, Qt), headers: k(this, tn), body: e };
    typeof AbortController == "function" && k(this, rn) && (Z(this, ze, new AbortController()), typeof EventTarget < "u" && k(this, ze).signal instanceof EventTarget && (n.signal = k(this, ze).signal)), typeof document < "u" && (n.credentials = this.withCredentials ? "include" : "omit"), fetch(k(this, en), n).then((r) => {
      var s;
      return r.headers.forEach((o, i) => {
        Z(this, lt, k(this, lt) + `${i}: ${o}\r
`);
      }), this.status = r.status, this.statusText = r.statusText, this.readyState = 3, (s = this.onreadystatechange) == null || s.call(this), t ? r.text() : r.arrayBuffer();
    }).then((r) => {
      var s;
      typeof r == "string" ? this.responseText = r : this.response = r, this.readyState = 4, (s = this.onreadystatechange) == null || s.call(this);
    }).catch((r) => {
      var s, o;
      r.name !== "AbortError" ? (s = this.onerror) == null || s.call(this, r) : (o = this.onabort) == null || o.call(this);
    });
  }
}, Qt = /* @__PURE__ */ new WeakMap(), en = /* @__PURE__ */ new WeakMap(), lt = /* @__PURE__ */ new WeakMap(), tn = /* @__PURE__ */ new WeakMap(), ze = /* @__PURE__ */ new WeakMap(), nn = /* @__PURE__ */ new WeakMap(), rn = /* @__PURE__ */ new WeakMap(), es);
const Xn = typeof XMLHttpRequest == "function" ? "xhr" : "fetch", tl = Xn === "xhr" ? XMLHttpRequest : Zn, nl = (e, t) => {
  const n = e.options, r = e.applyMiddleware("finalizeOptions", n), s = {}, o = e.applyMiddleware("interceptRequest", void 0, { adapter: Xn, context: e });
  if (o) {
    const f = setTimeout(t, 0, null, o);
    return { abort: () => clearTimeout(f) };
  }
  let i = new tl();
  i instanceof Zn && typeof r.fetch == "object" && i.setInit(r.fetch, r.useAbortSignal ?? !0);
  const a = r.headers, u = r.timeout;
  let c = !1, l = !1, d = !1;
  if (i.onerror = (f) => {
    b(i instanceof Zn ? f instanceof Error ? f : new Error(`Request error while attempting to reach is ${r.url}`, { cause: f }) : new Error(`Request error while attempting to reach is ${r.url}${f.lengthComputable ? `(${f.loaded} of ${f.total} bytes transferred)` : ""}`));
  }, i.ontimeout = (f) => {
    b(new Error(`Request timeout while attempting to reach ${r.url}${f.lengthComputable ? `(${f.loaded} of ${f.total} bytes transferred)` : ""}`));
  }, i.onabort = () => {
    m(!0), c = !0;
  }, i.onreadystatechange = () => {
    u && (m(), s.socket = setTimeout(() => g("ESOCKETTIMEDOUT"), u.socket)), !c && i.readyState === 4 && i.status !== 0 && function() {
      if (!(c || l || d)) {
        if (i.status === 0)
          return void b(new Error("Unknown XHR error"));
        m(), l = !0, t(null, { body: i.response || (i.responseType === "" || i.responseType === "text" ? i.responseText : ""), url: r.url, method: r.method, headers: el(i.getAllResponseHeaders()), statusCode: i.status, statusMessage: i.statusText });
      }
    }();
  }, i.open(r.method, r.url, !0), i.withCredentials = !!r.withCredentials, a && i.setRequestHeader)
    for (const f in a)
      a.hasOwnProperty(f) && i.setRequestHeader(f, a[f]);
  return r.rawBody && (i.responseType = "arraybuffer"), e.applyMiddleware("onRequest", { options: r, adapter: Xn, request: i, context: e }), i.send(r.body || null), u && (s.connect = setTimeout(() => g("ETIMEDOUT"), u.connect)), { abort: function() {
    c = !0, i && i.abort();
  } };
  function g(f) {
    d = !0, i.abort();
    const S = new Error(f === "ESOCKETTIMEDOUT" ? `Socket timed out on request to ${r.url}` : `Connection timed out on request to ${r.url}`);
    S.code = f, e.channels.error.publish(S);
  }
  function m(f) {
    (f || c || i.readyState >= 2 && s.connect) && clearTimeout(s.connect), s.socket && clearTimeout(s.socket);
  }
  function b(f) {
    if (l)
      return;
    m(!0), l = !0, i = null;
    const S = f || new Error(`Network error while attempting to reach ${r.url}`);
    S.isNetworkError = !0, S.request = r, t(S);
  }
}, rl = (e = [], t = nl) => go(e, t);
var ts, ns, Qn = { exports: {} };
function sl() {
  if (ns)
    return ts;
  ns = 1;
  var e = 1e3, t = 60 * e, n = 60 * t, r = 24 * n, s = 7 * r, o = 365.25 * r;
  function i(a, u, c, l) {
    var d = u >= 1.5 * c;
    return Math.round(a / c) + " " + l + (d ? "s" : "");
  }
  return ts = function(a, u) {
    u = u || {};
    var c, l, d = typeof a;
    if (d === "string" && a.length > 0)
      return function(g) {
        if (!((g = String(g)).length > 100)) {
          var m = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(g);
          if (m) {
            var b = parseFloat(m[1]);
            switch ((m[2] || "ms").toLowerCase()) {
              case "years":
              case "year":
              case "yrs":
              case "yr":
              case "y":
                return b * o;
              case "weeks":
              case "week":
              case "w":
                return b * s;
              case "days":
              case "day":
              case "d":
                return b * r;
              case "hours":
              case "hour":
              case "hrs":
              case "hr":
              case "h":
                return b * n;
              case "minutes":
              case "minute":
              case "mins":
              case "min":
              case "m":
                return b * t;
              case "seconds":
              case "second":
              case "secs":
              case "sec":
              case "s":
                return b * e;
              case "milliseconds":
              case "millisecond":
              case "msecs":
              case "msec":
              case "ms":
                return b;
              default:
                return;
            }
          }
        }
      }(a);
    if (d === "number" && isFinite(a))
      return u.long ? (c = a, (l = Math.abs(c)) >= r ? i(c, l, r, "day") : l >= n ? i(c, l, n, "hour") : l >= t ? i(c, l, t, "minute") : l >= e ? i(c, l, e, "second") : c + " ms") : function(g) {
        var m = Math.abs(g);
        return m >= r ? Math.round(g / r) + "d" : m >= n ? Math.round(g / n) + "h" : m >= t ? Math.round(g / t) + "m" : m >= e ? Math.round(g / e) + "s" : g + "ms";
      }(a);
    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(a));
  };
}
var ol = function(e) {
  function t(s) {
    let o, i, a, u = null;
    function c(...l) {
      if (!c.enabled)
        return;
      const d = c, g = Number(/* @__PURE__ */ new Date()), m = g - (o || g);
      d.diff = m, d.prev = o, d.curr = g, o = g, l[0] = t.coerce(l[0]), typeof l[0] != "string" && l.unshift("%O");
      let b = 0;
      l[0] = l[0].replace(/%([a-zA-Z%])/g, (f, S) => {
        if (f === "%%")
          return "%";
        b++;
        const $ = t.formatters[S];
        if (typeof $ == "function") {
          const E = l[b];
          f = $.call(d, E), l.splice(b, 1), b--;
        }
        return f;
      }), t.formatArgs.call(d, l), (d.log || t.log).apply(d, l);
    }
    return c.namespace = s, c.useColors = t.useColors(), c.color = t.selectColor(s), c.extend = n, c.destroy = t.destroy, Object.defineProperty(c, "enabled", { enumerable: !0, configurable: !1, get: () => u !== null ? u : (i !== t.namespaces && (i = t.namespaces, a = t.enabled(s)), a), set: (l) => {
      u = l;
    } }), typeof t.init == "function" && t.init(c), c;
  }
  function n(s, o) {
    const i = t(this.namespace + (typeof o > "u" ? ":" : o) + s);
    return i.log = this.log, i;
  }
  function r(s) {
    return s.toString().substring(2, s.toString().length - 2).replace(/\.\*\?$/, "*");
  }
  return t.debug = t, t.default = t, t.coerce = function(s) {
    return s instanceof Error ? s.stack || s.message : s;
  }, t.disable = function() {
    const s = [...t.names.map(r), ...t.skips.map(r).map((o) => "-" + o)].join(",");
    return t.enable(""), s;
  }, t.enable = function(s) {
    let o;
    t.save(s), t.namespaces = s, t.names = [], t.skips = [];
    const i = (typeof s == "string" ? s : "").split(/[\s,]+/), a = i.length;
    for (o = 0; o < a; o++)
      i[o] && ((s = i[o].replace(/\*/g, ".*?"))[0] === "-" ? t.skips.push(new RegExp("^" + s.slice(1) + "$")) : t.names.push(new RegExp("^" + s + "$")));
  }, t.enabled = function(s) {
    if (s[s.length - 1] === "*")
      return !0;
    let o, i;
    for (o = 0, i = t.skips.length; o < i; o++)
      if (t.skips[o].test(s))
        return !1;
    for (o = 0, i = t.names.length; o < i; o++)
      if (t.names[o].test(s))
        return !0;
    return !1;
  }, t.humanize = sl(), t.destroy = function() {
    console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
  }, Object.keys(e).forEach((s) => {
    t[s] = e[s];
  }), t.names = [], t.skips = [], t.formatters = {}, t.selectColor = function(s) {
    let o = 0;
    for (let i = 0; i < s.length; i++)
      o = (o << 5) - o + s.charCodeAt(i), o |= 0;
    return t.colors[Math.abs(o) % t.colors.length];
  }, t.enable(t.load()), t;
};
(function(e, t) {
  t.formatArgs = function(r) {
    if (r[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + r[0] + (this.useColors ? "%c " : " ") + "+" + e.exports.humanize(this.diff), !this.useColors)
      return;
    const s = "color: " + this.color;
    r.splice(1, 0, s, "color: inherit");
    let o = 0, i = 0;
    r[0].replace(/%[a-zA-Z%]/g, (a) => {
      a !== "%%" && (o++, a === "%c" && (i = o));
    }), r.splice(i, 0, s);
  }, t.save = function(r) {
    try {
      r ? t.storage.setItem("debug", r) : t.storage.removeItem("debug");
    } catch {
    }
  }, t.load = function() {
    let r;
    try {
      r = t.storage.getItem("debug");
    } catch {
    }
    return !r && typeof process < "u" && "env" in process && (r = process.env.DEBUG), r;
  }, t.useColors = function() {
    return !(!(typeof window < "u" && window.process) || window.process.type !== "renderer" && !window.process.__nwjs) || !(typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) && (typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
  }, t.storage = function() {
    try {
      return localStorage;
    } catch {
    }
  }(), t.destroy = /* @__PURE__ */ (() => {
    let r = !1;
    return () => {
      r || (r = !0, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
    };
  })(), t.colors = ["#0000CC", "#0000FF", "#0033CC", "#0033FF", "#0066CC", "#0066FF", "#0099CC", "#0099FF", "#00CC00", "#00CC33", "#00CC66", "#00CC99", "#00CCCC", "#00CCFF", "#3300CC", "#3300FF", "#3333CC", "#3333FF", "#3366CC", "#3366FF", "#3399CC", "#3399FF", "#33CC00", "#33CC33", "#33CC66", "#33CC99", "#33CCCC", "#33CCFF", "#6600CC", "#6600FF", "#6633CC", "#6633FF", "#66CC00", "#66CC33", "#9900CC", "#9900FF", "#9933CC", "#9933FF", "#99CC00", "#99CC33", "#CC0000", "#CC0033", "#CC0066", "#CC0099", "#CC00CC", "#CC00FF", "#CC3300", "#CC3333", "#CC3366", "#CC3399", "#CC33CC", "#CC33FF", "#CC6600", "#CC6633", "#CC9900", "#CC9933", "#CCCC00", "#CCCC33", "#FF0000", "#FF0033", "#FF0066", "#FF0099", "#FF00CC", "#FF00FF", "#FF3300", "#FF3333", "#FF3366", "#FF3399", "#FF33CC", "#FF33FF", "#FF6600", "#FF6633", "#FF9900", "#FF9933", "#FFCC00", "#FFCC33"], t.log = console.debug || console.log || (() => {
  }), e.exports = ol(t);
  const { formatters: n } = e.exports;
  n.j = function(r) {
    try {
      return JSON.stringify(r);
    } catch (s) {
      return "[UnexpectedJSONParseError]: " + s.message;
    }
  };
})(Qn, Qn.exports);
mo(Qn.exports);
const il = typeof Buffer > "u" ? () => !1 : (e) => Buffer.isBuffer(e);
function rs(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function al(e) {
  if (rs(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const n = t.prototype;
  return !(rs(n) === !1 || n.hasOwnProperty("isPrototypeOf") === !1);
}
const cl = ["boolean", "string", "number"];
function ul() {
  return { processOptions: (e) => {
    const t = e.body;
    return !t || typeof t.pipe == "function" || il(t) || cl.indexOf(typeof t) === -1 && !Array.isArray(t) && !al(t) ? e : Object.assign({}, e, { body: JSON.stringify(e.body), headers: Object.assign({}, e.headers, { "Content-Type": "application/json" }) });
  } };
}
function ll(e) {
  return { onResponse: (n) => {
    const r = n.headers["content-type"] || "", s = r.indexOf("application/json") !== -1;
    return n.body && r && s ? Object.assign({}, n, { body: t(n.body) }) : n;
  }, processOptions: (n) => Object.assign({}, n, { headers: Object.assign({ Accept: "application/json" }, n.headers) }) };
  function t(n) {
    try {
      return JSON.parse(n);
    } catch (r) {
      throw r.message = `Failed to parsed response body as JSON: ${r.message}`, r;
    }
  }
}
let $t = {};
typeof globalThis < "u" ? $t = globalThis : typeof window < "u" ? $t = window : typeof global < "u" ? $t = global : typeof self < "u" && ($t = self);
var dl = $t;
function pl(e = {}) {
  const t = e.implementation || dl.Observable;
  if (!t)
    throw new Error("`Observable` is not available in global scope, and no implementation was passed");
  return { onReturn: (n, r) => new t((s) => (n.error.subscribe((o) => s.error(o)), n.progress.subscribe((o) => s.next(Object.assign({ type: "progress" }, o))), n.response.subscribe((o) => {
    s.next(Object.assign({ type: "response" }, o)), s.complete();
  }), n.request.publish(r), () => n.abort.publish())) };
}
function fl() {
  return { onRequest: (e) => {
    if (e.adapter !== "xhr")
      return;
    const t = e.request, n = e.context;
    function r(s) {
      return (o) => {
        const i = o.lengthComputable ? o.loaded / o.total * 100 : -1;
        n.channels.progress.publish({ stage: s, percent: i, total: o.total, loaded: o.loaded, lengthComputable: o.lengthComputable });
      };
    }
    "upload" in t && "onprogress" in t.upload && (t.upload.onprogress = r("upload")), "onprogress" in t && (t.onprogress = r("download"));
  } };
}
var vo = (e, t, n) => (n.method === "GET" || n.method === "HEAD") && (e.isNetworkError || !1);
function hl(e) {
  return 100 * Math.pow(2, e) + 100 * Math.random();
}
const vr = (e = {}) => ((t) => {
  const n = t.maxRetries || 5, r = t.retryDelay || hl, s = t.shouldRetry;
  return { onError: (o, i) => {
    const a = i.options, u = a.maxRetries || n, c = a.retryDelay || r, l = a.shouldRetry || s, d = a.attemptNumber || 0;
    if ((g = a.body) !== null && typeof g == "object" && typeof g.pipe == "function" || !l(o, d, a) || d >= u)
      return o;
    var g;
    const m = Object.assign({}, i, { options: Object.assign({}, a, { attemptNumber: d + 1 }) });
    return setTimeout(() => i.channels.request.publish(m), c(d)), null;
  } };
})({ shouldRetry: vo, ...e });
vr.shouldRetry = vo;
var er = function(e, t) {
  return er = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var s in r)
      Object.prototype.hasOwnProperty.call(r, s) && (n[s] = r[s]);
  }, er(e, t);
};
function yr(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  er(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
function ml(e, t, n, r) {
  function s(o) {
    return o instanceof n ? o : new n(function(i) {
      i(o);
    });
  }
  return new (n || (n = Promise))(function(o, i) {
    function a(l) {
      try {
        c(r.next(l));
      } catch (d) {
        i(d);
      }
    }
    function u(l) {
      try {
        c(r.throw(l));
      } catch (d) {
        i(d);
      }
    }
    function c(l) {
      l.done ? o(l.value) : s(l.value).then(a, u);
    }
    c((r = r.apply(e, t || [])).next());
  });
}
function yo(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1)
      throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, s, o, i = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return i.next = a(0), i.throw = a(1), i.return = a(2), typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function a(c) {
    return function(l) {
      return u([c, l]);
    };
  }
  function u(c) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; i && (i = 0, c[0] && (n = 0)), n; )
      try {
        if (r = 1, s && (o = c[0] & 2 ? s.return : c[0] ? s.throw || ((o = s.return) && o.call(s), 0) : s.next) && !(o = o.call(s, c[1])).done)
          return o;
        switch (s = 0, o && (c = [c[0] & 2, o.value]), c[0]) {
          case 0:
          case 1:
            o = c;
            break;
          case 4:
            return n.label++, { value: c[1], done: !1 };
          case 5:
            n.label++, s = c[1], c = [0];
            continue;
          case 7:
            c = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              n = 0;
              continue;
            }
            if (c[0] === 3 && (!o || c[1] > o[0] && c[1] < o[3])) {
              n.label = c[1];
              break;
            }
            if (c[0] === 6 && n.label < o[1]) {
              n.label = o[1], o = c;
              break;
            }
            if (o && n.label < o[2]) {
              n.label = o[2], n.ops.push(c);
              break;
            }
            o[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        c = t.call(e, n);
      } catch (l) {
        c = [6, l], s = 0;
      } finally {
        r = o = 0;
      }
    if (c[0] & 5)
      throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
function Vt(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n)
    return n.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function ot(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), s, o = [], i;
  try {
    for (; (t === void 0 || t-- > 0) && !(s = r.next()).done; )
      o.push(s.value);
  } catch (a) {
    i = { error: a };
  } finally {
    try {
      s && !s.done && (n = r.return) && n.call(r);
    } finally {
      if (i)
        throw i.error;
    }
  }
  return o;
}
function it(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, s = t.length, o; r < s; r++)
      (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}
function mt(e) {
  return this instanceof mt ? (this.v = e, this) : new mt(e);
}
function gl(e, t, n) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var r = n.apply(e, t || []), s, o = [];
  return s = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), a("next"), a("throw"), a("return", i), s[Symbol.asyncIterator] = function() {
    return this;
  }, s;
  function i(m) {
    return function(b) {
      return Promise.resolve(b).then(m, d);
    };
  }
  function a(m, b) {
    r[m] && (s[m] = function(f) {
      return new Promise(function(S, $) {
        o.push([m, f, S, $]) > 1 || u(m, f);
      });
    }, b && (s[m] = b(s[m])));
  }
  function u(m, b) {
    try {
      c(r[m](b));
    } catch (f) {
      g(o[0][3], f);
    }
  }
  function c(m) {
    m.value instanceof mt ? Promise.resolve(m.value.v).then(l, d) : g(o[0][2], m);
  }
  function l(m) {
    u("next", m);
  }
  function d(m) {
    u("throw", m);
  }
  function g(m, b) {
    m(b), o.shift(), o.length && u(o[0][0], o[0][1]);
  }
}
function vl(e) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var t = e[Symbol.asyncIterator], n;
  return t ? t.call(e) : (e = typeof Vt == "function" ? Vt(e) : e[Symbol.iterator](), n = {}, r("next"), r("throw"), r("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n);
  function r(o) {
    n[o] = e[o] && function(i) {
      return new Promise(function(a, u) {
        i = e[o](i), s(a, u, i.done, i.value);
      });
    };
  }
  function s(o, i, a, u) {
    Promise.resolve(u).then(function(c) {
      o({ value: c, done: a });
    }, i);
  }
}
function ge(e) {
  return typeof e == "function";
}
function bo(e) {
  var t = function(r) {
    Error.call(r), r.stack = new Error().stack;
  }, n = e(t);
  return n.prototype = Object.create(Error.prototype), n.prototype.constructor = n, n;
}
var Bn = bo(function(e) {
  return function(t) {
    e(this), this.message = t ? t.length + ` errors occurred during unsubscription:
` + t.map(function(n, r) {
      return r + 1 + ") " + n.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = t;
  };
});
function ss(e, t) {
  if (e) {
    var n = e.indexOf(t);
    0 <= n && e.splice(n, 1);
  }
}
var br = function() {
  function e(t) {
    this.initialTeardown = t, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return e.prototype.unsubscribe = function() {
    var t, n, r, s, o;
    if (!this.closed) {
      this.closed = !0;
      var i = this._parentage;
      if (i)
        if (this._parentage = null, Array.isArray(i))
          try {
            for (var a = Vt(i), u = a.next(); !u.done; u = a.next()) {
              var c = u.value;
              c.remove(this);
            }
          } catch (f) {
            t = { error: f };
          } finally {
            try {
              u && !u.done && (n = a.return) && n.call(a);
            } finally {
              if (t)
                throw t.error;
            }
          }
        else
          i.remove(this);
      var l = this.initialTeardown;
      if (ge(l))
        try {
          l();
        } catch (f) {
          o = f instanceof Bn ? f.errors : [f];
        }
      var d = this._finalizers;
      if (d) {
        this._finalizers = null;
        try {
          for (var g = Vt(d), m = g.next(); !m.done; m = g.next()) {
            var b = m.value;
            try {
              os(b);
            } catch (f) {
              o = o ?? [], f instanceof Bn ? o = it(it([], ot(o)), ot(f.errors)) : o.push(f);
            }
          }
        } catch (f) {
          r = { error: f };
        } finally {
          try {
            m && !m.done && (s = g.return) && s.call(g);
          } finally {
            if (r)
              throw r.error;
          }
        }
      }
      if (o)
        throw new Bn(o);
    }
  }, e.prototype.add = function(t) {
    var n;
    if (t && t !== this)
      if (this.closed)
        os(t);
      else {
        if (t instanceof e) {
          if (t.closed || t._hasParent(this))
            return;
          t._addParent(this);
        }
        (this._finalizers = (n = this._finalizers) !== null && n !== void 0 ? n : []).push(t);
      }
  }, e.prototype._hasParent = function(t) {
    var n = this._parentage;
    return n === t || Array.isArray(n) && n.includes(t);
  }, e.prototype._addParent = function(t) {
    var n = this._parentage;
    this._parentage = Array.isArray(n) ? (n.push(t), n) : n ? [n, t] : t;
  }, e.prototype._removeParent = function(t) {
    var n = this._parentage;
    n === t ? this._parentage = null : Array.isArray(n) && ss(n, t);
  }, e.prototype.remove = function(t) {
    var n = this._finalizers;
    n && ss(n, t), t instanceof e && t._removeParent(this);
  }, e.EMPTY = function() {
    var t = new e();
    return t.closed = !0, t;
  }(), e;
}();
br.EMPTY;
function wo(e) {
  return e instanceof br || e && "closed" in e && ge(e.remove) && ge(e.add) && ge(e.unsubscribe);
}
function os(e) {
  ge(e) ? e() : e.unsubscribe();
}
var _o = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: void 0,
  useDeprecatedSynchronousErrorHandling: !1,
  useDeprecatedNextContext: !1
}, yl = {
  setTimeout: function(e, t) {
    for (var n = [], r = 2; r < arguments.length; r++)
      n[r - 2] = arguments[r];
    return setTimeout.apply(void 0, it([e, t], ot(n)));
  },
  clearTimeout: function(e) {
    return clearTimeout(e);
  },
  delegate: void 0
};
function So(e) {
  yl.setTimeout(function() {
    throw e;
  });
}
function is() {
}
function bl(e) {
  e();
}
var wr = function(e) {
  yr(t, e);
  function t(n) {
    var r = e.call(this) || this;
    return r.isStopped = !1, n ? (r.destination = n, wo(n) && n.add(r)) : r.destination = Cl, r;
  }
  return t.create = function(n, r, s) {
    return new tr(n, r, s);
  }, t.prototype.next = function(n) {
    this.isStopped || this._next(n);
  }, t.prototype.error = function(n) {
    this.isStopped || (this.isStopped = !0, this._error(n));
  }, t.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, t.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, e.prototype.unsubscribe.call(this), this.destination = null);
  }, t.prototype._next = function(n) {
    this.destination.next(n);
  }, t.prototype._error = function(n) {
    try {
      this.destination.error(n);
    } finally {
      this.unsubscribe();
    }
  }, t.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, t;
}(br), wl = Function.prototype.bind;
function Vn(e, t) {
  return wl.call(e, t);
}
var _l = function() {
  function e(t) {
    this.partialObserver = t;
  }
  return e.prototype.next = function(t) {
    var n = this.partialObserver;
    if (n.next)
      try {
        n.next(t);
      } catch (r) {
        sn(r);
      }
  }, e.prototype.error = function(t) {
    var n = this.partialObserver;
    if (n.error)
      try {
        n.error(t);
      } catch (r) {
        sn(r);
      }
    else
      sn(t);
  }, e.prototype.complete = function() {
    var t = this.partialObserver;
    if (t.complete)
      try {
        t.complete();
      } catch (n) {
        sn(n);
      }
  }, e;
}(), tr = function(e) {
  yr(t, e);
  function t(n, r, s) {
    var o = e.call(this) || this, i;
    if (ge(n) || !n)
      i = {
        next: n ?? void 0,
        error: r ?? void 0,
        complete: s ?? void 0
      };
    else {
      var a;
      o && _o.useDeprecatedNextContext ? (a = Object.create(n), a.unsubscribe = function() {
        return o.unsubscribe();
      }, i = {
        next: n.next && Vn(n.next, a),
        error: n.error && Vn(n.error, a),
        complete: n.complete && Vn(n.complete, a)
      }) : i = n;
    }
    return o.destination = new _l(i), o;
  }
  return t;
}(wr);
function sn(e) {
  So(e);
}
function Sl(e) {
  throw e;
}
var Cl = {
  closed: !0,
  next: is,
  error: Sl,
  complete: is
}, _r = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function Co(e) {
  return e;
}
function xl() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return xo(e);
}
function xo(e) {
  return e.length === 0 ? Co : e.length === 1 ? e[0] : function(t) {
    return e.reduce(function(n, r) {
      return r(n);
    }, t);
  };
}
var Oe = function() {
  function e(t) {
    t && (this._subscribe = t);
  }
  return e.prototype.lift = function(t) {
    var n = new e();
    return n.source = this, n.operator = t, n;
  }, e.prototype.subscribe = function(t, n, r) {
    var s = this, o = $l(t) ? t : new tr(t, n, r);
    return bl(function() {
      var i = s, a = i.operator, u = i.source;
      o.add(a ? a.call(o, u) : u ? s._subscribe(o) : s._trySubscribe(o));
    }), o;
  }, e.prototype._trySubscribe = function(t) {
    try {
      return this._subscribe(t);
    } catch (n) {
      t.error(n);
    }
  }, e.prototype.forEach = function(t, n) {
    var r = this;
    return n = as(n), new n(function(s, o) {
      var i = new tr({
        next: function(a) {
          try {
            t(a);
          } catch (u) {
            o(u), i.unsubscribe();
          }
        },
        error: o,
        complete: s
      });
      r.subscribe(i);
    });
  }, e.prototype._subscribe = function(t) {
    var n;
    return (n = this.source) === null || n === void 0 ? void 0 : n.subscribe(t);
  }, e.prototype[_r] = function() {
    return this;
  }, e.prototype.pipe = function() {
    for (var t = [], n = 0; n < arguments.length; n++)
      t[n] = arguments[n];
    return xo(t)(this);
  }, e.prototype.toPromise = function(t) {
    var n = this;
    return t = as(t), new t(function(r, s) {
      var o;
      n.subscribe(function(i) {
        return o = i;
      }, function(i) {
        return s(i);
      }, function() {
        return r(o);
      });
    });
  }, e.create = function(t) {
    return new e(t);
  }, e;
}();
function as(e) {
  var t;
  return (t = e ?? _o.Promise) !== null && t !== void 0 ? t : Promise;
}
function Tl(e) {
  return e && ge(e.next) && ge(e.error) && ge(e.complete);
}
function $l(e) {
  return e && e instanceof wr || Tl(e) && wo(e);
}
function Ol(e) {
  return ge(e == null ? void 0 : e.lift);
}
function Sr(e) {
  return function(t) {
    if (Ol(t))
      return t.lift(function(n) {
        try {
          return e(n, this);
        } catch (r) {
          this.error(r);
        }
      });
    throw new TypeError("Unable to lift unknown Observable type");
  };
}
function Cr(e, t, n, r, s) {
  return new kl(e, t, n, r, s);
}
var kl = function(e) {
  yr(t, e);
  function t(n, r, s, o, i, a) {
    var u = e.call(this, n) || this;
    return u.onFinalize = i, u.shouldUnsubscribe = a, u._next = r ? function(c) {
      try {
        r(c);
      } catch (l) {
        n.error(l);
      }
    } : e.prototype._next, u._error = o ? function(c) {
      try {
        o(c);
      } catch (l) {
        n.error(l);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._error, u._complete = s ? function() {
      try {
        s();
      } catch (c) {
        n.error(c);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._complete, u;
  }
  return t.prototype.unsubscribe = function() {
    var n;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var r = this.closed;
      e.prototype.unsubscribe.call(this), !r && ((n = this.onFinalize) === null || n === void 0 || n.call(this));
    }
  }, t;
}(wr);
function El(e) {
  return e[e.length - 1];
}
function Il(e) {
  return ge(El(e)) ? e.pop() : void 0;
}
var Pl = function(e) {
  return e && typeof e.length == "number" && typeof e != "function";
};
function Rl(e) {
  return ge(e == null ? void 0 : e.then);
}
function Al(e) {
  return ge(e[_r]);
}
function jl(e) {
  return Symbol.asyncIterator && ge(e == null ? void 0 : e[Symbol.asyncIterator]);
}
function Dl(e) {
  return new TypeError("You provided " + (e !== null && typeof e == "object" ? "an invalid object" : "'" + e + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
function Ll() {
  return typeof Symbol != "function" || !Symbol.iterator ? "@@iterator" : Symbol.iterator;
}
var Ml = Ll();
function Nl(e) {
  return ge(e == null ? void 0 : e[Ml]);
}
function Ul(e) {
  return gl(this, arguments, function() {
    var t, n, r, s;
    return yo(this, function(o) {
      switch (o.label) {
        case 0:
          t = e.getReader(), o.label = 1;
        case 1:
          o.trys.push([1, , 9, 10]), o.label = 2;
        case 2:
          return [4, mt(t.read())];
        case 3:
          return n = o.sent(), r = n.value, s = n.done, s ? [4, mt(void 0)] : [3, 5];
        case 4:
          return [2, o.sent()];
        case 5:
          return [4, mt(r)];
        case 6:
          return [4, o.sent()];
        case 7:
          return o.sent(), [3, 2];
        case 8:
          return [3, 10];
        case 9:
          return t.releaseLock(), [7];
        case 10:
          return [2];
      }
    });
  });
}
function ql(e) {
  return ge(e == null ? void 0 : e.getReader);
}
function Fl(e) {
  if (e instanceof Oe)
    return e;
  if (e != null) {
    if (Al(e))
      return Bl(e);
    if (Pl(e))
      return Vl(e);
    if (Rl(e))
      return zl(e);
    if (jl(e))
      return To(e);
    if (Nl(e))
      return Hl(e);
    if (ql(e))
      return Wl(e);
  }
  throw Dl(e);
}
function Bl(e) {
  return new Oe(function(t) {
    var n = e[_r]();
    if (ge(n.subscribe))
      return n.subscribe(t);
    throw new TypeError("Provided object does not correctly implement Symbol.observable");
  });
}
function Vl(e) {
  return new Oe(function(t) {
    for (var n = 0; n < e.length && !t.closed; n++)
      t.next(e[n]);
    t.complete();
  });
}
function zl(e) {
  return new Oe(function(t) {
    e.then(function(n) {
      t.closed || (t.next(n), t.complete());
    }, function(n) {
      return t.error(n);
    }).then(null, So);
  });
}
function Hl(e) {
  return new Oe(function(t) {
    var n, r;
    try {
      for (var s = Vt(e), o = s.next(); !o.done; o = s.next()) {
        var i = o.value;
        if (t.next(i), t.closed)
          return;
      }
    } catch (a) {
      n = { error: a };
    } finally {
      try {
        o && !o.done && (r = s.return) && r.call(s);
      } finally {
        if (n)
          throw n.error;
      }
    }
    t.complete();
  });
}
function To(e) {
  return new Oe(function(t) {
    Yl(e, t).catch(function(n) {
      return t.error(n);
    });
  });
}
function Wl(e) {
  return To(Ul(e));
}
function Yl(e, t) {
  var n, r, s, o;
  return ml(this, void 0, void 0, function() {
    var i, a;
    return yo(this, function(u) {
      switch (u.label) {
        case 0:
          u.trys.push([0, 5, 6, 11]), n = vl(e), u.label = 1;
        case 1:
          return [4, n.next()];
        case 2:
          if (r = u.sent(), !!r.done)
            return [3, 4];
          if (i = r.value, t.next(i), t.closed)
            return [2];
          u.label = 3;
        case 3:
          return [3, 1];
        case 4:
          return [3, 11];
        case 5:
          return a = u.sent(), s = { error: a }, [3, 11];
        case 6:
          return u.trys.push([6, , 9, 10]), r && !r.done && (o = n.return) ? [4, o.call(n)] : [3, 8];
        case 7:
          u.sent(), u.label = 8;
        case 8:
          return [3, 10];
        case 9:
          if (s)
            throw s.error;
          return [7];
        case 10:
          return [7];
        case 11:
          return t.complete(), [2];
      }
    });
  });
}
function $o(e, t) {
  return Fl(e);
}
var Kl = bo(function(e) {
  return function() {
    e(this), this.name = "EmptyError", this.message = "no elements in sequence";
  };
});
function fe(e, t) {
  return new Promise(function(n, r) {
    var s = !1, o;
    e.subscribe({
      next: function(i) {
        o = i, s = !0;
      },
      error: r,
      complete: function() {
        s ? n(o) : r(new Kl());
      }
    });
  });
}
function Ve(e, t) {
  return Sr(function(n, r) {
    var s = 0;
    n.subscribe(Cr(r, function(o) {
      r.next(e.call(t, o, s++));
    }));
  });
}
var Gl = Array.isArray;
function Jl(e, t) {
  return Gl(t) ? e.apply(void 0, it([], ot(t))) : e(t);
}
function Zl(e) {
  return Ve(function(t) {
    return Jl(e, t);
  });
}
function Xl(e, t, n) {
  return n === void 0 && (n = Co), function(r) {
    cs(t, function() {
      for (var s = e.length, o = new Array(s), i = s, a = s, u = function(l) {
        cs(t, function() {
          var d = $o(e[l]), g = !1;
          d.subscribe(Cr(r, function(m) {
            o[l] = m, g || (g = !0, a--), a || r.next(n(o.slice()));
          }, function() {
            --i || r.complete();
          }));
        }, r);
      }, c = 0; c < s; c++)
        u(c);
    });
  };
}
function cs(e, t, n) {
  t();
}
var Ql = Array.isArray;
function ed(e) {
  return e.length === 1 && Ql(e[0]) ? e[0] : e;
}
function Wt(e, t) {
  return Sr(function(n, r) {
    var s = 0;
    n.subscribe(Cr(r, function(o) {
      return e.call(t, o, s++) && r.next(o);
    }));
  });
}
function Oo() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var n = Il(e);
  return n ? xl(Oo.apply(void 0, it([], ot(e))), Zl(n)) : Sr(function(r, s) {
    Xl(it([r], ot(ed(e))))(s);
  });
}
function td() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return Oo.apply(void 0, it([], ot(e)));
}
var ko = { 0: 8203, 1: 8204, 2: 8205, 3: 8290, 4: 8291, 5: 8288, 6: 65279, 7: 8289, 8: 119155, 9: 119156, a: 119157, b: 119158, c: 119159, d: 119160, e: 119161, f: 119162 }, xr = { 0: 8203, 1: 8204, 2: 8205, 3: 65279 }, nd = new Array(4).fill(String.fromCodePoint(xr[0])).join("");
function rd(e) {
  let t = JSON.stringify(e);
  return `${nd}${Array.from(t).map((n) => {
    let r = n.charCodeAt(0);
    if (r > 255)
      throw new Error(`Only ASCII edit info can be encoded. Error attempting to encode ${t} on character ${n} (${r})`);
    return Array.from(r.toString(4).padStart(4, "0")).map((s) => String.fromCodePoint(xr[s])).join("");
  }).join("")}`;
}
function sd(e) {
  return !Number.isNaN(Number(e)) || /[a-z]/i.test(e) && !/\d+(?:[-:\/]\d+){2}(?:T\d+(?:[-:\/]\d+){1,2}(\.\d+)?Z?)?/.test(e) ? !1 : !!Date.parse(e);
}
function od(e) {
  try {
    new URL(e, e.startsWith("/") ? "https://acme.com" : void 0);
  } catch {
    return !1;
  }
  return !0;
}
function Fh(e, t, n = "auto") {
  return n === !0 || n === "auto" && (sd(e) || od(e)) ? e : `${e}${rd(t)}`;
}
Object.fromEntries(Object.entries(xr).map((e) => e.reverse()));
Object.fromEntries(Object.entries(ko).map((e) => e.reverse()));
var id = `${Object.values(ko).map((e) => `\\u{${e.toString(16)}}`).join("")}`, us = new RegExp(`[${id}]{4,}`, "gu");
function ad(e) {
  var t;
  return { cleaned: e.replace(us, ""), encoded: ((t = e.match(us)) == null ? void 0 : t[0]) || "" };
}
function cd(e) {
  return e && JSON.parse(ad(JSON.stringify(e)).cleaned);
}
function ud(e) {
  return cd(e);
}
class ld extends Error {
  constructor(t) {
    const n = Eo(t);
    super(n.message), H(this, "response"), H(this, "statusCode", 400), H(this, "responseBody"), H(this, "details"), Object.assign(this, n);
  }
}
class dd extends Error {
  constructor(t) {
    const n = Eo(t);
    super(n.message), H(this, "response"), H(this, "statusCode", 500), H(this, "responseBody"), H(this, "details"), Object.assign(this, n);
  }
}
function Eo(e) {
  const t = e.body, n = {
    response: e,
    statusCode: e.statusCode,
    responseBody: md(t, e),
    message: "",
    details: void 0
  };
  if (t.error && t.message)
    return n.message = `${t.error} - ${t.message}`, n;
  if (pd(t) || fd(t)) {
    const r = t.error.items || [], s = r.slice(0, 5).map((i) => {
      var a;
      return (a = i.error) == null ? void 0 : a.description;
    }).filter(Boolean);
    let o = s.length ? `:
- ${s.join(`
- `)}` : "";
    return r.length > 5 && (o += `
...and ${r.length - 5} more`), n.message = `${t.error.description}${o}`, n.details = t.error, n;
  }
  return t.error && t.error.description ? (n.message = t.error.description, n.details = t.error, n) : (n.message = t.error || t.message || hd(e), n);
}
function pd(e) {
  return wn(e) && wn(e.error) && e.error.type === "mutationError" && typeof e.error.description == "string";
}
function fd(e) {
  return wn(e) && wn(e.error) && e.error.type === "actionError" && typeof e.error.description == "string";
}
function wn(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
function hd(e) {
  const t = e.statusMessage ? ` ${e.statusMessage}` : "";
  return `${e.method}-request to ${e.url} resulted in HTTP ${e.statusCode}${t}`;
}
function md(e, t) {
  return (t.headers["content-type"] || "").toLowerCase().indexOf("application/json") !== -1 ? JSON.stringify(e, null, 2) : e;
}
class gd extends Error {
  constructor({ projectId: t }) {
    super("CorsOriginError"), H(this, "projectId"), H(this, "addOriginUrl"), this.name = "CorsOriginError", this.projectId = t;
    const n = new URL(`https://sanity.io/manage/project/${t}/api`);
    if (typeof location < "u") {
      const { origin: r } = location;
      n.searchParams.set("cors", "add"), n.searchParams.set("origin", r), this.addOriginUrl = n, this.message = `The current origin is not allowed to connect to the Live Content API. Add it here: ${n}`;
    } else
      this.message = `The current origin is not allowed to connect to the Live Content API. Change your configuration here: ${n}`;
  }
}
const vd = {
  onResponse: (e) => {
    if (e.statusCode >= 500)
      throw new dd(e);
    if (e.statusCode >= 400)
      throw new ld(e);
    return e;
  }
}, yd = {
  onResponse: (e) => {
    const t = e.headers["x-sanity-warning"];
    return (Array.isArray(t) ? t : [t]).filter(Boolean).forEach((n) => console.warn(n)), e;
  }
};
function bd(e) {
  return rl([
    vr({ shouldRetry: wd }),
    ...e,
    yd,
    ul(),
    ll(),
    fl(),
    vd,
    pl({ implementation: Oe })
  ]);
}
function wd(e, t, n) {
  if (n.maxRetries === 0)
    return !1;
  const r = n.method === "GET" || n.method === "HEAD", s = (n.uri || n.url).startsWith("/data/query"), o = e.response && (e.response.statusCode === 429 || e.response.statusCode === 502 || e.response.statusCode === 503);
  return (r || s) && o ? !0 : vr.shouldRetry(e, t, n);
}
const _d = "https://www.sanity.io/help/";
function Tr(e) {
  return _d + e;
}
const ls = ["image", "file"], ds = ["before", "after", "replace"], Io = (e) => {
  if (!/^(~[a-z0-9]{1}[-\w]{0,63}|[a-z0-9]{1}[-\w]{0,63})$/.test(e))
    throw new Error(
      "Datasets can only contain lowercase characters, numbers, underscores and dashes, and start with tilde, and be maximum 64 characters"
    );
}, Sd = (e) => {
  if (!/^[-a-z0-9]+$/i.test(e))
    throw new Error("`projectId` can only contain only a-z, 0-9 and dashes");
}, Cd = (e) => {
  if (ls.indexOf(e) === -1)
    throw new Error(`Invalid asset type: ${e}. Must be one of ${ls.join(", ")}`);
}, Dt = (e, t) => {
  if (t === null || typeof t != "object" || Array.isArray(t))
    throw new Error(`${e}() takes an object of properties`);
}, Po = (e, t) => {
  if (typeof t != "string" || !/^[a-z0-9_][a-z0-9_.-]{0,127}$/i.test(t) || t.includes(".."))
    throw new Error(`${e}(): "${t}" is not a valid document ID`);
}, _n = (e, t) => {
  if (!t._id)
    throw new Error(`${e}() requires that the document contains an ID ("_id" property)`);
  Po(e, t._id);
}, xd = (e, t, n) => {
  const r = "insert(at, selector, items)";
  if (ds.indexOf(e) === -1) {
    const s = ds.map((o) => `"${o}"`).join(", ");
    throw new Error(`${r} takes an "at"-argument which is one of: ${s}`);
  }
  if (typeof t != "string")
    throw new Error(`${r} takes a "selector"-argument which must be a string`);
  if (!Array.isArray(n))
    throw new Error(`${r} takes an "items"-argument which must be an array`);
}, Ro = (e) => {
  if (!e.dataset)
    throw new Error("`dataset` must be provided to perform queries");
  return e.dataset || "";
}, Ao = (e) => {
  if (typeof e != "string" || !/^[a-z0-9._-]{1,75}$/i.test(e))
    throw new Error(
      "Tag can only contain alphanumeric characters, underscores, dashes and dots, and be between one and 75 characters long."
    );
  return e;
};
function Td(e) {
  let t = !1, n;
  return (...r) => (t || (n = e(...r), t = !0), n);
}
const Yt = (e) => (
  // eslint-disable-next-line no-console
  Td((...t) => console.warn(e.join(" "), ...t))
), $d = Yt([
  "Because you set `withCredentials` to true, we will override your `useCdn`",
  "setting to be false since (cookie-based) credentials are never set on the CDN"
]), Od = Yt([
  "Since you haven't set a value for `useCdn`, we will deliver content using our",
  "global, edge-cached API-CDN. If you wish to have content delivered faster, set",
  "`useCdn: false` to use the Live API. Note: You may incur higher costs using the live API."
]), kd = Yt([
  "The Sanity client is configured with the `perspective` set to `previewDrafts`, which doesn't support the API-CDN.",
  "The Live API will be used instead. Set `useCdn: false` in your configuration to hide this warning."
]), Ed = Yt([
  "You have configured Sanity client to use a token in the browser. This may cause unintentional security issues.",
  `See ${Tr(
    "js-client-browser-token"
  )} for more information and how to hide this warning.`
]), Id = Yt([
  "Using the Sanity client without specifying an API version is deprecated.",
  `See ${Tr("js-client-api-version")}`
]), Pd = "apicdn.sanity.io", Lt = {
  apiHost: "https://api.sanity.io",
  apiVersion: "1",
  useProjectHostname: !0,
  stega: { enabled: !1 }
}, Rd = ["localhost", "127.0.0.1", "0.0.0.0"], Ad = (e) => Rd.indexOf(e) !== -1;
function jd(e) {
  if (e === "1" || e === "X")
    return;
  const t = new Date(e);
  if (!(/^\d{4}-\d{2}-\d{2}$/.test(e) && t instanceof Date && t.getTime() > 0))
    throw new Error("Invalid API version string, expected `1` or date in format `YYYY-MM-DD`");
}
function jo(e) {
  if (Array.isArray(e)) {
    for (const t of e)
      if (t !== "published" && t !== "drafts" && !(typeof t == "string" && t.startsWith("r") && t !== "raw"))
        throw new TypeError(
          "Invalid API perspective value, expected `published`, `drafts` or a valid release identifier string"
        );
    return;
  }
  switch (e) {
    case "previewDrafts":
    case "drafts":
    case "published":
    case "raw":
      return;
    default:
      throw new TypeError(
        "Invalid API perspective string, expected `published`, `previewDrafts` or `raw`"
      );
  }
}
const Do = (e, t) => {
  const n = {
    ...t,
    ...e,
    stega: {
      ...typeof t.stega == "boolean" ? { enabled: t.stega } : t.stega || Lt.stega,
      ...typeof e.stega == "boolean" ? { enabled: e.stega } : e.stega || {}
    }
  };
  n.apiVersion || Id();
  const r = {
    ...Lt,
    ...n
  }, s = r.useProjectHostname;
  if (typeof Promise > "u") {
    const d = Tr("js-client-promise-polyfill");
    throw new Error(`No native Promise-implementation found, polyfill needed - see ${d}`);
  }
  if (s && !r.projectId)
    throw new Error("Configuration must contain `projectId`");
  if (typeof r.perspective < "u" && jo(r.perspective), "encodeSourceMap" in r)
    throw new Error(
      "It looks like you're using options meant for '@sanity/preview-kit/client'. 'encodeSourceMap' is not supported in '@sanity/client'. Did you mean 'stega.enabled'?"
    );
  if ("encodeSourceMapAtPath" in r)
    throw new Error(
      "It looks like you're using options meant for '@sanity/preview-kit/client'. 'encodeSourceMapAtPath' is not supported in '@sanity/client'. Did you mean 'stega.filter'?"
    );
  if (typeof r.stega.enabled != "boolean")
    throw new Error(`stega.enabled must be a boolean, received ${r.stega.enabled}`);
  if (r.stega.enabled && r.stega.studioUrl === void 0)
    throw new Error("stega.studioUrl must be defined when stega.enabled is true");
  if (r.stega.enabled && typeof r.stega.studioUrl != "string" && typeof r.stega.studioUrl != "function")
    throw new Error(
      `stega.studioUrl must be a string or a function, received ${r.stega.studioUrl}`
    );
  const o = typeof window < "u" && window.location && window.location.hostname, i = o && Ad(window.location.hostname);
  o && i && r.token && r.ignoreBrowserTokenWarning !== !0 ? Ed() : typeof r.useCdn > "u" && Od(), s && Sd(r.projectId), r.dataset && Io(r.dataset), "requestTagPrefix" in r && (r.requestTagPrefix = r.requestTagPrefix ? Ao(r.requestTagPrefix).replace(/\.+$/, "") : void 0), r.apiVersion = `${r.apiVersion}`.replace(/^v/, ""), r.isDefaultApi = r.apiHost === Lt.apiHost, r.useCdn === !0 && r.withCredentials && $d(), r.useCdn = r.useCdn !== !1 && !r.withCredentials, jd(r.apiVersion);
  const a = r.apiHost.split("://", 2), u = a[0], c = a[1], l = r.isDefaultApi ? Pd : c;
  return r.useProjectHostname ? (r.url = `${u}://${r.projectId}.${c}/v${r.apiVersion}`, r.cdnUrl = `${u}://${r.projectId}.${l}/v${r.apiVersion}`) : (r.url = `${r.apiHost}/v${r.apiVersion}`, r.cdnUrl = r.url), r;
};
function Lo(e) {
  if (typeof e == "string")
    return { id: e };
  if (Array.isArray(e))
    return { query: "*[_id in $ids]", params: { ids: e } };
  if (typeof e == "object" && e !== null && "query" in e && typeof e.query == "string")
    return "params" in e && typeof e.params == "object" && e.params !== null ? { query: e.query, params: e.params } : { query: e.query };
  const t = [
    "* Document ID (<docId>)",
    "* Array of document IDs",
    "* Object containing `query`"
  ].join(`
`);
  throw new Error(`Unknown selection - must be one of:

${t}`);
}
class Mo {
  constructor(t, n = {}) {
    H(this, "selection"), H(this, "operations"), this.selection = t, this.operations = n;
  }
  /**
   * Sets the given attributes to the document. Does NOT merge objects.
   * The operation is added to the current patch, ready to be commited by `commit()`
   *
   * @param attrs - Attributes to set. To set a deep attribute, use JSONMatch, eg: \{"nested.prop": "value"\}
   */
  set(t) {
    return this._assign("set", t);
  }
  /**
   * Sets the given attributes to the document if they are not currently set. Does NOT merge objects.
   * The operation is added to the current patch, ready to be commited by `commit()`
   *
   * @param attrs - Attributes to set. To set a deep attribute, use JSONMatch, eg: \{"nested.prop": "value"\}
   */
  setIfMissing(t) {
    return this._assign("setIfMissing", t);
  }
  /**
   * Performs a "diff-match-patch" operation on the string attributes provided.
   * The operation is added to the current patch, ready to be commited by `commit()`
   *
   * @param attrs - Attributes to perform operation on. To set a deep attribute, use JSONMatch, eg: \{"nested.prop": "dmp"\}
   */
  diffMatchPatch(t) {
    return Dt("diffMatchPatch", t), this._assign("diffMatchPatch", t);
  }
  /**
   * Unsets the attribute paths provided.
   * The operation is added to the current patch, ready to be commited by `commit()`
   *
   * @param attrs - Attribute paths to unset.
   */
  unset(t) {
    if (!Array.isArray(t))
      throw new Error("unset(attrs) takes an array of attributes to unset, non-array given");
    return this.operations = Object.assign({}, this.operations, { unset: t }), this;
  }
  /**
   * Increment a numeric value. Each entry in the argument is either an attribute or a JSON path. The value may be a positive or negative integer or floating-point value. The operation will fail if target value is not a numeric value, or doesn't exist.
   *
   * @param attrs - Object of attribute paths to increment, values representing the number to increment by.
   */
  inc(t) {
    return this._assign("inc", t);
  }
  /**
   * Decrement a numeric value. Each entry in the argument is either an attribute or a JSON path. The value may be a positive or negative integer or floating-point value. The operation will fail if target value is not a numeric value, or doesn't exist.
   *
   * @param attrs - Object of attribute paths to decrement, values representing the number to decrement by.
   */
  dec(t) {
    return this._assign("dec", t);
  }
  /**
   * Provides methods for modifying arrays, by inserting, appending and replacing elements via a JSONPath expression.
   *
   * @param at - Location to insert at, relative to the given selector, or 'replace' the matched path
   * @param selector - JSONPath expression, eg `comments[-1]` or `blocks[_key=="abc123"]`
   * @param items - Array of items to insert/replace
   */
  insert(t, n, r) {
    return xd(t, n, r), this._assign("insert", { [t]: n, items: r });
  }
  /**
   * Append the given items to the array at the given JSONPath
   *
   * @param selector - Attribute/path to append to, eg `comments` or `person.hobbies`
   * @param items - Array of items to append to the array
   */
  append(t, n) {
    return this.insert("after", `${t}[-1]`, n);
  }
  /**
   * Prepend the given items to the array at the given JSONPath
   *
   * @param selector - Attribute/path to prepend to, eg `comments` or `person.hobbies`
   * @param items - Array of items to prepend to the array
   */
  prepend(t, n) {
    return this.insert("before", `${t}[0]`, n);
  }
  /**
   * Change the contents of an array by removing existing elements and/or adding new elements.
   *
   * @param selector - Attribute or JSONPath expression for array
   * @param start - Index at which to start changing the array (with origin 0). If greater than the length of the array, actual starting index will be set to the length of the array. If negative, will begin that many elements from the end of the array (with origin -1) and will be set to 0 if absolute value is greater than the length of the array.x
   * @param deleteCount - An integer indicating the number of old array elements to remove.
   * @param items - The elements to add to the array, beginning at the start index. If you don't specify any elements, splice() will only remove elements from the array.
   */
  splice(t, n, r, s) {
    const o = typeof r > "u" || r === -1, i = n < 0 ? n - 1 : n, a = o ? -1 : Math.max(0, n + r), u = i < 0 && a >= 0 ? "" : a, c = `${t}[${i}:${u}]`;
    return this.insert("replace", c, s || []);
  }
  /**
   * Adds a revision clause, preventing the document from being patched if the `_rev` property does not match the given value
   *
   * @param rev - Revision to lock the patch to
   */
  ifRevisionId(t) {
    return this.operations.ifRevisionID = t, this;
  }
  /**
   * Return a plain JSON representation of the patch
   */
  serialize() {
    return { ...Lo(this.selection), ...this.operations };
  }
  /**
   * Return a plain JSON representation of the patch
   */
  toJSON() {
    return this.serialize();
  }
  /**
   * Clears the patch of all operations
   */
  reset() {
    return this.operations = {}, this;
  }
  _assign(t, n, r = !0) {
    return Dt(t, n), this.operations = Object.assign({}, this.operations, {
      [t]: Object.assign({}, r && this.operations[t] || {}, n)
    }), this;
  }
  _set(t, n) {
    return this._assign(t, n, !1);
  }
}
var pt;
const Dd = class No extends Mo {
  constructor(t, n, r) {
    super(t, n), X(this, pt), Z(this, pt, r);
  }
  /**
   * Clones the patch
   */
  clone() {
    return new No(this.selection, { ...this.operations }, k(this, pt));
  }
  commit(t) {
    if (!k(this, pt))
      throw new Error(
        "No `client` passed to patch, either provide one or pass the patch to a clients `mutate()` method"
      );
    const n = typeof this.selection == "string", r = Object.assign({ returnFirst: n, returnDocuments: !0 }, t);
    return k(this, pt).mutate({ patch: this.serialize() }, r);
  }
};
pt = /* @__PURE__ */ new WeakMap();
let Mt = Dd;
var ft;
const Ld = class Uo extends Mo {
  constructor(t, n, r) {
    super(t, n), X(this, ft), Z(this, ft, r);
  }
  /**
   * Clones the patch
   */
  clone() {
    return new Uo(this.selection, { ...this.operations }, k(this, ft));
  }
  commit(t) {
    if (!k(this, ft))
      throw new Error(
        "No `client` passed to patch, either provide one or pass the patch to a clients `mutate()` method"
      );
    const n = typeof this.selection == "string", r = Object.assign({ returnFirst: n, returnDocuments: !0 }, t);
    return k(this, ft).mutate({ patch: this.serialize() }, r);
  }
};
ft = /* @__PURE__ */ new WeakMap();
let Nt = Ld;
const qo = { returnDocuments: !1 };
class Fo {
  constructor(t = [], n) {
    H(this, "operations"), H(this, "trxId"), this.operations = t, this.trxId = n;
  }
  /**
   * Creates a new Sanity document. If `_id` is provided and already exists, the mutation will fail. If no `_id` is given, one will automatically be generated by the database.
   * The operation is added to the current transaction, ready to be commited by `commit()`
   *
   * @param doc - Document to create. Requires a `_type` property.
   */
  create(t) {
    return Dt("create", t), this._add({ create: t });
  }
  /**
   * Creates a new Sanity document. If a document with the same `_id` already exists, the create operation will be ignored.
   * The operation is added to the current transaction, ready to be commited by `commit()`
   *
   * @param doc - Document to create if it does not already exist. Requires `_id` and `_type` properties.
   */
  createIfNotExists(t) {
    const n = "createIfNotExists";
    return Dt(n, t), _n(n, t), this._add({ [n]: t });
  }
  /**
   * Creates a new Sanity document, or replaces an existing one if the same `_id` is already used.
   * The operation is added to the current transaction, ready to be commited by `commit()`
   *
   * @param doc - Document to create or replace. Requires `_id` and `_type` properties.
   */
  createOrReplace(t) {
    const n = "createOrReplace";
    return Dt(n, t), _n(n, t), this._add({ [n]: t });
  }
  /**
   * Deletes the document with the given document ID
   * The operation is added to the current transaction, ready to be commited by `commit()`
   *
   * @param documentId - Document ID to delete
   */
  delete(t) {
    return Po("delete", t), this._add({ delete: { id: t } });
  }
  transactionId(t) {
    return t ? (this.trxId = t, this) : this.trxId;
  }
  /**
   * Return a plain JSON representation of the transaction
   */
  serialize() {
    return [...this.operations];
  }
  /**
   * Return a plain JSON representation of the transaction
   */
  toJSON() {
    return this.serialize();
  }
  /**
   * Clears the transaction of all operations
   */
  reset() {
    return this.operations = [], this;
  }
  _add(t) {
    return this.operations.push(t), this;
  }
}
var Je;
const Md = class Bo extends Fo {
  constructor(t, n, r) {
    super(t, r), X(this, Je), Z(this, Je, n);
  }
  /**
   * Clones the transaction
   */
  clone() {
    return new Bo([...this.operations], k(this, Je), this.trxId);
  }
  commit(t) {
    if (!k(this, Je))
      throw new Error(
        "No `client` passed to transaction, either provide one or pass the transaction to a clients `mutate()` method"
      );
    return k(this, Je).mutate(
      this.serialize(),
      Object.assign({ transactionId: this.trxId }, qo, t || {})
    );
  }
  patch(t, n) {
    const r = typeof n == "function";
    if (typeof t != "string" && t instanceof Nt)
      return this._add({ patch: t.serialize() });
    if (r) {
      const s = n(new Nt(t, {}, k(this, Je)));
      if (!(s instanceof Nt))
        throw new Error("function passed to `patch()` must return the patch");
      return this._add({ patch: s.serialize() });
    }
    return this._add({ patch: { id: t, ...n } });
  }
};
Je = /* @__PURE__ */ new WeakMap();
let Vo = Md;
var Ze;
const Nd = class zo extends Fo {
  constructor(t, n, r) {
    super(t, r), X(this, Ze), Z(this, Ze, n);
  }
  /**
   * Clones the transaction
   */
  clone() {
    return new zo([...this.operations], k(this, Ze), this.trxId);
  }
  commit(t) {
    if (!k(this, Ze))
      throw new Error(
        "No `client` passed to transaction, either provide one or pass the transaction to a clients `mutate()` method"
      );
    return k(this, Ze).mutate(
      this.serialize(),
      Object.assign({ transactionId: this.trxId }, qo, t || {})
    );
  }
  patch(t, n) {
    const r = typeof n == "function";
    if (typeof t != "string" && t instanceof Mt)
      return this._add({ patch: t.serialize() });
    if (r) {
      const s = n(new Mt(t, {}, k(this, Ze)));
      if (!(s instanceof Mt))
        throw new Error("function passed to `patch()` must return the patch");
      return this._add({ patch: s.serialize() });
    }
    return this._add({ patch: { id: t, ...n } });
  }
};
Ze = /* @__PURE__ */ new WeakMap();
let Ho = Nd;
const Ud = "X-Sanity-Project-ID";
function qd(e, t = {}) {
  const n = {}, r = t.token || e.token;
  r && (n.Authorization = `Bearer ${r}`), !t.useGlobalApi && !e.useProjectHostname && e.projectId && (n[Ud] = e.projectId);
  const s = !!(typeof t.withCredentials > "u" ? e.token || e.withCredentials : t.withCredentials), o = typeof t.timeout > "u" ? e.timeout : t.timeout;
  return Object.assign({}, t, {
    headers: Object.assign({}, n, t.headers || {}),
    timeout: typeof o > "u" ? 5 * 60 * 1e3 : o,
    proxy: t.proxy || e.proxy,
    json: !0,
    withCredentials: s,
    fetch: typeof t.fetch == "object" && typeof e.fetch == "object" ? { ...e.fetch, ...t.fetch } : t.fetch || e.fetch
  });
}
const Wo = ({
  query: e,
  params: t = {},
  options: n = {}
}) => {
  const r = new URLSearchParams(), { tag: s, includeMutations: o, returnQuery: i, ...a } = n;
  s && r.append("tag", s), r.append("query", e);
  for (const [u, c] of Object.entries(t))
    r.append(`$${u}`, JSON.stringify(c));
  for (const [u, c] of Object.entries(a))
    c && r.append(u, `${c}`);
  return i === !1 && r.append("returnQuery", "false"), o === !1 && r.append("includeMutations", "false"), `?${r}`;
}, Fd = (e, t) => e === !1 ? void 0 : typeof e > "u" ? t : e, Bd = (e = {}) => ({
  dryRun: e.dryRun,
  returnIds: !0,
  returnDocuments: Fd(e.returnDocuments, !0),
  visibility: e.visibility || "sync",
  autoGenerateArrayKeys: e.autoGenerateArrayKeys,
  skipCrossDatasetReferenceValidation: e.skipCrossDatasetReferenceValidation
}), $r = (e) => e.type === "response", Vd = (e) => e.body, zd = (e, t) => e.reduce((n, r) => (n[t(r)] = r, n), /* @__PURE__ */ Object.create(null)), Hd = 11264;
function Yo(e, t, n, r, s = {}, o = {}) {
  const i = "stega" in o ? {
    ...n || {},
    ...typeof o.stega == "boolean" ? { enabled: o.stega } : o.stega || {}
  } : n, a = i.enabled ? ud(s) : s, u = o.filterResponse === !1 ? (b) => b : (b) => b.result, { cache: c, next: l, ...d } = {
    // Opt out of setting a `signal` on an internal `fetch` if one isn't provided.
    // This is necessary in React Server Components to avoid opting out of Request Memoization.
    useAbortSignal: typeof o.signal < "u",
    // Set `resultSourceMap' when stega is enabled, as it's required for encoding.
    resultSourceMap: i.enabled ? "withKeyArraySelector" : o.resultSourceMap,
    ...o,
    // Default to not returning the query, unless `filterResponse` is `false`,
    // or `returnQuery` is explicitly set. `true` is the default in Content Lake, so skip if truthy
    returnQuery: o.filterResponse === !1 && o.returnQuery !== !1
  }, g = typeof c < "u" || typeof l < "u" ? { ...d, fetch: { cache: c, next: l } } : d, m = bt(e, t, "query", { query: r, params: a }, g);
  return i.enabled ? m.pipe(
    td(
      $o(
        import("./stegaEncodeSourceMap-CKKMoWzc-DjVlh-hT.js").then(function(b) {
          return b.stegaEncodeSourceMap$1;
        }).then(
          ({ stegaEncodeSourceMap: b }) => b
        )
      )
    ),
    Ve(
      ([b, f]) => {
        const S = f(b.result, b.resultSourceMap, i);
        return u({ ...b, result: S });
      }
    )
  ) : m.pipe(Ve(u));
}
function Ko(e, t, n, r = {}) {
  const s = {
    uri: ct(e, "doc", n),
    json: !0,
    tag: r.tag,
    signal: r.signal
  };
  return Kt(e, t, s).pipe(
    Wt($r),
    Ve((o) => o.body.documents && o.body.documents[0])
  );
}
function Go(e, t, n, r = {}) {
  const s = {
    uri: ct(e, "doc", n.join(",")),
    json: !0,
    tag: r.tag,
    signal: r.signal
  };
  return Kt(e, t, s).pipe(
    Wt($r),
    Ve((o) => {
      const i = zd(o.body.documents || [], (a) => a._id);
      return n.map((a) => i[a] || null);
    })
  );
}
function Jo(e, t, n, r) {
  return _n("createIfNotExists", n), In(e, t, n, "createIfNotExists", r);
}
function Zo(e, t, n, r) {
  return _n("createOrReplace", n), In(e, t, n, "createOrReplace", r);
}
function Xo(e, t, n, r) {
  return bt(
    e,
    t,
    "mutate",
    { mutations: [{ delete: Lo(n) }] },
    r
  );
}
function Qo(e, t, n, r) {
  let s;
  n instanceof Nt || n instanceof Mt ? s = { patch: n.serialize() } : n instanceof Vo || n instanceof Ho ? s = n.serialize() : s = n;
  const o = Array.isArray(s) ? s : [s], i = r && r.transactionId || void 0;
  return bt(e, t, "mutate", { mutations: o, transactionId: i }, r);
}
function ei(e, t, n, r) {
  const s = Array.isArray(n) ? n : [n], o = r && r.transactionId || void 0, i = r && r.skipCrossDatasetReferenceValidation || void 0, a = r && r.dryRun || void 0;
  return bt(
    e,
    t,
    "actions",
    { actions: s, transactionId: o, skipCrossDatasetReferenceValidation: i, dryRun: a },
    r
  );
}
function bt(e, t, n, r, s = {}) {
  const o = n === "mutate", i = n === "actions", a = n === "query", u = o || i ? "" : Wo(r), c = !o && !i && u.length < Hd, l = c ? u : "", d = s.returnFirst, { timeout: g, token: m, tag: b, headers: f, returnQuery: S, lastLiveEventId: $, cacheMode: E } = s, j = ct(e, n, l), D = {
    method: c ? "GET" : "POST",
    uri: j,
    json: !0,
    body: c ? void 0 : r,
    query: o && Bd(s),
    timeout: g,
    headers: f,
    token: m,
    tag: b,
    returnQuery: S,
    perspective: s.perspective,
    resultSourceMap: s.resultSourceMap,
    lastLiveEventId: Array.isArray($) ? $[0] : $,
    cacheMode: E,
    canUseCdn: a,
    signal: s.signal,
    fetch: s.fetch,
    useAbortSignal: s.useAbortSignal,
    useCdn: s.useCdn
  };
  return Kt(e, t, D).pipe(
    Wt($r),
    Ve(Vd),
    Ve((I) => {
      if (!o)
        return I;
      const M = I.results || [];
      if (s.returnDocuments)
        return d ? M[0] && M[0].document : M.map((q) => q.document);
      const K = d ? "documentId" : "documentIds", J = d ? M[0] && M[0].id : M.map((q) => q.id);
      return {
        transactionId: I.transactionId,
        results: M,
        [K]: J
      };
    })
  );
}
function In(e, t, n, r, s = {}) {
  const o = { [r]: n }, i = Object.assign({ returnFirst: !0, returnDocuments: !0 }, s);
  return bt(e, t, "mutate", { mutations: [o] }, i);
}
function Kt(e, t, n) {
  const r = n.url || n.uri, s = e.config(), o = typeof n.canUseCdn > "u" ? ["GET", "HEAD"].indexOf(n.method || "GET") >= 0 && r.indexOf("/data/") === 0 : n.canUseCdn;
  let i = (n.useCdn ?? s.useCdn) && o;
  const a = n.tag && s.requestTagPrefix ? [s.requestTagPrefix, n.tag].join(".") : n.tag || s.requestTagPrefix;
  if (a && n.tag !== null && (n.query = { tag: Ao(a), ...n.query }), ["GET", "HEAD", "POST"].indexOf(n.method || "GET") >= 0 && r.indexOf("/data/query/") === 0) {
    const l = n.resultSourceMap ?? s.resultSourceMap;
    l !== void 0 && l !== !1 && (n.query = { resultSourceMap: l, ...n.query });
    const d = n.perspective || s.perspective;
    typeof d < "u" && (jo(d), n.query = {
      perspective: Array.isArray(d) ? d.join(",") : d,
      ...n.query
    }, d === "previewDrafts" && i && (i = !1, kd())), n.lastLiveEventId && (n.query = { ...n.query, lastLiveEventId: n.lastLiveEventId }), n.returnQuery === !1 && (n.query = { returnQuery: "false", ...n.query }), i && n.cacheMode == "noStale" && (n.query = { cacheMode: "noStale", ...n.query });
  }
  const u = qd(
    s,
    Object.assign({}, n, {
      url: Or(e, r, i)
    })
  ), c = new Oe(
    (l) => t(u, s.requester).subscribe(l)
  );
  return n.signal ? c.pipe(Wd(n.signal)) : c;
}
function Re(e, t, n) {
  return Kt(e, t, n).pipe(
    Wt((r) => r.type === "response"),
    Ve((r) => r.body)
  );
}
function ct(e, t, n) {
  const r = e.config(), s = Ro(r), o = `/${t}/${s}`;
  return `/data${n ? `${o}/${n}` : o}`.replace(/\/($|\?)/, "$1");
}
function Or(e, t, n = !1) {
  const { url: r, cdnUrl: s } = e.config();
  return `${n ? s : r}/${t.replace(/^\//, "")}`;
}
function Wd(e) {
  return (t) => new Oe((n) => {
    const r = () => n.error(Kd(e));
    if (e && e.aborted) {
      r();
      return;
    }
    const s = t.subscribe(n);
    return e.addEventListener("abort", r), () => {
      e.removeEventListener("abort", r), s.unsubscribe();
    };
  });
}
const Yd = !!globalThis.DOMException;
function Kd(e) {
  if (Yd)
    return new DOMException((e == null ? void 0 : e.reason) ?? "The operation was aborted.", "AbortError");
  const t = new Error((e == null ? void 0 : e.reason) ?? "The operation was aborted.");
  return t.name = "AbortError", t;
}
var on, an;
class Gd {
  constructor(t, n) {
    X(this, on), X(this, an), Z(this, on, t), Z(this, an, n);
  }
  upload(t, n, r) {
    return ti(k(this, on), k(this, an), t, n, r);
  }
}
on = /* @__PURE__ */ new WeakMap(), an = /* @__PURE__ */ new WeakMap();
var cn, un;
class Jd {
  constructor(t, n) {
    X(this, cn), X(this, un), Z(this, cn, t), Z(this, un, n);
  }
  upload(t, n, r) {
    const s = ti(k(this, cn), k(this, un), t, n, r);
    return fe(
      s.pipe(
        Wt((o) => o.type === "response"),
        Ve(
          (o) => o.body.document
        )
      )
    );
  }
}
cn = /* @__PURE__ */ new WeakMap(), un = /* @__PURE__ */ new WeakMap();
function ti(e, t, n, r, s = {}) {
  Cd(n);
  let o = s.extract || void 0;
  o && !o.length && (o = ["none"]);
  const i = Ro(e.config()), a = n === "image" ? "images" : "files", u = Zd(s, r), { tag: c, label: l, title: d, description: g, creditLine: m, filename: b, source: f } = u, S = {
    label: l,
    title: d,
    description: g,
    filename: b,
    meta: o,
    creditLine: m
  };
  return f && (S.sourceId = f.id, S.sourceName = f.name, S.sourceUrl = f.url), Kt(e, t, {
    tag: c,
    method: "POST",
    timeout: u.timeout || 0,
    uri: `/assets/${a}/${i}`,
    headers: u.contentType ? { "Content-Type": u.contentType } : {},
    query: S,
    body: r
  });
}
function Zd(e, t) {
  return typeof File > "u" || !(t instanceof File) ? e : Object.assign(
    {
      filename: e.preserveFilename === !1 ? void 0 : t.name,
      contentType: t.type
    },
    e
  );
}
var Xd = (e, t) => Object.keys(t).concat(Object.keys(e)).reduce((n, r) => (n[r] = typeof e[r] > "u" ? t[r] : e[r], n), {});
const Qd = (e, t) => t.reduce((n, r) => (typeof e[r] > "u" || (n[r] = e[r]), n), {}), ep = 14800, tp = [
  "includePreviousRevision",
  "includeResult",
  "includeMutations",
  "visibility",
  "effectFormat",
  "tag"
], np = {
  includeResult: !0
};
function ni(e, t, n = {}) {
  const { url: r, token: s, withCredentials: o, requestTagPrefix: i } = this.config(), a = n.tag && i ? [i, n.tag].join(".") : n.tag, u = { ...Xd(n, np), tag: a }, c = Qd(u, tp), l = Wo({ query: e, params: t, options: { tag: a, ...c } }), d = `${r}${ct(this, "listen", l)}`;
  if (d.length > ep)
    return new Oe((f) => f.error(new Error("Query too large for listener")));
  const g = u.events ? u.events : ["mutation"], m = g.indexOf("reconnect") !== -1, b = {};
  return (s || o) && (b.withCredentials = !0), s && (b.headers = {
    Authorization: `Bearer ${s}`
  }), new Oe((f) => {
    let S, $, E = !1, j = !1;
    h();
    function D() {
      E || (q(), !E && S.readyState === S.CLOSED && (J(), clearTimeout($), $ = setTimeout(h, 100)));
    }
    function I(p) {
      f.error(rp(p));
    }
    function M(p) {
      const v = ri(p);
      return v instanceof Error ? f.error(v) : f.next(v);
    }
    function K() {
      E = !0, J(), f.complete();
    }
    function J() {
      S && (S.removeEventListener("error", D), S.removeEventListener("channelError", I), S.removeEventListener("disconnect", K), g.forEach((p) => S.removeEventListener(p, M)), S.close());
    }
    function q() {
      m && f.next({ type: "reconnect" });
    }
    async function N() {
      const { default: p } = await import("./browser-Szu3yenX-CBUf4cPF.js").then((_) => _.b);
      if (j)
        return;
      const v = new p(d, b);
      return v.addEventListener("error", D), v.addEventListener("channelError", I), v.addEventListener("disconnect", K), g.forEach((_) => v.addEventListener(_, M)), v;
    }
    function h() {
      N().then((p) => {
        p && (S = p, j && J());
      }).catch((p) => {
        f.error(p), y();
      });
    }
    function y() {
      E = !0, J(), j = !0;
    }
    return y;
  });
}
function ri(e) {
  try {
    const t = e.data && JSON.parse(e.data) || {};
    return Object.assign({ type: e.type }, t);
  } catch (t) {
    return t;
  }
}
function rp(e) {
  if (e instanceof Error)
    return e;
  const t = ri(e);
  return t instanceof Error ? t : new Error(sp(t));
}
function sp(e) {
  return e.error ? e.error.description ? e.error.description : typeof e.error == "string" ? e.error : JSON.stringify(e.error, null, 2) : e.message || "Unknown listener error";
}
const ps = "2021-03-26";
var ht;
class si {
  constructor(t) {
    X(this, ht), Z(this, ht, t);
  }
  /**
   * Requires `apiVersion` to be `2021-03-26` or later.
   */
  events({
    includeDrafts: t = !1,
    tag: n
  } = {}) {
    const {
      projectId: r,
      apiVersion: s,
      token: o,
      withCredentials: i,
      requestTagPrefix: a
    } = k(this, ht).config(), u = s.replace(/^v/, "");
    if (u !== "X" && u < ps)
      throw new Error(
        `The live events API requires API version ${ps} or later. The current API version is ${u}. Please update your API version to use this feature.`
      );
    if (t && !o && !i)
      throw new Error(
        "The live events API requires a token or withCredentials when 'includeDrafts: true'. Please update your client configuration. The token should have the lowest possible access role."
      );
    if (t && u !== "X")
      throw new Error(
        "The live events API requires API version X when 'includeDrafts: true'. This API is experimental and may change or even be removed."
      );
    const c = ct(k(this, ht), "live/events"), l = new URL(k(this, ht).getUrl(c, !1)), d = n && a ? [a, n].join(".") : n;
    d && l.searchParams.set("tag", d), t && l.searchParams.set("includeDrafts", "true");
    const g = ["restart", "message", "welcome", "reconnect"], m = {};
    return t && o && (m.headers = {
      Authorization: `Bearer ${o}`
    }), t && i && (m.withCredentials = !0), new Oe((b) => {
      let f, S, $ = !1, E = !1;
      K();
      function j(q) {
        if (!$) {
          if ("data" in q) {
            const N = fs(q);
            b.error(new Error(N.message, { cause: N }));
          }
          f.readyState === f.CLOSED && (I(), clearTimeout(S), S = setTimeout(K, 100));
        }
      }
      function D(q) {
        const N = fs(q);
        return N instanceof Error ? b.error(N) : b.next(N);
      }
      function I() {
        if (f) {
          f.removeEventListener("error", j);
          for (const q of g)
            f.removeEventListener(q, D);
          f.close();
        }
      }
      async function M() {
        const q = typeof EventSource > "u" || m.headers || m.withCredentials ? (await import("./browser-Szu3yenX-CBUf4cPF.js").then((h) => h.b)).default : EventSource;
        if (E)
          return;
        try {
          if (await fetch(l, {
            method: "OPTIONS",
            mode: "cors",
            credentials: m.withCredentials ? "include" : "omit",
            headers: m.headers
          }), E)
            return;
        } catch {
          throw new gd({ projectId: r });
        }
        const N = new q(l.toString(), m);
        N.addEventListener("error", j);
        for (const h of g)
          N.addEventListener(h, D);
        return N;
      }
      function K() {
        M().then((q) => {
          q && (f = q, E && I());
        }).catch((q) => {
          b.error(q), J();
        });
      }
      function J() {
        $ = !0, I(), E = !0;
      }
      return J;
    });
  }
}
ht = /* @__PURE__ */ new WeakMap();
function fs(e) {
  try {
    const t = e.data && JSON.parse(e.data) || {};
    return { type: e.type, id: e.lastEventId, ...t };
  } catch (t) {
    return t;
  }
}
var Xe, Qe;
class op {
  constructor(t, n) {
    X(this, Xe), X(this, Qe), Z(this, Xe, t), Z(this, Qe, n);
  }
  /**
   * Create a new dataset with the given name
   *
   * @param name - Name of the dataset to create
   * @param options - Options for the dataset
   */
  create(t, n) {
    return gt(k(this, Xe), k(this, Qe), "PUT", t, n);
  }
  /**
   * Edit a dataset with the given name
   *
   * @param name - Name of the dataset to edit
   * @param options - New options for the dataset
   */
  edit(t, n) {
    return gt(k(this, Xe), k(this, Qe), "PATCH", t, n);
  }
  /**
   * Delete a dataset with the given name
   *
   * @param name - Name of the dataset to delete
   */
  delete(t) {
    return gt(k(this, Xe), k(this, Qe), "DELETE", t);
  }
  /**
   * Fetch a list of datasets for the configured project
   */
  list() {
    return Re(k(this, Xe), k(this, Qe), {
      uri: "/datasets",
      tag: null
    });
  }
}
Xe = /* @__PURE__ */ new WeakMap(), Qe = /* @__PURE__ */ new WeakMap();
var et, tt;
class ip {
  constructor(t, n) {
    X(this, et), X(this, tt), Z(this, et, t), Z(this, tt, n);
  }
  /**
   * Create a new dataset with the given name
   *
   * @param name - Name of the dataset to create
   * @param options - Options for the dataset
   */
  create(t, n) {
    return fe(
      gt(k(this, et), k(this, tt), "PUT", t, n)
    );
  }
  /**
   * Edit a dataset with the given name
   *
   * @param name - Name of the dataset to edit
   * @param options - New options for the dataset
   */
  edit(t, n) {
    return fe(
      gt(k(this, et), k(this, tt), "PATCH", t, n)
    );
  }
  /**
   * Delete a dataset with the given name
   *
   * @param name - Name of the dataset to delete
   */
  delete(t) {
    return fe(gt(k(this, et), k(this, tt), "DELETE", t));
  }
  /**
   * Fetch a list of datasets for the configured project
   */
  list() {
    return fe(
      Re(k(this, et), k(this, tt), { uri: "/datasets", tag: null })
    );
  }
}
et = /* @__PURE__ */ new WeakMap(), tt = /* @__PURE__ */ new WeakMap();
function gt(e, t, n, r, s) {
  return Io(r), Re(e, t, {
    method: n,
    uri: `/datasets/${r}`,
    body: s,
    tag: null
  });
}
var Ot, kt;
class ap {
  constructor(t, n) {
    X(this, Ot), X(this, kt), Z(this, Ot, t), Z(this, kt, n);
  }
  list(t) {
    const n = (t == null ? void 0 : t.includeMembers) === !1 ? "/projects?includeMembers=false" : "/projects";
    return Re(k(this, Ot), k(this, kt), { uri: n });
  }
  /**
   * Fetch a project by project ID
   *
   * @param projectId - ID of the project to fetch
   */
  getById(t) {
    return Re(k(this, Ot), k(this, kt), { uri: `/projects/${t}` });
  }
}
Ot = /* @__PURE__ */ new WeakMap(), kt = /* @__PURE__ */ new WeakMap();
var Et, It;
class cp {
  constructor(t, n) {
    X(this, Et), X(this, It), Z(this, Et, t), Z(this, It, n);
  }
  list(t) {
    const n = (t == null ? void 0 : t.includeMembers) === !1 ? "/projects?includeMembers=false" : "/projects";
    return fe(Re(k(this, Et), k(this, It), { uri: n }));
  }
  /**
   * Fetch a project by project ID
   *
   * @param projectId - ID of the project to fetch
   */
  getById(t) {
    return fe(
      Re(k(this, Et), k(this, It), { uri: `/projects/${t}` })
    );
  }
}
Et = /* @__PURE__ */ new WeakMap(), It = /* @__PURE__ */ new WeakMap();
var ln, dn;
class up {
  constructor(t, n) {
    X(this, ln), X(this, dn), Z(this, ln, t), Z(this, dn, n);
  }
  /**
   * Fetch a user by user ID
   *
   * @param id - User ID of the user to fetch. If `me` is provided, a minimal response including the users role is returned.
   */
  getById(t) {
    return Re(
      k(this, ln),
      k(this, dn),
      { uri: `/users/${t}` }
    );
  }
}
ln = /* @__PURE__ */ new WeakMap(), dn = /* @__PURE__ */ new WeakMap();
var pn, fn;
class lp {
  constructor(t, n) {
    X(this, pn), X(this, fn), Z(this, pn, t), Z(this, fn, n);
  }
  /**
   * Fetch a user by user ID
   *
   * @param id - User ID of the user to fetch. If `me` is provided, a minimal response including the users role is returned.
   */
  getById(t) {
    return fe(
      Re(k(this, pn), k(this, fn), {
        uri: `/users/${t}`
      })
    );
  }
}
pn = /* @__PURE__ */ new WeakMap(), fn = /* @__PURE__ */ new WeakMap();
var We, pe;
const dp = class nr {
  constructor(t, n = Lt) {
    H(this, "assets"), H(this, "datasets"), H(this, "live"), H(this, "projects"), H(this, "users"), X(this, We), X(this, pe), H(this, "listen", ni), this.config(n), Z(this, pe, t), this.assets = new Gd(this, k(this, pe)), this.datasets = new op(this, k(this, pe)), this.live = new si(this), this.projects = new ap(this, k(this, pe)), this.users = new up(this, k(this, pe));
  }
  /**
   * Clone the client - returns a new instance
   */
  clone() {
    return new nr(k(this, pe), this.config());
  }
  config(t) {
    if (t === void 0)
      return { ...k(this, We) };
    if (k(this, We) && k(this, We).allowReconfigure === !1)
      throw new Error(
        "Existing client instance cannot be reconfigured - use `withConfig(newConfig)` to return a new client"
      );
    return Z(this, We, Do(t, k(this, We) || {})), this;
  }
  /**
   * Clone the client with a new (partial) configuration.
   *
   * @param newConfig - New client configuration properties, shallowly merged with existing configuration
   */
  withConfig(t) {
    const n = this.config();
    return new nr(k(this, pe), {
      ...n,
      ...t,
      stega: {
        ...n.stega || {},
        ...typeof (t == null ? void 0 : t.stega) == "boolean" ? { enabled: t.stega } : (t == null ? void 0 : t.stega) || {}
      }
    });
  }
  fetch(t, n, r) {
    return Yo(
      this,
      k(this, pe),
      k(this, We).stega,
      t,
      n,
      r
    );
  }
  /**
   * Fetch a single document with the given ID.
   *
   * @param id - Document ID to fetch
   * @param options - Request options
   */
  getDocument(t, n) {
    return Ko(this, k(this, pe), t, n);
  }
  /**
   * Fetch multiple documents in one request.
   * Should be used sparingly - performing a query is usually a better option.
   * The order/position of documents is preserved based on the original array of IDs.
   * If any of the documents are missing, they will be replaced by a `null` entry in the returned array
   *
   * @param ids - Document IDs to fetch
   * @param options - Request options
   */
  getDocuments(t, n) {
    return Go(this, k(this, pe), t, n);
  }
  create(t, n) {
    return In(this, k(this, pe), t, "create", n);
  }
  createIfNotExists(t, n) {
    return Jo(this, k(this, pe), t, n);
  }
  createOrReplace(t, n) {
    return Zo(this, k(this, pe), t, n);
  }
  delete(t, n) {
    return Xo(this, k(this, pe), t, n);
  }
  mutate(t, n) {
    return Qo(this, k(this, pe), t, n);
  }
  /**
   * Create a new buildable patch of operations to perform
   *
   * @param selection - Document ID, an array of document IDs, or an object with `query` and optional `params`, defining which document(s) to patch
   * @param operations - Optional object of patch operations to initialize the patch instance with
   * @returns Patch instance - call `.commit()` to perform the operations defined
   */
  patch(t, n) {
    return new Mt(t, n, this);
  }
  /**
   * Create a new transaction of mutations
   *
   * @param operations - Optional array of mutation operations to initialize the transaction instance with
   */
  transaction(t) {
    return new Ho(t, this);
  }
  /**
   * Perform action operations against the configured dataset
   *
   * @param operations - Action operation(s) to execute
   * @param options - Action options
   */
  action(t, n) {
    return ei(this, k(this, pe), t, n);
  }
  /**
   * Perform an HTTP request against the Sanity API
   *
   * @param options - Request options
   */
  request(t) {
    return Re(this, k(this, pe), t);
  }
  /**
   * Get a Sanity API URL for the URI provided
   *
   * @param uri - URI/path to build URL for
   * @param canUseCdn - Whether or not to allow using the API CDN for this route
   */
  getUrl(t, n) {
    return Or(this, t, n);
  }
  /**
   * Get a Sanity API URL for the data operation and path provided
   *
   * @param operation - Data operation (eg `query`, `mutate`, `listen` or similar)
   * @param path - Path to append after the operation
   */
  getDataUrl(t, n) {
    return ct(this, t, n);
  }
};
We = /* @__PURE__ */ new WeakMap(), pe = /* @__PURE__ */ new WeakMap();
let pp = dp;
var Ye, ue;
const fp = class rr {
  constructor(t, n = Lt) {
    H(this, "assets"), H(this, "datasets"), H(this, "live"), H(this, "projects"), H(this, "users"), H(this, "observable"), X(this, Ye), X(this, ue), H(this, "listen", ni), this.config(n), Z(this, ue, t), this.assets = new Jd(this, k(this, ue)), this.datasets = new ip(this, k(this, ue)), this.live = new si(this), this.projects = new cp(this, k(this, ue)), this.users = new lp(this, k(this, ue)), this.observable = new pp(t, n);
  }
  /**
   * Clone the client - returns a new instance
   */
  clone() {
    return new rr(k(this, ue), this.config());
  }
  config(t) {
    if (t === void 0)
      return { ...k(this, Ye) };
    if (k(this, Ye) && k(this, Ye).allowReconfigure === !1)
      throw new Error(
        "Existing client instance cannot be reconfigured - use `withConfig(newConfig)` to return a new client"
      );
    return this.observable && this.observable.config(t), Z(this, Ye, Do(t, k(this, Ye) || {})), this;
  }
  /**
   * Clone the client with a new (partial) configuration.
   *
   * @param newConfig - New client configuration properties, shallowly merged with existing configuration
   */
  withConfig(t) {
    const n = this.config();
    return new rr(k(this, ue), {
      ...n,
      ...t,
      stega: {
        ...n.stega || {},
        ...typeof (t == null ? void 0 : t.stega) == "boolean" ? { enabled: t.stega } : (t == null ? void 0 : t.stega) || {}
      }
    });
  }
  fetch(t, n, r) {
    return fe(
      Yo(
        this,
        k(this, ue),
        k(this, Ye).stega,
        t,
        n,
        r
      )
    );
  }
  /**
   * Fetch a single document with the given ID.
   *
   * @param id - Document ID to fetch
   * @param options - Request options
   */
  getDocument(t, n) {
    return fe(Ko(this, k(this, ue), t, n));
  }
  /**
   * Fetch multiple documents in one request.
   * Should be used sparingly - performing a query is usually a better option.
   * The order/position of documents is preserved based on the original array of IDs.
   * If any of the documents are missing, they will be replaced by a `null` entry in the returned array
   *
   * @param ids - Document IDs to fetch
   * @param options - Request options
   */
  getDocuments(t, n) {
    return fe(Go(this, k(this, ue), t, n));
  }
  create(t, n) {
    return fe(
      In(this, k(this, ue), t, "create", n)
    );
  }
  createIfNotExists(t, n) {
    return fe(
      Jo(this, k(this, ue), t, n)
    );
  }
  createOrReplace(t, n) {
    return fe(
      Zo(this, k(this, ue), t, n)
    );
  }
  delete(t, n) {
    return fe(Xo(this, k(this, ue), t, n));
  }
  mutate(t, n) {
    return fe(Qo(this, k(this, ue), t, n));
  }
  /**
   * Create a new buildable patch of operations to perform
   *
   * @param selection - Document ID, an array of document IDs, or an object with `query` and optional `params`, defining which document(s) to patch
   * @param operations - Optional object of patch operations to initialize the patch instance with
   * @returns Patch instance - call `.commit()` to perform the operations defined
   */
  patch(t, n) {
    return new Nt(t, n, this);
  }
  /**
   * Create a new transaction of mutations
   *
   * @param operations - Optional array of mutation operations to initialize the transaction instance with
   */
  transaction(t) {
    return new Vo(t, this);
  }
  /**
   * Perform action operations against the configured dataset
   * Returns a promise that resolves to the transaction result
   *
   * @param operations - Action operation(s) to execute
   * @param options - Action options
   */
  action(t, n) {
    return fe(ei(this, k(this, ue), t, n));
  }
  /**
   * Perform a request against the Sanity API
   * NOTE: Only use this for Sanity API endpoints, not for your own APIs!
   *
   * @param options - Request options
   * @returns Promise resolving to the response body
   */
  request(t) {
    return fe(Re(this, k(this, ue), t));
  }
  /**
   * Perform an HTTP request a `/data` sub-endpoint
   * NOTE: Considered internal, thus marked as deprecated. Use `request` instead.
   *
   * @deprecated - Use `request()` or your own HTTP library instead
   * @param endpoint - Endpoint to hit (mutate, query etc)
   * @param body - Request body
   * @param options - Request options
   * @internal
   */
  dataRequest(t, n, r) {
    return fe(bt(this, k(this, ue), t, n, r));
  }
  /**
   * Get a Sanity API URL for the URI provided
   *
   * @param uri - URI/path to build URL for
   * @param canUseCdn - Whether or not to allow using the API CDN for this route
   */
  getUrl(t, n) {
    return Or(this, t, n);
  }
  /**
   * Get a Sanity API URL for the data operation and path provided
   *
   * @param operation - Data operation (eg `query`, `mutate`, `listen` or similar)
   * @param path - Path to append after the operation
   */
  getDataUrl(t, n) {
    return ct(this, t, n);
  }
};
Ye = /* @__PURE__ */ new WeakMap(), ue = /* @__PURE__ */ new WeakMap();
let hp = fp;
function mp(e, t) {
  const n = bd(e);
  return { requester: n, createClient: (r) => new t(
    (s, o) => (o || n)({
      maxRedirects: 0,
      maxRetries: r.maxRetries,
      retryDelay: r.retryDelay,
      ...s
    }),
    r
  ) };
}
var gp = [];
const vp = mp(gp, hp), yp = vp.createClient, oi = yp({
  projectId: "0ls0csm4",
  dataset: "production",
  token: "skF3I3GTefhnWc6ta4QSMIwXiCUlQ1DHc2UuHfSoL22XgPVAnI6SX0e3Sxh5lLw7EnaIM4RHkd4w0ihgdtI7LFv7bNVF9sYS2PYeH87oQZitkj1M26Yl5mBHNV3YSYrTKxki5Ni2ABxP8mI3QSWc9u1tUCY4o43vbvZ5U4q2T8Qje5BXKeV3",
  useCdn: !1,
  ignoreBrowserTokenWarning: !0,
  apiVersion: "2020-01-01"
}), bp = Gu(oi), wp = async (e, t = {}) => {
  try {
    return await oi.fetch(e, t);
  } catch (n) {
    throw console.log("Error fetching cms: ", n), n;
  }
}, _p = (e) => bp.image(e), Sp = {
  fetchCms: wp,
  resolveImage: _p
};
function Cp(e) {
  const t = [];
  return new Proxy(e, {
    apply(n, r, s) {
      const o = js(s), i = t.find((u) => Ds(u.key, o));
      if (i)
        return i.value;
      const a = Reflect.apply(n, r, s);
      return t.push({ key: o, value: a }), a;
    }
  });
}
Cp(Sp.fetchCms);
function ii(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: xp } = Object.prototype, { getPrototypeOf: kr } = Object, Pn = /* @__PURE__ */ ((e) => (t) => {
  const n = xp.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Ae = (e) => (e = e.toLowerCase(), (t) => Pn(t) === e), Rn = (e) => (t) => typeof t === e, { isArray: wt } = Array, zt = Rn("undefined");
function Tp(e) {
  return e !== null && !zt(e) && e.constructor !== null && !zt(e.constructor) && xe(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const ai = Ae("ArrayBuffer");
function $p(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && ai(e.buffer), t;
}
const Op = Rn("string"), xe = Rn("function"), ci = Rn("number"), An = (e) => e !== null && typeof e == "object", kp = (e) => e === !0 || e === !1, hn = (e) => {
  if (Pn(e) !== "object")
    return !1;
  const t = kr(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, Ep = Ae("Date"), Ip = Ae("File"), Pp = Ae("Blob"), Rp = Ae("FileList"), Ap = (e) => An(e) && xe(e.pipe), jp = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || xe(e.append) && ((t = Pn(e)) === "formdata" || // detect form-data instance
  t === "object" && xe(e.toString) && e.toString() === "[object FormData]"));
}, Dp = Ae("URLSearchParams"), [Lp, Mp, Np, Up] = ["ReadableStream", "Request", "Response", "Headers"].map(Ae), qp = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Gt(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, s;
  if (typeof e != "object" && (e = [e]), wt(e))
    for (r = 0, s = e.length; r < s; r++)
      t.call(null, e[r], r, e);
  else {
    const o = n ? Object.getOwnPropertyNames(e) : Object.keys(e), i = o.length;
    let a;
    for (r = 0; r < i; r++)
      a = o[r], t.call(null, e[a], a, e);
  }
}
function ui(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, s;
  for (; r-- > 0; )
    if (s = n[r], t === s.toLowerCase())
      return s;
  return null;
}
const nt = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, li = (e) => !zt(e) && e !== nt;
function sr() {
  const { caseless: e } = li(this) && this || {}, t = {}, n = (r, s) => {
    const o = e && ui(t, s) || s;
    hn(t[o]) && hn(r) ? t[o] = sr(t[o], r) : hn(r) ? t[o] = sr({}, r) : wt(r) ? t[o] = r.slice() : t[o] = r;
  };
  for (let r = 0, s = arguments.length; r < s; r++)
    arguments[r] && Gt(arguments[r], n);
  return t;
}
const Fp = (e, t, n, { allOwnKeys: r } = {}) => (Gt(t, (s, o) => {
  n && xe(s) ? e[o] = ii(s, n) : e[o] = s;
}, { allOwnKeys: r }), e), Bp = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), Vp = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, zp = (e, t, n, r) => {
  let s, o, i;
  const a = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (s = Object.getOwnPropertyNames(e), o = s.length; o-- > 0; )
      i = s[o], (!r || r(i, e, t)) && !a[i] && (t[i] = e[i], a[i] = !0);
    e = n !== !1 && kr(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, Hp = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, Wp = (e) => {
  if (!e)
    return null;
  if (wt(e))
    return e;
  let t = e.length;
  if (!ci(t))
    return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, Yp = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && kr(Uint8Array)), Kp = (e, t) => {
  const n = (e && e[Symbol.iterator]).call(e);
  let r;
  for (; (r = n.next()) && !r.done; ) {
    const s = r.value;
    t.call(e, s[0], s[1]);
  }
}, Gp = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, Jp = Ae("HTMLFormElement"), Zp = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(t, n, r) {
    return n.toUpperCase() + r;
  }
), hs = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), Xp = Ae("RegExp"), di = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  Gt(n, (s, o) => {
    let i;
    (i = t(s, o, e)) !== !1 && (r[o] = i || s);
  }), Object.defineProperties(e, r);
}, Qp = (e) => {
  di(e, (t, n) => {
    if (xe(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (xe(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, ef = (e, t) => {
  const n = {}, r = (s) => {
    s.forEach((o) => {
      n[o] = !0;
    });
  };
  return wt(e) ? r(e) : r(String(e).split(t)), n;
}, tf = () => {
}, nf = (e, t) => e != null && Number.isFinite(e = +e) ? e : t, zn = "abcdefghijklmnopqrstuvwxyz", ms = "0123456789", pi = {
  DIGIT: ms,
  ALPHA: zn,
  ALPHA_DIGIT: zn + zn.toUpperCase() + ms
}, rf = (e = 16, t = pi.ALPHA_DIGIT) => {
  let n = "";
  const { length: r } = t;
  for (; e--; )
    n += t[Math.random() * r | 0];
  return n;
};
function sf(e) {
  return !!(e && xe(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const of = (e) => {
  const t = new Array(10), n = (r, s) => {
    if (An(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[s] = r;
        const o = wt(r) ? [] : {};
        return Gt(r, (i, a) => {
          const u = n(i, s + 1);
          !zt(u) && (o[a] = u);
        }), t[s] = void 0, o;
      }
    }
    return r;
  };
  return n(e, 0);
}, af = Ae("AsyncFunction"), cf = (e) => e && (An(e) || xe(e)) && xe(e.then) && xe(e.catch), fi = ((e, t) => e ? setImmediate : t ? ((n, r) => (nt.addEventListener("message", ({ source: s, data: o }) => {
  s === nt && o === n && r.length && r.shift()();
}, !1), (s) => {
  r.push(s), nt.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  xe(nt.postMessage)
), uf = typeof queueMicrotask < "u" ? queueMicrotask.bind(nt) : typeof process < "u" && process.nextTick || fi, C = {
  isArray: wt,
  isArrayBuffer: ai,
  isBuffer: Tp,
  isFormData: jp,
  isArrayBufferView: $p,
  isString: Op,
  isNumber: ci,
  isBoolean: kp,
  isObject: An,
  isPlainObject: hn,
  isReadableStream: Lp,
  isRequest: Mp,
  isResponse: Np,
  isHeaders: Up,
  isUndefined: zt,
  isDate: Ep,
  isFile: Ip,
  isBlob: Pp,
  isRegExp: Xp,
  isFunction: xe,
  isStream: Ap,
  isURLSearchParams: Dp,
  isTypedArray: Yp,
  isFileList: Rp,
  forEach: Gt,
  merge: sr,
  extend: Fp,
  trim: qp,
  stripBOM: Bp,
  inherits: Vp,
  toFlatObject: zp,
  kindOf: Pn,
  kindOfTest: Ae,
  endsWith: Hp,
  toArray: Wp,
  forEachEntry: Kp,
  matchAll: Gp,
  isHTMLForm: Jp,
  hasOwnProperty: hs,
  hasOwnProp: hs,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: di,
  freezeMethods: Qp,
  toObjectSet: ef,
  toCamelCase: Zp,
  noop: tf,
  toFiniteNumber: nf,
  findKey: ui,
  global: nt,
  isContextDefined: li,
  ALPHABET: pi,
  generateString: rf,
  isSpecCompliantForm: sf,
  toJSONObject: of,
  isAsyncFn: af,
  isThenable: cf,
  setImmediate: fi,
  asap: uf
};
function V(e, t, n, r, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), s && (this.response = s, this.status = s.status ? s.status : null);
}
C.inherits(V, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: C.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const hi = V.prototype, mi = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  mi[e] = { value: e };
});
Object.defineProperties(V, mi);
Object.defineProperty(hi, "isAxiosError", { value: !0 });
V.from = (e, t, n, r, s, o) => {
  const i = Object.create(hi);
  return C.toFlatObject(e, i, function(a) {
    return a !== Error.prototype;
  }, (a) => a !== "isAxiosError"), V.call(i, e.message, t, n, r, s), i.cause = e, i.name = e.name, o && Object.assign(i, o), i;
};
const lf = null;
function or(e) {
  return C.isPlainObject(e) || C.isArray(e);
}
function gi(e) {
  return C.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function gs(e, t, n) {
  return e ? e.concat(t).map(function(r, s) {
    return r = gi(r), !n && s ? "[" + r + "]" : r;
  }).join(n ? "." : "") : t;
}
function df(e) {
  return C.isArray(e) && !e.some(or);
}
const pf = C.toFlatObject(C, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function jn(e, t, n) {
  if (!C.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = C.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(m, b) {
    return !C.isUndefined(b[m]);
  });
  const r = n.metaTokens, s = n.visitor || c, o = n.dots, i = n.indexes, a = (n.Blob || typeof Blob < "u" && Blob) && C.isSpecCompliantForm(t);
  if (!C.isFunction(s))
    throw new TypeError("visitor must be a function");
  function u(m) {
    if (m === null)
      return "";
    if (C.isDate(m))
      return m.toISOString();
    if (!a && C.isBlob(m))
      throw new V("Blob is not supported. Use a Buffer instead.");
    return C.isArrayBuffer(m) || C.isTypedArray(m) ? a && typeof Blob == "function" ? new Blob([m]) : Buffer.from(m) : m;
  }
  function c(m, b, f) {
    let S = m;
    if (m && !f && typeof m == "object") {
      if (C.endsWith(b, "{}"))
        b = r ? b : b.slice(0, -2), m = JSON.stringify(m);
      else if (C.isArray(m) && df(m) || (C.isFileList(m) || C.endsWith(b, "[]")) && (S = C.toArray(m)))
        return b = gi(b), S.forEach(function($, E) {
          !(C.isUndefined($) || $ === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            i === !0 ? gs([b], E, o) : i === null ? b : b + "[]",
            u($)
          );
        }), !1;
    }
    return or(m) ? !0 : (t.append(gs(f, b, o), u(m)), !1);
  }
  const l = [], d = Object.assign(pf, {
    defaultVisitor: c,
    convertValue: u,
    isVisitable: or
  });
  function g(m, b) {
    if (!C.isUndefined(m)) {
      if (l.indexOf(m) !== -1)
        throw Error("Circular reference detected in " + b.join("."));
      l.push(m), C.forEach(m, function(f, S) {
        (!(C.isUndefined(f) || f === null) && s.call(
          t,
          f,
          C.isString(S) ? S.trim() : S,
          b,
          d
        )) === !0 && g(f, b ? b.concat(S) : [S]);
      }), l.pop();
    }
  }
  if (!C.isObject(e))
    throw new TypeError("data must be an object");
  return g(e), t;
}
function vs(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function Er(e, t) {
  this._pairs = [], e && jn(e, this, t);
}
const vi = Er.prototype;
vi.append = function(e, t) {
  this._pairs.push([e, t]);
};
vi.toString = function(e) {
  const t = e ? function(n) {
    return e.call(this, n, vs);
  } : vs;
  return this._pairs.map(function(n) {
    return t(n[0]) + "=" + t(n[1]);
  }, "").join("&");
};
function ff(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function yi(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || ff;
  C.isFunction(n) && (n = {
    serialize: n
  });
  const s = n && n.serialize;
  let o;
  if (s ? o = s(t, n) : o = C.isURLSearchParams(t) ? t.toString() : new Er(t, n).toString(r), o) {
    const i = e.indexOf("#");
    i !== -1 && (e = e.slice(0, i)), e += (e.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return e;
}
class ys {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    C.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
}
const bi = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, hf = typeof URLSearchParams < "u" ? URLSearchParams : Er, mf = typeof FormData < "u" ? FormData : null, gf = typeof Blob < "u" ? Blob : null, vf = {
  isBrowser: !0,
  classes: {
    URLSearchParams: hf,
    FormData: mf,
    Blob: gf
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Ir = typeof window < "u" && typeof document < "u", ir = typeof navigator == "object" && navigator || void 0, yf = Ir && (!ir || ["ReactNative", "NativeScript", "NS"].indexOf(ir.product) < 0), bf = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", wf = Ir && window.location.href || "http://localhost", _f = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Ir,
  hasStandardBrowserEnv: yf,
  hasStandardBrowserWebWorkerEnv: bf,
  navigator: ir,
  origin: wf
}, Symbol.toStringTag, { value: "Module" })), ye = {
  ..._f,
  ...vf
};
function Sf(e, t) {
  return jn(e, new ye.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, s, o) {
      return ye.isNode && C.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function Cf(e) {
  return C.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function xf(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const s = n.length;
  let o;
  for (r = 0; r < s; r++)
    o = n[r], t[o] = e[o];
  return t;
}
function wi(e) {
  function t(n, r, s, o) {
    let i = n[o++];
    if (i === "__proto__")
      return !0;
    const a = Number.isFinite(+i), u = o >= n.length;
    return i = !i && C.isArray(s) ? s.length : i, u ? (C.hasOwnProp(s, i) ? s[i] = [s[i], r] : s[i] = r, !a) : ((!s[i] || !C.isObject(s[i])) && (s[i] = []), t(n, r, s[i], o) && C.isArray(s[i]) && (s[i] = xf(s[i])), !a);
  }
  if (C.isFormData(e) && C.isFunction(e.entries)) {
    const n = {};
    return C.forEachEntry(e, (r, s) => {
      t(Cf(r), s, n, 0);
    }), n;
  }
  return null;
}
function Tf(e, t, n) {
  if (C.isString(e))
    try {
      return (t || JSON.parse)(e), C.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (0, JSON.stringify)(e);
}
const Jt = {
  transitional: bi,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, t) {
    const n = t.getContentType() || "", r = n.indexOf("application/json") > -1, s = C.isObject(e);
    if (s && C.isHTMLForm(e) && (e = new FormData(e)), C.isFormData(e))
      return r ? JSON.stringify(wi(e)) : e;
    if (C.isArrayBuffer(e) || C.isBuffer(e) || C.isStream(e) || C.isFile(e) || C.isBlob(e) || C.isReadableStream(e))
      return e;
    if (C.isArrayBufferView(e))
      return e.buffer;
    if (C.isURLSearchParams(e))
      return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let o;
    if (s) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return Sf(e, this.formSerializer).toString();
      if ((o = C.isFileList(e)) || n.indexOf("multipart/form-data") > -1) {
        const i = this.env && this.env.FormData;
        return jn(
          o ? { "files[]": e } : e,
          i && new i(),
          this.formSerializer
        );
      }
    }
    return s || r ? (t.setContentType("application/json", !1), Tf(e)) : e;
  }],
  transformResponse: [function(e) {
    const t = this.transitional || Jt.transitional, n = t && t.forcedJSONParsing, r = this.responseType === "json";
    if (C.isResponse(e) || C.isReadableStream(e))
      return e;
    if (e && C.isString(e) && (n && !this.responseType || r)) {
      const s = !(t && t.silentJSONParsing) && r;
      try {
        return JSON.parse(e);
      } catch (o) {
        if (s)
          throw o.name === "SyntaxError" ? V.from(o, V.ERR_BAD_RESPONSE, this, null, this.response) : o;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: ye.classes.FormData,
    Blob: ye.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
C.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  Jt.headers[e] = {};
});
const $f = C.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Of = (e) => {
  const t = {};
  let n, r, s;
  return e && e.split(`
`).forEach(function(o) {
    s = o.indexOf(":"), n = o.substring(0, s).trim().toLowerCase(), r = o.substring(s + 1).trim(), !(!n || t[n] && $f[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, bs = Symbol("internals");
function xt(e) {
  return e && String(e).trim().toLowerCase();
}
function mn(e) {
  return e === !1 || e == null ? e : C.isArray(e) ? e.map(mn) : String(e);
}
function kf(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const Ef = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Hn(e, t, n, r, s) {
  if (C.isFunction(r))
    return r.call(this, t, n);
  if (s && (t = n), !!C.isString(t)) {
    if (C.isString(r))
      return t.indexOf(r) !== -1;
    if (C.isRegExp(r))
      return r.test(t);
  }
}
function If(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function Pf(e, t) {
  const n = C.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(s, o, i) {
        return this[r].call(this, t, s, o, i);
      },
      configurable: !0
    });
  });
}
class _e {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const s = this;
    function o(a, u, c) {
      const l = xt(u);
      if (!l)
        throw new Error("header name must be a non-empty string");
      const d = C.findKey(s, l);
      (!d || s[d] === void 0 || c === !0 || c === void 0 && s[d] !== !1) && (s[d || u] = mn(a));
    }
    const i = (a, u) => C.forEach(a, (c, l) => o(c, l, u));
    if (C.isPlainObject(t) || t instanceof this.constructor)
      i(t, n);
    else if (C.isString(t) && (t = t.trim()) && !Ef(t))
      i(Of(t), n);
    else if (C.isHeaders(t))
      for (const [a, u] of t.entries())
        o(u, a, r);
    else
      t != null && o(n, t, r);
    return this;
  }
  get(t, n) {
    if (t = xt(t), t) {
      const r = C.findKey(this, t);
      if (r) {
        const s = this[r];
        if (!n)
          return s;
        if (n === !0)
          return kf(s);
        if (C.isFunction(n))
          return n.call(this, s, r);
        if (C.isRegExp(n))
          return n.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = xt(t), t) {
      const r = C.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || Hn(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let s = !1;
    function o(i) {
      if (i = xt(i), i) {
        const a = C.findKey(r, i);
        a && (!n || Hn(r, r[a], a, n)) && (delete r[a], s = !0);
      }
    }
    return C.isArray(t) ? t.forEach(o) : o(t), s;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, s = !1;
    for (; r--; ) {
      const o = n[r];
      (!t || Hn(this, this[o], o, t, !0)) && (delete this[o], s = !0);
    }
    return s;
  }
  normalize(t) {
    const n = this, r = {};
    return C.forEach(this, (s, o) => {
      const i = C.findKey(r, o);
      if (i) {
        n[i] = mn(s), delete n[o];
        return;
      }
      const a = t ? If(o) : String(o).trim();
      a !== o && delete n[o], n[a] = mn(s), r[a] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return C.forEach(this, (r, s) => {
      r != null && r !== !1 && (n[s] = t && C.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((s) => r.set(s)), r;
  }
  static accessor(t) {
    const n = (this[bs] = this[bs] = {
      accessors: {}
    }).accessors, r = this.prototype;
    function s(o) {
      const i = xt(o);
      n[i] || (Pf(r, o), n[i] = !0);
    }
    return C.isArray(t) ? t.forEach(s) : s(t), this;
  }
}
_e.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
C.reduceDescriptors(_e.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(r) {
      this[n] = r;
    }
  };
});
C.freezeMethods(_e);
function Wn(e, t) {
  const n = this || Jt, r = t || n, s = _e.from(r.headers);
  let o = r.data;
  return C.forEach(e, function(i) {
    o = i.call(n, o, s.normalize(), t ? t.status : void 0);
  }), s.normalize(), o;
}
function _i(e) {
  return !!(e && e.__CANCEL__);
}
function _t(e, t, n) {
  V.call(this, e ?? "canceled", V.ERR_CANCELED, t, n), this.name = "CanceledError";
}
C.inherits(_t, V, {
  __CANCEL__: !0
});
function Si(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new V(
    "Request failed with status code " + n.status,
    [V.ERR_BAD_REQUEST, V.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function Rf(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function Af(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let s = 0, o = 0, i;
  return t = t !== void 0 ? t : 1e3, function(a) {
    const u = Date.now(), c = r[o];
    i || (i = u), n[s] = a, r[s] = u;
    let l = o, d = 0;
    for (; l !== s; )
      d += n[l++], l = l % e;
    if (s = (s + 1) % e, s === o && (o = (o + 1) % e), u - i < t)
      return;
    const g = c && u - c;
    return g ? Math.round(d * 1e3 / g) : void 0;
  };
}
function jf(e, t) {
  let n = 0, r = 1e3 / t, s, o;
  const i = (a, u = Date.now()) => {
    n = u, s = null, o && (clearTimeout(o), o = null), e.apply(null, a);
  };
  return [(...a) => {
    const u = Date.now(), c = u - n;
    c >= r ? i(a, u) : (s = a, o || (o = setTimeout(() => {
      o = null, i(s);
    }, r - c)));
  }, () => s && i(s)];
}
const Sn = (e, t, n = 3) => {
  let r = 0;
  const s = Af(50, 250);
  return jf((o) => {
    const i = o.loaded, a = o.lengthComputable ? o.total : void 0, u = i - r, c = s(u), l = i <= a;
    r = i;
    const d = {
      loaded: i,
      total: a,
      progress: a ? i / a : void 0,
      bytes: u,
      rate: c || void 0,
      estimated: c && a && l ? (a - i) / c : void 0,
      event: o,
      lengthComputable: a != null,
      [t ? "download" : "upload"]: !0
    };
    e(d);
  }, n);
}, ws = (e, t) => {
  const n = e != null;
  return [(r) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: r
  }), t[1]];
}, _s = (e) => (...t) => C.asap(() => e(...t)), Df = ye.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (n) => (n = new URL(n, ye.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(
  new URL(ye.origin),
  ye.navigator && /(msie|trident)/i.test(ye.navigator.userAgent)
) : () => !0, Lf = ye.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, r, s, o) {
      const i = [e + "=" + encodeURIComponent(t)];
      C.isNumber(n) && i.push("expires=" + new Date(n).toGMTString()), C.isString(r) && i.push("path=" + r), C.isString(s) && i.push("domain=" + s), o === !0 && i.push("secure"), document.cookie = i.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function Mf(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function Nf(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Ci(e, t) {
  return e && !Mf(t) ? Nf(e, t) : t;
}
const Ss = (e) => e instanceof _e ? { ...e } : e;
function at(e, t) {
  t = t || {};
  const n = {};
  function r(c, l, d, g) {
    return C.isPlainObject(c) && C.isPlainObject(l) ? C.merge.call({ caseless: g }, c, l) : C.isPlainObject(l) ? C.merge({}, l) : C.isArray(l) ? l.slice() : l;
  }
  function s(c, l, d, g) {
    if (C.isUndefined(l)) {
      if (!C.isUndefined(c))
        return r(void 0, c, d, g);
    } else
      return r(c, l, d, g);
  }
  function o(c, l) {
    if (!C.isUndefined(l))
      return r(void 0, l);
  }
  function i(c, l) {
    if (C.isUndefined(l)) {
      if (!C.isUndefined(c))
        return r(void 0, c);
    } else
      return r(void 0, l);
  }
  function a(c, l, d) {
    if (d in t)
      return r(c, l);
    if (d in e)
      return r(void 0, c);
  }
  const u = {
    url: o,
    method: o,
    data: o,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    withXSRFToken: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: a,
    headers: (c, l, d) => s(Ss(c), Ss(l), d, !0)
  };
  return C.forEach(Object.keys(Object.assign({}, e, t)), function(c) {
    const l = u[c] || s, d = l(e[c], t[c], c);
    C.isUndefined(d) && l !== a || (n[c] = d);
  }), n;
}
const xi = (e) => {
  const t = at({}, e);
  let { data: n, withXSRFToken: r, xsrfHeaderName: s, xsrfCookieName: o, headers: i, auth: a } = t;
  t.headers = i = _e.from(i), t.url = yi(Ci(t.baseURL, t.url), e.params, e.paramsSerializer), a && i.set(
    "Authorization",
    "Basic " + btoa((a.username || "") + ":" + (a.password ? unescape(encodeURIComponent(a.password)) : ""))
  );
  let u;
  if (C.isFormData(n)) {
    if (ye.hasStandardBrowserEnv || ye.hasStandardBrowserWebWorkerEnv)
      i.setContentType(void 0);
    else if ((u = i.getContentType()) !== !1) {
      const [c, ...l] = u ? u.split(";").map((d) => d.trim()).filter(Boolean) : [];
      i.setContentType([c || "multipart/form-data", ...l].join("; "));
    }
  }
  if (ye.hasStandardBrowserEnv && (r && C.isFunction(r) && (r = r(t)), r || r !== !1 && Df(t.url))) {
    const c = s && o && Lf.read(o);
    c && i.set(s, c);
  }
  return t;
}, Uf = typeof XMLHttpRequest < "u", qf = Uf && function(e) {
  return new Promise(function(t, n) {
    const r = xi(e);
    let s = r.data;
    const o = _e.from(r.headers).normalize();
    let { responseType: i, onUploadProgress: a, onDownloadProgress: u } = r, c, l, d, g, m;
    function b() {
      g && g(), m && m(), r.cancelToken && r.cancelToken.unsubscribe(c), r.signal && r.signal.removeEventListener("abort", c);
    }
    let f = new XMLHttpRequest();
    f.open(r.method.toUpperCase(), r.url, !0), f.timeout = r.timeout;
    function S() {
      if (!f)
        return;
      const E = _e.from(
        "getAllResponseHeaders" in f && f.getAllResponseHeaders()
      ), j = {
        data: !i || i === "text" || i === "json" ? f.responseText : f.response,
        status: f.status,
        statusText: f.statusText,
        headers: E,
        config: e,
        request: f
      };
      Si(function(D) {
        t(D), b();
      }, function(D) {
        n(D), b();
      }, j), f = null;
    }
    "onloadend" in f ? f.onloadend = S : f.onreadystatechange = function() {
      !f || f.readyState !== 4 || f.status === 0 && !(f.responseURL && f.responseURL.indexOf("file:") === 0) || setTimeout(S);
    }, f.onabort = function() {
      f && (n(new V("Request aborted", V.ECONNABORTED, e, f)), f = null);
    }, f.onerror = function() {
      n(new V("Network Error", V.ERR_NETWORK, e, f)), f = null;
    }, f.ontimeout = function() {
      let E = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded";
      const j = r.transitional || bi;
      r.timeoutErrorMessage && (E = r.timeoutErrorMessage), n(new V(
        E,
        j.clarifyTimeoutError ? V.ETIMEDOUT : V.ECONNABORTED,
        e,
        f
      )), f = null;
    }, s === void 0 && o.setContentType(null), "setRequestHeader" in f && C.forEach(o.toJSON(), function(E, j) {
      f.setRequestHeader(j, E);
    }), C.isUndefined(r.withCredentials) || (f.withCredentials = !!r.withCredentials), i && i !== "json" && (f.responseType = r.responseType), u && ([d, m] = Sn(u, !0), f.addEventListener("progress", d)), a && f.upload && ([l, g] = Sn(a), f.upload.addEventListener("progress", l), f.upload.addEventListener("loadend", g)), (r.cancelToken || r.signal) && (c = (E) => {
      f && (n(!E || E.type ? new _t(null, e, f) : E), f.abort(), f = null);
    }, r.cancelToken && r.cancelToken.subscribe(c), r.signal && (r.signal.aborted ? c() : r.signal.addEventListener("abort", c)));
    const $ = Rf(r.url);
    if ($ && ye.protocols.indexOf($) === -1) {
      n(new V("Unsupported protocol " + $ + ":", V.ERR_BAD_REQUEST, e));
      return;
    }
    f.send(s || null);
  });
}, Ff = (e, t) => {
  const { length: n } = e = e ? e.filter(Boolean) : [];
  if (t || n) {
    let r = new AbortController(), s;
    const o = function(c) {
      if (!s) {
        s = !0, a();
        const l = c instanceof Error ? c : this.reason;
        r.abort(l instanceof V ? l : new _t(l instanceof Error ? l.message : l));
      }
    };
    let i = t && setTimeout(() => {
      i = null, o(new V(`timeout ${t} of ms exceeded`, V.ETIMEDOUT));
    }, t);
    const a = () => {
      e && (i && clearTimeout(i), i = null, e.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(o) : c.removeEventListener("abort", o);
      }), e = null);
    };
    e.forEach((c) => c.addEventListener("abort", o));
    const { signal: u } = r;
    return u.unsubscribe = () => C.asap(a), u;
  }
}, Bf = function* (e, t) {
  let n = e.byteLength;
  if (n < t) {
    yield e;
    return;
  }
  let r = 0, s;
  for (; r < n; )
    s = r + t, yield e.slice(r, s), r = s;
}, Vf = async function* (e, t) {
  for await (const n of zf(e))
    yield* Bf(n, t);
}, zf = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: n, value: r } = await t.read();
      if (n)
        break;
      yield r;
    }
  } finally {
    await t.cancel();
  }
}, Cs = (e, t, n, r) => {
  const s = Vf(e, t);
  let o = 0, i, a = (u) => {
    i || (i = !0, r && r(u));
  };
  return new ReadableStream({
    async pull(u) {
      try {
        const { done: c, value: l } = await s.next();
        if (c) {
          a(), u.close();
          return;
        }
        let d = l.byteLength;
        if (n) {
          let g = o += d;
          n(g);
        }
        u.enqueue(new Uint8Array(l));
      } catch (c) {
        throw a(c), c;
      }
    },
    cancel(u) {
      return a(u), s.return();
    }
  }, {
    highWaterMark: 2
  });
}, Dn = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", Ti = Dn && typeof ReadableStream == "function", Hf = Dn && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), $i = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, Wf = Ti && $i(() => {
  let e = !1;
  const t = new Request(ye.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), xs = 64 * 1024, ar = Ti && $i(() => C.isReadableStream(new Response("").body)), Cn = {
  stream: ar && ((e) => e.body)
};
Dn && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !Cn[t] && (Cn[t] = C.isFunction(e[t]) ? (n) => n[t]() : (n, r) => {
      throw new V(`Response type '${t}' is not supported`, V.ERR_NOT_SUPPORT, r);
    });
  });
})(new Response());
const Yf = async (e) => {
  if (e == null)
    return 0;
  if (C.isBlob(e))
    return e.size;
  if (C.isSpecCompliantForm(e))
    return (await new Request(ye.origin, {
      method: "POST",
      body: e
    }).arrayBuffer()).byteLength;
  if (C.isArrayBufferView(e) || C.isArrayBuffer(e))
    return e.byteLength;
  if (C.isURLSearchParams(e) && (e = e + ""), C.isString(e))
    return (await Hf(e)).byteLength;
}, Kf = async (e, t) => C.toFiniteNumber(e.getContentLength()) ?? Yf(t), Gf = Dn && (async (e) => {
  let {
    url: t,
    method: n,
    data: r,
    signal: s,
    cancelToken: o,
    timeout: i,
    onDownloadProgress: a,
    onUploadProgress: u,
    responseType: c,
    headers: l,
    withCredentials: d = "same-origin",
    fetchOptions: g
  } = xi(e);
  c = c ? (c + "").toLowerCase() : "text";
  let m = Ff([s, o && o.toAbortSignal()], i), b;
  const f = m && m.unsubscribe && (() => {
    m.unsubscribe();
  });
  let S;
  try {
    if (u && Wf && n !== "get" && n !== "head" && (S = await Kf(l, r)) !== 0) {
      let I = new Request(t, {
        method: "POST",
        body: r,
        duplex: "half"
      }), M;
      if (C.isFormData(r) && (M = I.headers.get("content-type")) && l.setContentType(M), I.body) {
        const [K, J] = ws(
          S,
          Sn(_s(u))
        );
        r = Cs(I.body, xs, K, J);
      }
    }
    C.isString(d) || (d = d ? "include" : "omit");
    const $ = "credentials" in Request.prototype;
    b = new Request(t, {
      ...g,
      signal: m,
      method: n.toUpperCase(),
      headers: l.normalize().toJSON(),
      body: r,
      duplex: "half",
      credentials: $ ? d : void 0
    });
    let E = await fetch(b);
    const j = ar && (c === "stream" || c === "response");
    if (ar && (a || j && f)) {
      const I = {};
      ["status", "statusText", "headers"].forEach((q) => {
        I[q] = E[q];
      });
      const M = C.toFiniteNumber(E.headers.get("content-length")), [K, J] = a && ws(
        M,
        Sn(_s(a), !0)
      ) || [];
      E = new Response(
        Cs(E.body, xs, K, () => {
          J && J(), f && f();
        }),
        I
      );
    }
    c = c || "text";
    let D = await Cn[C.findKey(Cn, c) || "text"](E, e);
    return !j && f && f(), await new Promise((I, M) => {
      Si(I, M, {
        data: D,
        headers: _e.from(E.headers),
        status: E.status,
        statusText: E.statusText,
        config: e,
        request: b
      });
    });
  } catch ($) {
    throw f && f(), $ && $.name === "TypeError" && /fetch/i.test($.message) ? Object.assign(
      new V("Network Error", V.ERR_NETWORK, e, b),
      {
        cause: $.cause || $
      }
    ) : V.from($, $ && $.code, e, b);
  }
}), cr = {
  http: lf,
  xhr: qf,
  fetch: Gf
};
C.forEach(cr, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Ts = (e) => `- ${e}`, Jf = (e) => C.isFunction(e) || e === null || e === !1, Oi = {
  getAdapter: (e) => {
    e = C.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    const s = {};
    for (let o = 0; o < t; o++) {
      n = e[o];
      let i;
      if (r = n, !Jf(n) && (r = cr[(i = String(n)).toLowerCase()], r === void 0))
        throw new V(`Unknown adapter '${i}'`);
      if (r)
        break;
      s[i || "#" + o] = r;
    }
    if (!r) {
      const o = Object.entries(s).map(
        ([a, u]) => `adapter ${a} ` + (u === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let i = t ? o.length > 1 ? `since :
` + o.map(Ts).join(`
`) : " " + Ts(o[0]) : "as no adapter specified";
      throw new V(
        "There is no suitable adapter to dispatch the request " + i,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: cr
};
function Yn(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new _t(null, e);
}
function $s(e) {
  return Yn(e), e.headers = _e.from(e.headers), e.data = Wn.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Oi.getAdapter(e.adapter || Jt.adapter)(e).then(function(t) {
    return Yn(e), t.data = Wn.call(
      e,
      e.transformResponse,
      t
    ), t.headers = _e.from(t.headers), t;
  }, function(t) {
    return _i(t) || (Yn(e), t && t.response && (t.response.data = Wn.call(
      e,
      e.transformResponse,
      t.response
    ), t.response.headers = _e.from(t.response.headers))), Promise.reject(t);
  });
}
const ki = "1.7.9", Ln = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Ln[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Os = {};
Ln.transitional = function(e, t, n) {
  function r(s, o) {
    return "[Axios v" + ki + "] Transitional option '" + s + "'" + o + (n ? ". " + n : "");
  }
  return (s, o, i) => {
    if (e === !1)
      throw new V(
        r(o, " has been removed" + (t ? " in " + t : "")),
        V.ERR_DEPRECATED
      );
    return t && !Os[o] && (Os[o] = !0, console.warn(
      r(
        o,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), e ? e(s, o, i) : !0;
  };
};
Ln.spelling = function(e) {
  return (t, n) => (console.warn(`${n} is likely a misspelling of ${e}`), !0);
};
function Zf(e, t, n) {
  if (typeof e != "object")
    throw new V("options must be an object", V.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let s = r.length;
  for (; s-- > 0; ) {
    const o = r[s], i = t[o];
    if (i) {
      const a = e[o], u = a === void 0 || i(a, o, e);
      if (u !== !0)
        throw new V("option " + o + " must be " + u, V.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new V("Unknown option " + o, V.ERR_BAD_OPTION);
  }
}
const gn = {
  assertOptions: Zf,
  validators: Ln
}, De = gn.validators;
class rt {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new ys(),
      response: new ys()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (r) {
      if (r instanceof Error) {
        let s = {};
        Error.captureStackTrace ? Error.captureStackTrace(s) : s = new Error();
        const o = s.stack ? s.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? o && !String(r.stack).endsWith(o.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + o) : r.stack = o;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = at(this.defaults, n);
    const { transitional: r, paramsSerializer: s, headers: o } = n;
    r !== void 0 && gn.assertOptions(r, {
      silentJSONParsing: De.transitional(De.boolean),
      forcedJSONParsing: De.transitional(De.boolean),
      clarifyTimeoutError: De.transitional(De.boolean)
    }, !1), s != null && (C.isFunction(s) ? n.paramsSerializer = {
      serialize: s
    } : gn.assertOptions(s, {
      encode: De.function,
      serialize: De.function
    }, !0)), gn.assertOptions(n, {
      baseUrl: De.spelling("baseURL"),
      withXsrfToken: De.spelling("withXSRFToken")
    }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let i = o && C.merge(
      o.common,
      o[n.method]
    );
    o && C.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (b) => {
        delete o[b];
      }
    ), n.headers = _e.concat(i, o);
    const a = [];
    let u = !0;
    this.interceptors.request.forEach(function(b) {
      typeof b.runWhen == "function" && b.runWhen(n) === !1 || (u = u && b.synchronous, a.unshift(b.fulfilled, b.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(b) {
      c.push(b.fulfilled, b.rejected);
    });
    let l, d = 0, g;
    if (!u) {
      const b = [$s.bind(this), void 0];
      for (b.unshift.apply(b, a), b.push.apply(b, c), g = b.length, l = Promise.resolve(n); d < g; )
        l = l.then(b[d++], b[d++]);
      return l;
    }
    g = a.length;
    let m = n;
    for (d = 0; d < g; ) {
      const b = a[d++], f = a[d++];
      try {
        m = b(m);
      } catch (S) {
        f.call(this, S);
        break;
      }
    }
    try {
      l = $s.call(this, m);
    } catch (b) {
      return Promise.reject(b);
    }
    for (d = 0, g = c.length; d < g; )
      l = l.then(c[d++], c[d++]);
    return l;
  }
  getUri(t) {
    t = at(this.defaults, t);
    const n = Ci(t.baseURL, t.url);
    return yi(n, t.params, t.paramsSerializer);
  }
}
C.forEach(["delete", "get", "head", "options"], function(e) {
  rt.prototype[e] = function(t, n) {
    return this.request(at(n || {}, {
      method: e,
      url: t,
      data: (n || {}).data
    }));
  };
});
C.forEach(["post", "put", "patch"], function(e) {
  function t(n) {
    return function(r, s, o) {
      return this.request(at(o || {}, {
        method: e,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: r,
        data: s
      }));
    };
  }
  rt.prototype[e] = t(), rt.prototype[e + "Form"] = t(!0);
});
class Pr {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(s) {
      n = s;
    });
    const r = this;
    this.promise.then((s) => {
      if (!r._listeners)
        return;
      let o = r._listeners.length;
      for (; o-- > 0; )
        r._listeners[o](s);
      r._listeners = null;
    }), this.promise.then = (s) => {
      let o;
      const i = new Promise((a) => {
        r.subscribe(a), o = a;
      }).then(s);
      return i.cancel = function() {
        r.unsubscribe(o);
      }, i;
    }, t(function(s, o, i) {
      r.reason || (r.reason = new _t(s, o, i), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), n = (r) => {
      t.abort(r);
    };
    return this.subscribe(n), t.signal.unsubscribe = () => this.unsubscribe(n), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Pr(function(n) {
        t = n;
      }),
      cancel: t
    };
  }
}
function Xf(e) {
  return function(t) {
    return e.apply(null, t);
  };
}
function Qf(e) {
  return C.isObject(e) && e.isAxiosError === !0;
}
const ur = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(ur).forEach(([e, t]) => {
  ur[t] = e;
});
function Ei(e) {
  const t = new rt(e), n = ii(rt.prototype.request, t);
  return C.extend(n, rt.prototype, t, { allOwnKeys: !0 }), C.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(r) {
    return Ei(at(e, r));
  }, n;
}
const de = Ei(Jt);
de.Axios = rt;
de.CanceledError = _t;
de.CancelToken = Pr;
de.isCancel = _i;
de.VERSION = ki;
de.toFormData = jn;
de.AxiosError = V;
de.Cancel = de.CanceledError;
de.all = function(e) {
  return Promise.all(e);
};
de.spread = Xf;
de.isAxiosError = Qf;
de.mergeConfig = at;
de.AxiosHeaders = _e;
de.formToJSON = (e) => wi(C.isHTMLForm(e) ? new FormData(e) : e);
de.getAdapter = Oi.getAdapter;
de.HttpStatusCode = ur;
de.default = de;
const eh = 3e4;
class th {
  constructor(t) {
    H(this, "axiosInstance"), H(this, "getAccessToken");
    const { baseURL: n, defaultHeaders: r, timeout: s, getAccessToken: o } = t;
    this.axiosInstance = de.create({
      baseURL: n,
      headers: r,
      timeout: s ?? eh
    }), this.getAccessToken = o;
  }
  /**
   * Executes a request with the provided options, automatically injecting a Bearer token if missing.
   */
  async executeRequest(t) {
    const {
      method: n,
      route: r,
      pathParams: s = [],
      data: o,
      headers: i,
      responseType: a
    } = t;
    if (!r)
      throw new Error("Route is required");
    const u = s.length > 0 ? `/${s.join("/")}` : "", c = {
      ...this.axiosInstance.defaults.headers.common,
      ...i
    };
    if (!c.Authorization && this.getAccessToken)
      try {
        const g = await this.getAccessToken();
        g && (c.Authorization = `Bearer ${g}`);
      } catch (g) {
        throw new Error(`Failed to acquire access token: ${g}`);
      }
    const l = {
      method: n,
      url: `${r}${u}`,
      data: o,
      headers: c,
      responseType: a
    }, d = await this.axiosInstance(
      l
    );
    return {
      data: d.data,
      status: d.status
    };
  }
}
const nh = "https://apim-really-test.azure-api.net", rh = "3a7c292724d9422f8bd6c88e86cee633";
class sh {
  create(t, n) {
    const r = t.startsWith("/") ? t : `/${t}`;
    return new th({
      baseURL: `${nh}${r}`,
      defaultHeaders: {
        "Ocp-Apim-Subscription-Key": rh
      },
      getAccessToken: n
    });
  }
}
const oh = new sh();
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('.base-btn[data-v-41e566fd]{font-weight:600;font-size:.75rem;background:none;border:none;display:flex;gap:.5rem;align-items:center;justify-content:center;cursor:pointer;transition:all .25s ease;white-space:nowrap}.base-btn[data-v-41e566fd]:active:enabled{box-shadow:none}.base-btn[data-v-41e566fd]:disabled{cursor:no-drop}.base-btn--primary[data-v-41e566fd]{background-color:#441b49;color:#fff}.base-btn--primary[data-v-41e566fd]:active:enabled{background-color:#1d1d1d}.base-btn--primary[data-v-41e566fd]:hover:enabled{box-shadow:0 2px 10px #1d1d1d40;background-color:#2f0e33}.base-btn--primary[data-v-41e566fd]:disabled{background-color:#727272}.base-btn--accent[data-v-41e566fd]{background-color:#ecba4e;color:#1d1d1d}.base-btn--accent[data-v-41e566fd]:active:enabled{background-color:#d29e2d}.base-btn--accent[data-v-41e566fd]:hover:enabled{box-shadow:0 2px 10px #1d1d1d40;background-color:#e1ae3f}.base-btn--accent[data-v-41e566fd]:disabled{background-color:#d5d5d5}.base-btn--secondary[data-v-41e566fd]{background-color:#ede2f1;color:#1d1d1d}.base-btn--secondary[data-v-41e566fd]:active:enabled{background-color:#d8c4e0;box-shadow:none}.base-btn--secondary[data-v-41e566fd]:hover:enabled{box-shadow:0 2px 10px #1d1d1d40;background-color:#e5d5eb}.base-btn--secondary[data-v-41e566fd]:disabled{background-color:#ede2f1}.base-btn--tertiary[data-v-41e566fd]{border:1px solid #1d1d1d;color:#1d1d1d}.base-btn--tertiary[data-v-41e566fd]:disabled{border:1px solid #727272;opacity:.3}.base-btn--tertiary[data-v-41e566fd]:hover:enabled{background-color:#eaeaea}.base-btn--tertiary-link[data-v-41e566fd]{padding:0!important;width:auto!important;height:auto!important;font-size:.875rem;font-weight:400;text-decoration:underline;color:#1d1d1d}.base-btn--tertiary.base-btn--active[data-v-41e566fd]{background-color:#eaeaea}.base-btn__text--uppercase[data-v-41e566fd]{text-transform:uppercase}.base-btn--full-width[data-v-41e566fd]{width:100%}.base-btn--rounded[data-v-41e566fd],.base-btn--circle[data-v-41e566fd]{border-radius:9999px}.base-btn--rectangle.base-btn--border-radius-xs[data-v-41e566fd],.base-btn--square.base-btn--border-radius-xs[data-v-41e566fd]{border-radius:4px}.base-btn--rectangle.base-btn--border-radius-sm[data-v-41e566fd],.base-btn--square.base-btn--border-radius-sm[data-v-41e566fd]{border-radius:8px}.base-btn--rectangle.base-btn--size-xs[data-v-41e566fd],.base-btn--rounded.base-btn--size-xs[data-v-41e566fd]{height:2rem;padding:0 1.25rem}.base-btn--rectangle.base-btn--size-sm[data-v-41e566fd],.base-btn--rounded.base-btn--size-sm[data-v-41e566fd]{height:2.5rem;padding:0 1.25rem}.base-btn--rectangle.base-btn--size-md[data-v-41e566fd],.base-btn--rounded.base-btn--size-md[data-v-41e566fd]{height:3rem;padding:0 1.25rem}.base-btn--square.base-btn--size-md[data-v-41e566fd],.base-btn--circle.base-btn--size-md[data-v-41e566fd]{height:3rem;width:3rem}.base-btn__icon-container[data-v-41e566fd]{width:1.5rem;height:1.5rem;display:flex;align-items:center;justify-content:center}.base-btn__spinner[data-v-41e566fd]{width:.8125rem;height:.8125rem}.input-error[data-v-70494e94]{display:flex;align-items:center;background:#ffe7e9;border:1px solid #ff0000;border-radius:8px;padding:.75rem}.input-error__icon[data-v-70494e94]{flex-shrink:0}.input-error__text[data-v-70494e94]{margin-left:.5rem;font-weight:400;font-size:1rem;line-height:1.25}.base-checkbox[data-v-a6256959]{display:inline-block;position:relative;cursor:pointer;-webkit-user-select:none;user-select:none;align-items:center;height:1.25rem;width:1.25rem;border-radius:4px;border:1px solid #1d1d1d}.base-checkbox--disabled[data-v-a6256959]{cursor:not-allowed;border-color:#c8c8c8}.base-checkbox__checkmark[data-v-a6256959]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);height:1rem;width:1rem;border-radius:4px;background-color:#fff}.base-checkbox__checkmark[data-v-a6256959]:after{--width: 5px;--height: calc(var(--width) * 2);--x-shift: calc(calc(var(--width) / 2) * -1);--y-shift-correction: 1px;--y-shift: calc( calc(calc(var(--height) / 2) + var(--y-shift-correction)) * -1 );width:var(--width);height:var(--height);transform:translate(var(--x-shift),var(--y-shift)) rotate(45deg);left:50%;top:50%;border:solid white;border-width:0 2px 2px 0}.base-checkbox__checkmark[data-v-a6256959]:after{content:"";position:absolute;display:none}.base-checkbox__label[data-v-a6256959]{margin-left:.5rem}.base-checkbox__input[data-v-a6256959]{opacity:0;cursor:pointer;height:0;width:0}.base-checkbox__input--checked~.base-checkbox__checkmark[data-v-a6256959]:after{display:block}.base-checkbox__input--checked~.base-checkbox__checkmark[data-v-a6256959]{background-color:#2f5d38}.opt-in[data-v-3a7d7ee2]{display:flex;align-items:center;gap:.5rem}.opt-in[data-v-3a7d7ee2]:not(:first-child){margin-top:1rem}.opt-in__checkbox[data-v-3a7d7ee2]{display:flex;align-items:center}.opt-in__label[data-v-3a7d7ee2]{font-size:.875rem;font-weight:400;line-height:1.25}.get-started[data-v-44fc2677]{max-width:382px;border-radius:16px;background:#fff;box-shadow:0 0 10px #1d1d1d33;color:#1d1d1d}.get-started__illustration[data-v-44fc2677]{border-radius:16px 16px 0 0}.get-started__main[data-v-44fc2677]{padding:1.5rem 1.5rem 2rem;display:flex;flex-direction:column;gap:1.5rem}.get-started__title[data-v-44fc2677]{font-size:1.5rem;font-weight:400}.get-started__description[data-v-44fc2677]{font-size:1rem;font-weight:400}.get-started__opt-in[data-v-44fc2677]{display:flex;align-items:center;gap:.5rem}.get-started__opt-in[data-v-44fc2677]:not(:first-child){margin-top:1rem}.get-started__opt-in-checkbox[data-v-44fc2677]{display:flex;align-items:center}.get-started__opt-in-label[data-v-44fc2677]{font-size:.875rem;font-weight:400;line-height:1.25}')), document.head.appendChild(e);
    }
  } catch (t) {
    console.error("vite-plugin-css-injected-by-js", t);
  }
})();
const Ii = oh.create(
  "Tender",
  async () => ""
), ih = async (e) => {
  try {
    return await Ii.executeRequest({
      method: "GET",
      route: `/Organization/${e}/Agreements/Properties`
    });
  } catch (t) {
    throw new Error(`Failed to fetch agreement statistics: ${t instanceof Error ? t.message : "Unknown error"}`);
  }
}, ah = async (e) => {
  try {
    return await Ii.executeRequest({
      method: "GET",
      route: `/Organization/${e}/Agreements/Supplier`
    });
  } catch (t) {
    throw new Error(`Failed to fetch agreement statistics: ${t instanceof Error ? t.message : "Unknown error"}`);
  }
}, Pi = () => ({
  getAgreementStatsAsync: ih,
  getSupplierAgreementStatsAsync: ah
});
var ch = {
  root: {
    position: "relative"
  }
}, uh = {
  root: "p-chart"
}, lh = Ce.extend({
  name: "chart",
  classes: uh,
  inlineStyles: ch
}), dh = {
  name: "BaseChart",
  extends: En,
  props: {
    type: String,
    data: null,
    options: null,
    plugins: null,
    width: {
      type: Number,
      default: 300
    },
    height: {
      type: Number,
      default: 150
    },
    canvasProps: {
      type: null,
      default: null
    }
  },
  style: lh,
  provide: function() {
    return {
      $pcChart: this,
      $parentInstance: this
    };
  }
}, Rr = {
  name: "Chart",
  extends: dh,
  inheritAttrs: !1,
  emits: ["select", "loaded"],
  chart: null,
  watch: {
    /*
     * Use deep watch to enable triggering watch for changes within structure
     * otherwise the entire data object needs to be replaced to trigger watch
     */
    data: {
      handler: function() {
        this.reinit();
      },
      deep: !0
    },
    type: function() {
      this.reinit();
    },
    options: function() {
      this.reinit();
    }
  },
  mounted: function() {
    this.initChart();
  },
  beforeUnmount: function() {
    this.chart && (this.chart.destroy(), this.chart = null);
  },
  methods: {
    initChart: function() {
      var t = this;
      import("./auto-D2Ct9N1O.js").then(function(n) {
        t.chart && (t.chart.destroy(), t.chart = null), n && n.default && (t.chart = new n.default(t.$refs.canvas, {
          type: t.type,
          data: t.data,
          options: t.options,
          plugins: t.plugins
        })), t.$emit("loaded", t.chart);
      });
    },
    getCanvas: function() {
      return this.$canvas;
    },
    getChart: function() {
      return this.chart;
    },
    getBase64Image: function() {
      return this.chart.toBase64Image();
    },
    refresh: function() {
      this.chart && this.chart.update();
    },
    reinit: function() {
      this.initChart();
    },
    onCanvasClick: function(t) {
      if (this.chart) {
        var n = this.chart.getElementsAtEventForMode(t, "nearest", {
          intersect: !0
        }, !1), r = this.chart.getElementsAtEventForMode(t, "dataset", {
          intersect: !0
        }, !1);
        n && n[0] && r && this.$emit("select", {
          originalEvent: t,
          element: n[0],
          dataset: r
        });
      }
    },
    generateLegend: function() {
      if (this.chart)
        return this.chart.generateLegend();
    }
  }
};
function Ht(e) {
  "@babel/helpers - typeof";
  return Ht = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ht(e);
}
function ks(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Es(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ks(Object(n), !0).forEach(function(r) {
      ph(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ks(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function ph(e, t, n) {
  return (t = fh(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function fh(e) {
  var t = hh(e, "string");
  return Ht(t) == "symbol" ? t : t + "";
}
function hh(e, t) {
  if (Ht(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Ht(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var mh = ["width", "height"];
function gh(e, t, n, r, s, o) {
  return R(), Y("div", me({
    class: e.cx("root"),
    style: e.sx("root")
  }, e.ptmi("root")), [U("canvas", me({
    ref: "canvas",
    width: e.width,
    height: e.height,
    onClick: t[0] || (t[0] = function(i) {
      return o.onCanvasClick(i);
    })
  }, Es(Es({}, e.canvasProps), e.ptm("canvas"))), null, 16, mh)], 16);
}
Rr.render = gh;
var vh = function(t) {
  var n = t.dt;
  return `
.p-card {
    background: `.concat(n("card.background"), `;
    color: `).concat(n("card.color"), `;
    box-shadow: `).concat(n("card.shadow"), `;
    border-radius: `).concat(n("card.border.radius"), `;
    display: flex;
    flex-direction: column;
}

.p-card-caption {
    display: flex;
    flex-direction: column;
    gap: `).concat(n("card.caption.gap"), `;
}

.p-card-body {
    padding: `).concat(n("card.body.padding"), `;
    display: flex;
    flex-direction: column;
    gap: `).concat(n("card.body.gap"), `;
}

.p-card-title {
    font-size: `).concat(n("card.title.font.size"), `;
    font-weight: `).concat(n("card.title.font.weight"), `;
}

.p-card-subtitle {
    color: `).concat(n("card.subtitle.color"), `;
}
`);
}, yh = {
  root: "p-card p-component",
  header: "p-card-header",
  body: "p-card-body",
  caption: "p-card-caption",
  title: "p-card-title",
  subtitle: "p-card-subtitle",
  content: "p-card-content",
  footer: "p-card-footer"
}, bh = Ce.extend({
  name: "card",
  theme: vh,
  classes: yh
}), wh = {
  name: "BaseCard",
  extends: En,
  style: bh,
  provide: function() {
    return {
      $pcCard: this,
      $parentInstance: this
    };
  }
}, Ar = {
  name: "Card",
  extends: wh,
  inheritAttrs: !1
};
function _h(e, t, n, r, s, o) {
  return R(), Y("div", me({
    class: e.cx("root")
  }, e.ptmi("root")), [e.$slots.header ? (R(), Y("div", me({
    key: 0,
    class: e.cx("header")
  }, e.ptm("header")), [le(e.$slots, "header")], 16)) : te("", !0), U("div", me({
    class: e.cx("body")
  }, e.ptm("body")), [e.$slots.title || e.$slots.subtitle ? (R(), Y("div", me({
    key: 0,
    class: e.cx("caption")
  }, e.ptm("caption")), [e.$slots.title ? (R(), Y("div", me({
    key: 0,
    class: e.cx("title")
  }, e.ptm("title")), [le(e.$slots, "title")], 16)) : te("", !0), e.$slots.subtitle ? (R(), Y("div", me({
    key: 1,
    class: e.cx("subtitle")
  }, e.ptm("subtitle")), [le(e.$slots, "subtitle")], 16)) : te("", !0)], 16)) : te("", !0), U("div", me({
    class: e.cx("content")
  }, e.ptm("content")), [le(e.$slots, "content")], 16), e.$slots.footer ? (R(), Y("div", me({
    key: 1,
    class: e.cx("footer")
  }, e.ptm("footer")), [le(e.$slots, "footer")], 16)) : te("", !0)], 16)], 16);
}
Ar.render = _h;
var Sh = function(t) {
  var n = t.dt;
  return `
.p-skeleton {
    overflow: hidden;
    background: `.concat(n("skeleton.background"), `;
    border-radius: `).concat(n("skeleton.border.radius"), `;
}

.p-skeleton::after {
    content: "";
    animation: p-skeleton-animation 1.2s infinite;
    height: 100%;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transform: translateX(-100%);
    z-index: 1;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0), `).concat(n("skeleton.animation.background"), `, rgba(255, 255, 255, 0));
}

[dir='rtl'] .p-skeleton::after {
    animation-name: p-skeleton-animation-rtl;
}

.p-skeleton-circle {
    border-radius: 50%;
}

.p-skeleton-animation-none::after {
    animation: none;
}

@keyframes p-skeleton-animation {
    from {
        transform: translateX(-100%);
    }
    to {
        transform: translateX(100%);
    }
}

@keyframes p-skeleton-animation-rtl {
    from {
        transform: translateX(100%);
    }
    to {
        transform: translateX(-100%);
    }
}
`);
}, Ch = {
  root: {
    position: "relative"
  }
}, xh = {
  root: function(t) {
    var n = t.props;
    return ["p-skeleton p-component", {
      "p-skeleton-circle": n.shape === "circle",
      "p-skeleton-animation-none": n.animation === "none"
    }];
  }
}, Th = Ce.extend({
  name: "skeleton",
  theme: Sh,
  classes: xh,
  inlineStyles: Ch
}), $h = {
  name: "BaseSkeleton",
  extends: En,
  props: {
    shape: {
      type: String,
      default: "rectangle"
    },
    size: {
      type: String,
      default: null
    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "1rem"
    },
    borderRadius: {
      type: String,
      default: null
    },
    animation: {
      type: String,
      default: "wave"
    }
  },
  style: Th,
  provide: function() {
    return {
      $pcSkeleton: this,
      $parentInstance: this
    };
  }
}, jr = {
  name: "Skeleton",
  extends: $h,
  inheritAttrs: !1,
  computed: {
    containerStyle: function() {
      return this.size ? {
        width: this.size,
        height: this.size,
        borderRadius: this.borderRadius
      } : {
        width: this.width,
        height: this.height,
        borderRadius: this.borderRadius
      };
    }
  }
};
function Oh(e, t, n, r, s, o) {
  return R(), Y("div", me({
    class: e.cx("root"),
    style: [e.sx("root"), o.containerStyle],
    "aria-hidden": "true"
  }, e.ptmi("root")), null, 16);
}
jr.render = Oh;
const kh = {
  key: 1,
  class: "text-red-500"
}, Eh = {
  key: 2,
  class: "loading"
}, Bh = /* @__PURE__ */ ne({
  __name: "SupplierAgreementValueStats",
  setup(e) {
    const { getSupplierAgreementStatsAsync: t } = Pi(), n = $e(!0), r = $e(null), s = $e([]), o = T(() => {
      const u = getComputedStyle(document.body);
      return {
        labels: s.value.map((c) => c.entityLabel),
        datasets: [{
          data: s.value.map((c) => c.totalContractValue),
          backgroundColor: [
            u.getPropertyValue("--p-cyan-500"),
            u.getPropertyValue("--p-orange-500"),
            u.getPropertyValue("--p-gray-500")
          ],
          hoverBackgroundColor: [
            u.getPropertyValue("--p-cyan-400"),
            u.getPropertyValue("--p-orange-400"),
            u.getPropertyValue("--p-gray-400")
          ]
        }]
      };
    }), i = T(() => ({
      plugins: {
        legend: {
          display: !1
        }
      },
      parsing: {
        key: "totalContractValue"
      }
    })), a = async () => {
      try {
        n.value = !0;
        const u = await t("931063340");
        console.log(u), s.value = u.data;
      } finally {
        n.value = !1;
      }
    };
    return xn(() => {
      a();
    }), (u, c) => (R(), z(Me(Ar), { class: "frontPageCard" }, {
      header: oe(() => c[0] || (c[0] = [
        U("i", {
          class: "pi money-bill",
          style: { "font-size": "1rem" }
        }, null, -1)
      ])),
      title: oe(() => c[1] || (c[1] = [
        dr("Kontraktsverdi pr leverandør")
      ])),
      content: oe(() => [
        !n.value && !r.value ? (R(), z(Me(Rr), {
          key: 0,
          type: "pie",
          data: o.value,
          options: i.value
        }, null, 8, ["data", "options"])) : r.value ? (R(), Y("div", kh, Le(r.value), 1)) : (R(), Y("div", Eh, [
          be(Me(jr), {
            shape: "circle",
            size: "20rem"
          })
        ]))
      ]),
      _: 1
    }));
  }
}), Ih = {
  key: 1,
  class: "text-red-500"
}, Ph = {
  key: 2,
  class: "loading"
}, Vh = /* @__PURE__ */ ne({
  __name: "PropertyAgreementValueStats",
  setup(e) {
    const { getAgreementStatsAsync: t } = Pi(), n = $e(!0), r = $e(null), s = $e([]), o = T(() => {
      const u = getComputedStyle(document.body);
      return {
        labels: s.value.map((c) => c.entityLabel),
        datasets: [{
          data: s.value.map((c) => c.totalContractValue),
          backgroundColor: [
            u.getPropertyValue("--p-cyan-500"),
            u.getPropertyValue("--p-orange-500"),
            u.getPropertyValue("--p-gray-500")
          ],
          hoverBackgroundColor: [
            u.getPropertyValue("--p-cyan-400"),
            u.getPropertyValue("--p-orange-400"),
            u.getPropertyValue("--p-gray-400")
          ]
        }]
      };
    }), i = T(() => ({
      plugins: {
        legend: {
          display: !1
        }
      },
      parsing: {
        key: "totalContractValue"
      }
    })), a = async () => {
      try {
        n.value = !0;
        const u = await t("931063340");
        console.log(u), s.value = u.data;
      } finally {
        n.value = !1;
      }
    };
    return xn(() => {
      a();
    }), (u, c) => (R(), z(Me(Ar), { class: "frontPageCard" }, {
      header: oe(() => c[0] || (c[0] = [
        U("i", {
          class: "pi money-bill",
          style: { "font-size": "1rem" }
        }, null, -1)
      ])),
      title: oe(() => c[1] || (c[1] = [
        dr("Kontraktsverdi pr eiendom")
      ])),
      content: oe(() => [
        !n.value && !r.value ? (R(), z(Me(Rr), {
          key: 0,
          type: "pie",
          data: o.value,
          options: i.value
        }, null, 8, ["data", "options"])) : r.value ? (R(), Y("div", Ih, Le(r.value), 1)) : (R(), Y("div", Ph, [
          be(Me(jr), {
            shape: "circle",
            size: "20rem"
          })
        ]))
      ]),
      _: 1
    }));
  }
});
export {
  Lh as B,
  Uh as C,
  Fh as E,
  Nh as I,
  we as L,
  Mh as S,
  Bh as _,
  pr as a,
  qh as b,
  Vh as c,
  Yu as r,
  Wu as t
};
